(function () {

// packages/alpinejs/src/scheduler.js
var $f111f945f972b324$var$flushPending = false;
var $f111f945f972b324$var$flushing = false;
var $f111f945f972b324$var$queue = [];
var $f111f945f972b324$var$lastFlushedIndex = -1;
function $f111f945f972b324$var$scheduler(callback) {
    $f111f945f972b324$var$queueJob(callback);
}
function $f111f945f972b324$var$queueJob(job) {
    if (!$f111f945f972b324$var$queue.includes(job)) $f111f945f972b324$var$queue.push(job);
    $f111f945f972b324$var$queueFlush();
}
function $f111f945f972b324$var$dequeueJob(job) {
    let index = $f111f945f972b324$var$queue.indexOf(job);
    if (index !== -1 && index > $f111f945f972b324$var$lastFlushedIndex) $f111f945f972b324$var$queue.splice(index, 1);
}
function $f111f945f972b324$var$queueFlush() {
    if (!$f111f945f972b324$var$flushing && !$f111f945f972b324$var$flushPending) {
        $f111f945f972b324$var$flushPending = true;
        queueMicrotask($f111f945f972b324$var$flushJobs);
    }
}
function $f111f945f972b324$var$flushJobs() {
    $f111f945f972b324$var$flushPending = false;
    $f111f945f972b324$var$flushing = true;
    for(let i = 0; i < $f111f945f972b324$var$queue.length; i++){
        $f111f945f972b324$var$queue[i]();
        $f111f945f972b324$var$lastFlushedIndex = i;
    }
    $f111f945f972b324$var$queue.length = 0;
    $f111f945f972b324$var$lastFlushedIndex = -1;
    $f111f945f972b324$var$flushing = false;
}
// packages/alpinejs/src/reactivity.js
var $f111f945f972b324$var$reactive;
var $f111f945f972b324$var$effect;
var $f111f945f972b324$var$release;
var $f111f945f972b324$var$raw;
var $f111f945f972b324$var$shouldSchedule = true;
function $f111f945f972b324$var$disableEffectScheduling(callback) {
    $f111f945f972b324$var$shouldSchedule = false;
    callback();
    $f111f945f972b324$var$shouldSchedule = true;
}
function $f111f945f972b324$var$setReactivityEngine(engine) {
    $f111f945f972b324$var$reactive = engine.reactive;
    $f111f945f972b324$var$release = engine.release;
    $f111f945f972b324$var$effect = (callback)=>engine.effect(callback, {
            scheduler: (task)=>{
                if ($f111f945f972b324$var$shouldSchedule) $f111f945f972b324$var$scheduler(task);
                else task();
            }
        });
    $f111f945f972b324$var$raw = engine.raw;
}
function $f111f945f972b324$var$overrideEffect(override) {
    $f111f945f972b324$var$effect = override;
}
function $f111f945f972b324$var$elementBoundEffect(el) {
    let cleanup2 = ()=>{};
    let wrappedEffect = (callback)=>{
        let effectReference = $f111f945f972b324$var$effect(callback);
        if (!el._x_effects) {
            el._x_effects = /* @__PURE__ */ new Set();
            el._x_runEffects = ()=>{
                el._x_effects.forEach((i)=>i());
            };
        }
        el._x_effects.add(effectReference);
        cleanup2 = ()=>{
            if (effectReference === void 0) return;
            el._x_effects.delete(effectReference);
            $f111f945f972b324$var$release(effectReference);
        };
        return effectReference;
    };
    return [
        wrappedEffect,
        ()=>{
            cleanup2();
        }
    ];
}
// packages/alpinejs/src/utils/dispatch.js
function $f111f945f972b324$var$dispatch(el, name, detail = {}) {
    el.dispatchEvent(new CustomEvent(name, {
        detail: detail,
        bubbles: true,
        // Allows events to pass the shadow DOM barrier.
        composed: true,
        cancelable: true
    }));
}
// packages/alpinejs/src/utils/walk.js
function $f111f945f972b324$var$walk(el, callback) {
    if (typeof ShadowRoot === "function" && el instanceof ShadowRoot) {
        Array.from(el.children).forEach((el2)=>$f111f945f972b324$var$walk(el2, callback));
        return;
    }
    let skip = false;
    callback(el, ()=>skip = true);
    if (skip) return;
    let node = el.firstElementChild;
    while(node){
        $f111f945f972b324$var$walk(node, callback, false);
        node = node.nextElementSibling;
    }
}
// packages/alpinejs/src/utils/warn.js
function $f111f945f972b324$var$warn(message, ...args) {
    console.warn(`Alpine Warning: ${message}`, ...args);
}
// packages/alpinejs/src/lifecycle.js
var $f111f945f972b324$var$started = false;
function $f111f945f972b324$var$start() {
    if ($f111f945f972b324$var$started) $f111f945f972b324$var$warn("Alpine has already been initialized on this page. Calling Alpine.start() more than once can cause problems.");
    $f111f945f972b324$var$started = true;
    if (!document.body) $f111f945f972b324$var$warn("Unable to initialize. Trying to load Alpine before `<body>` is available. Did you forget to add `defer` in Alpine's `<script>` tag?");
    $f111f945f972b324$var$dispatch(document, "alpine:init");
    $f111f945f972b324$var$dispatch(document, "alpine:initializing");
    $f111f945f972b324$var$startObservingMutations();
    $f111f945f972b324$var$onElAdded((el)=>$f111f945f972b324$var$initTree(el, $f111f945f972b324$var$walk));
    $f111f945f972b324$var$onElRemoved((el)=>$f111f945f972b324$var$destroyTree(el));
    $f111f945f972b324$var$onAttributesAdded((el, attrs)=>{
        $f111f945f972b324$var$directives(el, attrs).forEach((handle)=>handle());
    });
    let outNestedComponents = (el)=>!$f111f945f972b324$var$closestRoot(el.parentElement, true);
    Array.from(document.querySelectorAll($f111f945f972b324$var$allSelectors().join(","))).filter(outNestedComponents).forEach((el)=>{
        $f111f945f972b324$var$initTree(el);
    });
    $f111f945f972b324$var$dispatch(document, "alpine:initialized");
}
var $f111f945f972b324$var$rootSelectorCallbacks = [];
var $f111f945f972b324$var$initSelectorCallbacks = [];
function $f111f945f972b324$var$rootSelectors() {
    return $f111f945f972b324$var$rootSelectorCallbacks.map((fn)=>fn());
}
function $f111f945f972b324$var$allSelectors() {
    return $f111f945f972b324$var$rootSelectorCallbacks.concat($f111f945f972b324$var$initSelectorCallbacks).map((fn)=>fn());
}
function $f111f945f972b324$var$addRootSelector(selectorCallback) {
    $f111f945f972b324$var$rootSelectorCallbacks.push(selectorCallback);
}
function $f111f945f972b324$var$addInitSelector(selectorCallback) {
    $f111f945f972b324$var$initSelectorCallbacks.push(selectorCallback);
}
function $f111f945f972b324$var$closestRoot(el, includeInitSelectors = false) {
    return $f111f945f972b324$var$findClosest(el, (element)=>{
        const selectors = includeInitSelectors ? $f111f945f972b324$var$allSelectors() : $f111f945f972b324$var$rootSelectors();
        if (selectors.some((selector)=>element.matches(selector))) return true;
    });
}
function $f111f945f972b324$var$findClosest(el, callback) {
    if (!el) return;
    if (callback(el)) return el;
    if (el._x_teleportBack) el = el._x_teleportBack;
    if (!el.parentElement) return;
    return $f111f945f972b324$var$findClosest(el.parentElement, callback);
}
function $f111f945f972b324$var$isRoot(el) {
    return $f111f945f972b324$var$rootSelectors().some((selector)=>el.matches(selector));
}
var $f111f945f972b324$var$initInterceptors = [];
function $f111f945f972b324$var$interceptInit(callback) {
    $f111f945f972b324$var$initInterceptors.push(callback);
}
function $f111f945f972b324$var$initTree(el, walker = $f111f945f972b324$var$walk, intercept = ()=>{}) {
    $f111f945f972b324$var$deferHandlingDirectives(()=>{
        walker(el, (el2, skip)=>{
            intercept(el2, skip);
            $f111f945f972b324$var$initInterceptors.forEach((i)=>i(el2, skip));
            $f111f945f972b324$var$directives(el2, el2.attributes).forEach((handle)=>handle());
            el2._x_ignore && skip();
        });
    });
}
function $f111f945f972b324$var$destroyTree(root) {
    $f111f945f972b324$var$walk(root, (el)=>{
        $f111f945f972b324$var$cleanupAttributes(el);
        $f111f945f972b324$var$cleanupElement(el);
    });
}
// packages/alpinejs/src/mutation.js
var $f111f945f972b324$var$onAttributeAddeds = [];
var $f111f945f972b324$var$onElRemoveds = [];
var $f111f945f972b324$var$onElAddeds = [];
function $f111f945f972b324$var$onElAdded(callback) {
    $f111f945f972b324$var$onElAddeds.push(callback);
}
function $f111f945f972b324$var$onElRemoved(el, callback) {
    if (typeof callback === "function") {
        if (!el._x_cleanups) el._x_cleanups = [];
        el._x_cleanups.push(callback);
    } else {
        callback = el;
        $f111f945f972b324$var$onElRemoveds.push(callback);
    }
}
function $f111f945f972b324$var$onAttributesAdded(callback) {
    $f111f945f972b324$var$onAttributeAddeds.push(callback);
}
function $f111f945f972b324$var$onAttributeRemoved(el, name, callback) {
    if (!el._x_attributeCleanups) el._x_attributeCleanups = {};
    if (!el._x_attributeCleanups[name]) el._x_attributeCleanups[name] = [];
    el._x_attributeCleanups[name].push(callback);
}
function $f111f945f972b324$var$cleanupAttributes(el, names) {
    if (!el._x_attributeCleanups) return;
    Object.entries(el._x_attributeCleanups).forEach(([name, value])=>{
        if (names === void 0 || names.includes(name)) {
            value.forEach((i)=>i());
            delete el._x_attributeCleanups[name];
        }
    });
}
function $f111f945f972b324$var$cleanupElement(el) {
    if (el._x_cleanups) while(el._x_cleanups.length)el._x_cleanups.pop()();
}
var $f111f945f972b324$var$observer = new MutationObserver($f111f945f972b324$var$onMutate);
var $f111f945f972b324$var$currentlyObserving = false;
function $f111f945f972b324$var$startObservingMutations() {
    $f111f945f972b324$var$observer.observe(document, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeOldValue: true
    });
    $f111f945f972b324$var$currentlyObserving = true;
}
function $f111f945f972b324$var$stopObservingMutations() {
    $f111f945f972b324$var$flushObserver();
    $f111f945f972b324$var$observer.disconnect();
    $f111f945f972b324$var$currentlyObserving = false;
}
var $f111f945f972b324$var$recordQueue = [];
var $f111f945f972b324$var$willProcessRecordQueue = false;
function $f111f945f972b324$var$flushObserver() {
    $f111f945f972b324$var$recordQueue = $f111f945f972b324$var$recordQueue.concat($f111f945f972b324$var$observer.takeRecords());
    if ($f111f945f972b324$var$recordQueue.length && !$f111f945f972b324$var$willProcessRecordQueue) {
        $f111f945f972b324$var$willProcessRecordQueue = true;
        queueMicrotask(()=>{
            $f111f945f972b324$var$processRecordQueue();
            $f111f945f972b324$var$willProcessRecordQueue = false;
        });
    }
}
function $f111f945f972b324$var$processRecordQueue() {
    $f111f945f972b324$var$onMutate($f111f945f972b324$var$recordQueue);
    $f111f945f972b324$var$recordQueue.length = 0;
}
function $f111f945f972b324$var$mutateDom(callback) {
    if (!$f111f945f972b324$var$currentlyObserving) return callback();
    $f111f945f972b324$var$stopObservingMutations();
    let result = callback();
    $f111f945f972b324$var$startObservingMutations();
    return result;
}
var $f111f945f972b324$var$isCollecting = false;
var $f111f945f972b324$var$deferredMutations = [];
function $f111f945f972b324$var$deferMutations() {
    $f111f945f972b324$var$isCollecting = true;
}
function $f111f945f972b324$var$flushAndStopDeferringMutations() {
    $f111f945f972b324$var$isCollecting = false;
    $f111f945f972b324$var$onMutate($f111f945f972b324$var$deferredMutations);
    $f111f945f972b324$var$deferredMutations = [];
}
function $f111f945f972b324$var$onMutate(mutations) {
    if ($f111f945f972b324$var$isCollecting) {
        $f111f945f972b324$var$deferredMutations = $f111f945f972b324$var$deferredMutations.concat(mutations);
        return;
    }
    let addedNodes = [];
    let removedNodes = [];
    let addedAttributes = /* @__PURE__ */ new Map();
    let removedAttributes = /* @__PURE__ */ new Map();
    for(let i = 0; i < mutations.length; i++){
        if (mutations[i].target._x_ignoreMutationObserver) continue;
        if (mutations[i].type === "childList") {
            mutations[i].addedNodes.forEach((node)=>node.nodeType === 1 && addedNodes.push(node));
            mutations[i].removedNodes.forEach((node)=>node.nodeType === 1 && removedNodes.push(node));
        }
        if (mutations[i].type === "attributes") {
            let el = mutations[i].target;
            let name = mutations[i].attributeName;
            let oldValue = mutations[i].oldValue;
            let add2 = ()=>{
                if (!addedAttributes.has(el)) addedAttributes.set(el, []);
                addedAttributes.get(el).push({
                    name: name,
                    value: el.getAttribute(name)
                });
            };
            let remove = ()=>{
                if (!removedAttributes.has(el)) removedAttributes.set(el, []);
                removedAttributes.get(el).push(name);
            };
            if (el.hasAttribute(name) && oldValue === null) add2();
            else if (el.hasAttribute(name)) {
                remove();
                add2();
            } else remove();
        }
    }
    removedAttributes.forEach((attrs, el)=>{
        $f111f945f972b324$var$cleanupAttributes(el, attrs);
    });
    addedAttributes.forEach((attrs, el)=>{
        $f111f945f972b324$var$onAttributeAddeds.forEach((i)=>i(el, attrs));
    });
    for (let node of removedNodes){
        if (addedNodes.includes(node)) continue;
        $f111f945f972b324$var$onElRemoveds.forEach((i)=>i(node));
        $f111f945f972b324$var$destroyTree(node);
    }
    addedNodes.forEach((node)=>{
        node._x_ignoreSelf = true;
        node._x_ignore = true;
    });
    for (let node of addedNodes){
        if (removedNodes.includes(node)) continue;
        if (!node.isConnected) continue;
        delete node._x_ignoreSelf;
        delete node._x_ignore;
        $f111f945f972b324$var$onElAddeds.forEach((i)=>i(node));
        node._x_ignore = true;
        node._x_ignoreSelf = true;
    }
    addedNodes.forEach((node)=>{
        delete node._x_ignoreSelf;
        delete node._x_ignore;
    });
    addedNodes = null;
    removedNodes = null;
    addedAttributes = null;
    removedAttributes = null;
}
// packages/alpinejs/src/scope.js
function $f111f945f972b324$var$scope(node) {
    return $f111f945f972b324$var$mergeProxies($f111f945f972b324$var$closestDataStack(node));
}
function $f111f945f972b324$var$addScopeToNode(node, data2, referenceNode) {
    node._x_dataStack = [
        data2,
        ...$f111f945f972b324$var$closestDataStack(referenceNode || node)
    ];
    return ()=>{
        node._x_dataStack = node._x_dataStack.filter((i)=>i !== data2);
    };
}
function $f111f945f972b324$var$closestDataStack(node) {
    if (node._x_dataStack) return node._x_dataStack;
    if (typeof ShadowRoot === "function" && node instanceof ShadowRoot) return $f111f945f972b324$var$closestDataStack(node.host);
    if (!node.parentNode) return [];
    return $f111f945f972b324$var$closestDataStack(node.parentNode);
}
function $f111f945f972b324$var$mergeProxies(objects) {
    return new Proxy({
        objects: objects
    }, $f111f945f972b324$var$mergeProxyTrap);
}
var $f111f945f972b324$var$mergeProxyTrap = {
    ownKeys ({ objects: objects }) {
        return Array.from(new Set(objects.flatMap((i)=>Object.keys(i))));
    },
    has ({ objects: objects }, name) {
        if (name == Symbol.unscopables) return false;
        return objects.some((obj)=>Object.prototype.hasOwnProperty.call(obj, name));
    },
    get ({ objects: objects }, name, thisProxy) {
        if (name == "toJSON") return $f111f945f972b324$var$collapseProxies;
        return Reflect.get(objects.find((obj)=>Object.prototype.hasOwnProperty.call(obj, name)) || {}, name, thisProxy);
    },
    set ({ objects: objects }, name, value, thisProxy) {
        const target = objects.find((obj)=>Object.prototype.hasOwnProperty.call(obj, name)) || objects[objects.length - 1];
        const descriptor = Object.getOwnPropertyDescriptor(target, name);
        if (descriptor?.set && descriptor?.get) return Reflect.set(target, name, value, thisProxy);
        return Reflect.set(target, name, value);
    }
};
function $f111f945f972b324$var$collapseProxies() {
    let keys = Reflect.ownKeys(this);
    return keys.reduce((acc, key)=>{
        acc[key] = Reflect.get(this, key);
        return acc;
    }, {});
}
// packages/alpinejs/src/interceptor.js
function $f111f945f972b324$var$initInterceptors2(data2) {
    let isObject2 = (val)=>typeof val === "object" && !Array.isArray(val) && val !== null;
    let recurse = (obj, basePath = "")=>{
        Object.entries(Object.getOwnPropertyDescriptors(obj)).forEach(([key, { value: value, enumerable: enumerable }])=>{
            if (enumerable === false || value === void 0) return;
            let path = basePath === "" ? key : `${basePath}.${key}`;
            if (typeof value === "object" && value !== null && value._x_interceptor) obj[key] = value.initialize(data2, path, key);
            else if (isObject2(value) && value !== obj && !(value instanceof Element)) recurse(value, path);
        });
    };
    return recurse(data2);
}
function $f111f945f972b324$var$interceptor(callback, mutateObj = ()=>{}) {
    let obj = {
        initialValue: void 0,
        _x_interceptor: true,
        initialize (data2, path, key) {
            return callback(this.initialValue, ()=>$f111f945f972b324$var$get(data2, path), (value)=>$f111f945f972b324$var$set(data2, path, value), path, key);
        }
    };
    mutateObj(obj);
    return (initialValue)=>{
        if (typeof initialValue === "object" && initialValue !== null && initialValue._x_interceptor) {
            let initialize = obj.initialize.bind(obj);
            obj.initialize = (data2, path, key)=>{
                let innerValue = initialValue.initialize(data2, path, key);
                obj.initialValue = innerValue;
                return initialize(data2, path, key);
            };
        } else obj.initialValue = initialValue;
        return obj;
    };
}
function $f111f945f972b324$var$get(obj, path) {
    return path.split(".").reduce((carry, segment)=>carry[segment], obj);
}
function $f111f945f972b324$var$set(obj, path, value) {
    if (typeof path === "string") path = path.split(".");
    if (path.length === 1) obj[path[0]] = value;
    else if (path.length === 0) throw error;
    else {
        if (obj[path[0]]) return $f111f945f972b324$var$set(obj[path[0]], path.slice(1), value);
        else {
            obj[path[0]] = {};
            return $f111f945f972b324$var$set(obj[path[0]], path.slice(1), value);
        }
    }
}
// packages/alpinejs/src/magics.js
var $f111f945f972b324$var$magics = {};
function $f111f945f972b324$var$magic(name, callback) {
    $f111f945f972b324$var$magics[name] = callback;
}
function $f111f945f972b324$var$injectMagics(obj, el) {
    Object.entries($f111f945f972b324$var$magics).forEach(([name, callback])=>{
        let memoizedUtilities = null;
        function getUtilities() {
            if (memoizedUtilities) return memoizedUtilities;
            else {
                let [utilities, cleanup2] = $f111f945f972b324$var$getElementBoundUtilities(el);
                memoizedUtilities = {
                    interceptor: $f111f945f972b324$var$interceptor,
                    ...utilities
                };
                $f111f945f972b324$var$onElRemoved(el, cleanup2);
                return memoizedUtilities;
            }
        }
        Object.defineProperty(obj, `$${name}`, {
            get () {
                return callback(el, getUtilities());
            },
            enumerable: false
        });
    });
    return obj;
}
// packages/alpinejs/src/utils/error.js
function $f111f945f972b324$var$tryCatch(el, expression, callback, ...args) {
    try {
        return callback(...args);
    } catch (e) {
        $f111f945f972b324$var$handleError(e, el, expression);
    }
}
function $f111f945f972b324$var$handleError(error2, el, expression) {
    Object.assign(error2, {
        el: el,
        expression: expression
    });
    console.warn(`Alpine Expression Error: ${error2.message}

${expression ? 'Expression: "' + expression + '"\n\n' : ""}`, el);
    setTimeout(()=>{
        throw error2;
    }, 0);
}
// packages/alpinejs/src/evaluator.js
var $f111f945f972b324$var$shouldAutoEvaluateFunctions = true;
function $f111f945f972b324$var$dontAutoEvaluateFunctions(callback) {
    let cache = $f111f945f972b324$var$shouldAutoEvaluateFunctions;
    $f111f945f972b324$var$shouldAutoEvaluateFunctions = false;
    let result = callback();
    $f111f945f972b324$var$shouldAutoEvaluateFunctions = cache;
    return result;
}
function $f111f945f972b324$var$evaluate(el, expression, extras = {}) {
    let result;
    $f111f945f972b324$var$evaluateLater(el, expression)((value)=>result = value, extras);
    return result;
}
function $f111f945f972b324$var$evaluateLater(...args) {
    return $f111f945f972b324$var$theEvaluatorFunction(...args);
}
var $f111f945f972b324$var$theEvaluatorFunction = $f111f945f972b324$var$normalEvaluator;
function $f111f945f972b324$var$setEvaluator(newEvaluator) {
    $f111f945f972b324$var$theEvaluatorFunction = newEvaluator;
}
function $f111f945f972b324$var$normalEvaluator(el, expression) {
    let overriddenMagics = {};
    $f111f945f972b324$var$injectMagics(overriddenMagics, el);
    let dataStack = [
        overriddenMagics,
        ...$f111f945f972b324$var$closestDataStack(el)
    ];
    let evaluator = typeof expression === "function" ? $f111f945f972b324$var$generateEvaluatorFromFunction(dataStack, expression) : $f111f945f972b324$var$generateEvaluatorFromString(dataStack, expression, el);
    return $f111f945f972b324$var$tryCatch.bind(null, el, expression, evaluator);
}
function $f111f945f972b324$var$generateEvaluatorFromFunction(dataStack, func) {
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [] } = {})=>{
        let result = func.apply($f111f945f972b324$var$mergeProxies([
            scope2,
            ...dataStack
        ]), params);
        $f111f945f972b324$var$runIfTypeOfFunction(receiver, result);
    };
}
var $f111f945f972b324$var$evaluatorMemo = {};
function $f111f945f972b324$var$generateFunctionFromString(expression, el) {
    if ($f111f945f972b324$var$evaluatorMemo[expression]) return $f111f945f972b324$var$evaluatorMemo[expression];
    let AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
    let rightSideSafeExpression = /^[\n\s]*if.*\(.*\)/.test(expression.trim()) || /^(let|const)\s/.test(expression.trim()) ? `(async()=>{ ${expression} })()` : expression;
    const safeAsyncFunction = ()=>{
        try {
            let func2 = new AsyncFunction([
                "__self",
                "scope"
            ], `with (scope) { __self.result = ${rightSideSafeExpression} }; __self.finished = true; return __self.result;`);
            Object.defineProperty(func2, "name", {
                value: `[Alpine] ${expression}`
            });
            return func2;
        } catch (error2) {
            $f111f945f972b324$var$handleError(error2, el, expression);
            return Promise.resolve();
        }
    };
    let func = safeAsyncFunction();
    $f111f945f972b324$var$evaluatorMemo[expression] = func;
    return func;
}
function $f111f945f972b324$var$generateEvaluatorFromString(dataStack, expression, el) {
    let func = $f111f945f972b324$var$generateFunctionFromString(expression, el);
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [] } = {})=>{
        func.result = void 0;
        func.finished = false;
        let completeScope = $f111f945f972b324$var$mergeProxies([
            scope2,
            ...dataStack
        ]);
        if (typeof func === "function") {
            let promise = func(func, completeScope).catch((error2)=>$f111f945f972b324$var$handleError(error2, el, expression));
            if (func.finished) {
                $f111f945f972b324$var$runIfTypeOfFunction(receiver, func.result, completeScope, params, el);
                func.result = void 0;
            } else promise.then((result)=>{
                $f111f945f972b324$var$runIfTypeOfFunction(receiver, result, completeScope, params, el);
            }).catch((error2)=>$f111f945f972b324$var$handleError(error2, el, expression)).finally(()=>func.result = void 0);
        }
    };
}
function $f111f945f972b324$var$runIfTypeOfFunction(receiver, value, scope2, params, el) {
    if ($f111f945f972b324$var$shouldAutoEvaluateFunctions && typeof value === "function") {
        let result = value.apply(scope2, params);
        if (result instanceof Promise) result.then((i)=>$f111f945f972b324$var$runIfTypeOfFunction(receiver, i, scope2, params)).catch((error2)=>$f111f945f972b324$var$handleError(error2, el, value));
        else receiver(result);
    } else if (typeof value === "object" && value instanceof Promise) value.then((i)=>receiver(i));
    else receiver(value);
}
// packages/alpinejs/src/directives.js
var $f111f945f972b324$var$prefixAsString = "x-";
function $f111f945f972b324$var$prefix(subject = "") {
    return $f111f945f972b324$var$prefixAsString + subject;
}
function $f111f945f972b324$var$setPrefix(newPrefix) {
    $f111f945f972b324$var$prefixAsString = newPrefix;
}
var $f111f945f972b324$var$directiveHandlers = {};
function $f111f945f972b324$var$directive(name, callback) {
    $f111f945f972b324$var$directiveHandlers[name] = callback;
    return {
        before (directive2) {
            if (!$f111f945f972b324$var$directiveHandlers[directive2]) {
                console.warn("Cannot find directive `${directive}`. `${name}` will use the default order of execution");
                return;
            }
            const pos = $f111f945f972b324$var$directiveOrder.indexOf(directive2);
            $f111f945f972b324$var$directiveOrder.splice(pos >= 0 ? pos : $f111f945f972b324$var$directiveOrder.indexOf("DEFAULT"), 0, name);
        }
    };
}
function $f111f945f972b324$var$directives(el, attributes, originalAttributeOverride) {
    attributes = Array.from(attributes);
    if (el._x_virtualDirectives) {
        let vAttributes = Object.entries(el._x_virtualDirectives).map(([name, value])=>({
                name: name,
                value: value
            }));
        let staticAttributes = $f111f945f972b324$var$attributesOnly(vAttributes);
        vAttributes = vAttributes.map((attribute)=>{
            if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
                name: `x-bind:${attribute.name}`,
                value: `"${attribute.value}"`
            };
            return attribute;
        });
        attributes = attributes.concat(vAttributes);
    }
    let transformedAttributeMap = {};
    let directives2 = attributes.map($f111f945f972b324$var$toTransformedAttributes((newName, oldName)=>transformedAttributeMap[newName] = oldName)).filter($f111f945f972b324$var$outNonAlpineAttributes).map($f111f945f972b324$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride)).sort($f111f945f972b324$var$byPriority);
    return directives2.map((directive2)=>{
        return $f111f945f972b324$var$getDirectiveHandler(el, directive2);
    });
}
function $f111f945f972b324$var$attributesOnly(attributes) {
    return Array.from(attributes).map($f111f945f972b324$var$toTransformedAttributes()).filter((attr)=>!$f111f945f972b324$var$outNonAlpineAttributes(attr));
}
var $f111f945f972b324$var$isDeferringHandlers = false;
var $f111f945f972b324$var$directiveHandlerStacks = /* @__PURE__ */ new Map();
var $f111f945f972b324$var$currentHandlerStackKey = Symbol();
function $f111f945f972b324$var$deferHandlingDirectives(callback) {
    $f111f945f972b324$var$isDeferringHandlers = true;
    let key = Symbol();
    $f111f945f972b324$var$currentHandlerStackKey = key;
    $f111f945f972b324$var$directiveHandlerStacks.set(key, []);
    let flushHandlers = ()=>{
        while($f111f945f972b324$var$directiveHandlerStacks.get(key).length)$f111f945f972b324$var$directiveHandlerStacks.get(key).shift()();
        $f111f945f972b324$var$directiveHandlerStacks.delete(key);
    };
    let stopDeferring = ()=>{
        $f111f945f972b324$var$isDeferringHandlers = false;
        flushHandlers();
    };
    callback(flushHandlers);
    stopDeferring();
}
function $f111f945f972b324$var$getElementBoundUtilities(el) {
    let cleanups = [];
    let cleanup2 = (callback)=>cleanups.push(callback);
    let [effect3, cleanupEffect] = $f111f945f972b324$var$elementBoundEffect(el);
    cleanups.push(cleanupEffect);
    let utilities = {
        Alpine: $f111f945f972b324$var$alpine_default,
        effect: effect3,
        cleanup: cleanup2,
        evaluateLater: $f111f945f972b324$var$evaluateLater.bind($f111f945f972b324$var$evaluateLater, el),
        evaluate: $f111f945f972b324$var$evaluate.bind($f111f945f972b324$var$evaluate, el)
    };
    let doCleanup = ()=>cleanups.forEach((i)=>i());
    return [
        utilities,
        doCleanup
    ];
}
function $f111f945f972b324$var$getDirectiveHandler(el, directive2) {
    let noop = ()=>{};
    let handler4 = $f111f945f972b324$var$directiveHandlers[directive2.type] || noop;
    let [utilities, cleanup2] = $f111f945f972b324$var$getElementBoundUtilities(el);
    $f111f945f972b324$var$onAttributeRemoved(el, directive2.original, cleanup2);
    let fullHandler = ()=>{
        if (el._x_ignore || el._x_ignoreSelf) return;
        handler4.inline && handler4.inline(el, directive2, utilities);
        handler4 = handler4.bind(handler4, el, directive2, utilities);
        $f111f945f972b324$var$isDeferringHandlers ? $f111f945f972b324$var$directiveHandlerStacks.get($f111f945f972b324$var$currentHandlerStackKey).push(handler4) : handler4();
    };
    fullHandler.runCleanups = cleanup2;
    return fullHandler;
}
var $f111f945f972b324$var$startingWith = (subject, replacement)=>({ name: name, value: value })=>{
        if (name.startsWith(subject)) name = name.replace(subject, replacement);
        return {
            name: name,
            value: value
        };
    };
var $f111f945f972b324$var$into = (i)=>i;
function $f111f945f972b324$var$toTransformedAttributes(callback = ()=>{}) {
    return ({ name: name, value: value })=>{
        let { name: newName, value: newValue } = $f111f945f972b324$var$attributeTransformers.reduce((carry, transform)=>{
            return transform(carry);
        }, {
            name: name,
            value: value
        });
        if (newName !== name) callback(newName, name);
        return {
            name: newName,
            value: newValue
        };
    };
}
var $f111f945f972b324$var$attributeTransformers = [];
function $f111f945f972b324$var$mapAttributes(callback) {
    $f111f945f972b324$var$attributeTransformers.push(callback);
}
function $f111f945f972b324$var$outNonAlpineAttributes({ name: name }) {
    return $f111f945f972b324$var$alpineAttributeRegex().test(name);
}
var $f111f945f972b324$var$alpineAttributeRegex = ()=>new RegExp(`^${$f111f945f972b324$var$prefixAsString}([^:^.]+)\\b`);
function $f111f945f972b324$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride) {
    return ({ name: name, value: value })=>{
        let typeMatch = name.match($f111f945f972b324$var$alpineAttributeRegex());
        let valueMatch = name.match(/:([a-zA-Z0-9\-_:]+)/);
        let modifiers = name.match(/\.[^.\]]+(?=[^\]]*$)/g) || [];
        let original = originalAttributeOverride || transformedAttributeMap[name] || name;
        return {
            type: typeMatch ? typeMatch[1] : null,
            value: valueMatch ? valueMatch[1] : null,
            modifiers: modifiers.map((i)=>i.replace(".", "")),
            expression: value,
            original: original
        };
    };
}
var $f111f945f972b324$var$DEFAULT = "DEFAULT";
var $f111f945f972b324$var$directiveOrder = [
    "ignore",
    "ref",
    "data",
    "id",
    "anchor",
    "bind",
    "init",
    "for",
    "model",
    "modelable",
    "transition",
    "show",
    "if",
    $f111f945f972b324$var$DEFAULT,
    "teleport"
];
function $f111f945f972b324$var$byPriority(a, b) {
    let typeA = $f111f945f972b324$var$directiveOrder.indexOf(a.type) === -1 ? $f111f945f972b324$var$DEFAULT : a.type;
    let typeB = $f111f945f972b324$var$directiveOrder.indexOf(b.type) === -1 ? $f111f945f972b324$var$DEFAULT : b.type;
    return $f111f945f972b324$var$directiveOrder.indexOf(typeA) - $f111f945f972b324$var$directiveOrder.indexOf(typeB);
}
// packages/alpinejs/src/nextTick.js
var $f111f945f972b324$var$tickStack = [];
var $f111f945f972b324$var$isHolding = false;
function $f111f945f972b324$var$nextTick(callback = ()=>{}) {
    queueMicrotask(()=>{
        $f111f945f972b324$var$isHolding || setTimeout(()=>{
            $f111f945f972b324$var$releaseNextTicks();
        });
    });
    return new Promise((res)=>{
        $f111f945f972b324$var$tickStack.push(()=>{
            callback();
            res();
        });
    });
}
function $f111f945f972b324$var$releaseNextTicks() {
    $f111f945f972b324$var$isHolding = false;
    while($f111f945f972b324$var$tickStack.length)$f111f945f972b324$var$tickStack.shift()();
}
function $f111f945f972b324$var$holdNextTicks() {
    $f111f945f972b324$var$isHolding = true;
}
// packages/alpinejs/src/utils/classes.js
function $f111f945f972b324$var$setClasses(el, value) {
    if (Array.isArray(value)) return $f111f945f972b324$var$setClassesFromString(el, value.join(" "));
    else if (typeof value === "object" && value !== null) return $f111f945f972b324$var$setClassesFromObject(el, value);
    else if (typeof value === "function") return $f111f945f972b324$var$setClasses(el, value());
    return $f111f945f972b324$var$setClassesFromString(el, value);
}
function $f111f945f972b324$var$setClassesFromString(el, classString) {
    let split = (classString2)=>classString2.split(" ").filter(Boolean);
    let missingClasses = (classString2)=>classString2.split(" ").filter((i)=>!el.classList.contains(i)).filter(Boolean);
    let addClassesAndReturnUndo = (classes)=>{
        el.classList.add(...classes);
        return ()=>{
            el.classList.remove(...classes);
        };
    };
    classString = classString === true ? classString = "" : classString || "";
    return addClassesAndReturnUndo(missingClasses(classString));
}
function $f111f945f972b324$var$setClassesFromObject(el, classObject) {
    let split = (classString)=>classString.split(" ").filter(Boolean);
    let forAdd = Object.entries(classObject).flatMap(([classString, bool])=>bool ? split(classString) : false).filter(Boolean);
    let forRemove = Object.entries(classObject).flatMap(([classString, bool])=>!bool ? split(classString) : false).filter(Boolean);
    let added = [];
    let removed = [];
    forRemove.forEach((i)=>{
        if (el.classList.contains(i)) {
            el.classList.remove(i);
            removed.push(i);
        }
    });
    forAdd.forEach((i)=>{
        if (!el.classList.contains(i)) {
            el.classList.add(i);
            added.push(i);
        }
    });
    return ()=>{
        removed.forEach((i)=>el.classList.add(i));
        added.forEach((i)=>el.classList.remove(i));
    };
}
// packages/alpinejs/src/utils/styles.js
function $f111f945f972b324$var$setStyles(el, value) {
    if (typeof value === "object" && value !== null) return $f111f945f972b324$var$setStylesFromObject(el, value);
    return $f111f945f972b324$var$setStylesFromString(el, value);
}
function $f111f945f972b324$var$setStylesFromObject(el, value) {
    let previousStyles = {};
    Object.entries(value).forEach(([key, value2])=>{
        previousStyles[key] = el.style[key];
        if (!key.startsWith("--")) key = $f111f945f972b324$var$kebabCase(key);
        el.style.setProperty(key, value2);
    });
    setTimeout(()=>{
        if (el.style.length === 0) el.removeAttribute("style");
    });
    return ()=>{
        $f111f945f972b324$var$setStyles(el, previousStyles);
    };
}
function $f111f945f972b324$var$setStylesFromString(el, value) {
    let cache = el.getAttribute("style", value);
    el.setAttribute("style", value);
    return ()=>{
        el.setAttribute("style", cache || "");
    };
}
function $f111f945f972b324$var$kebabCase(subject) {
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
// packages/alpinejs/src/utils/once.js
function $f111f945f972b324$var$once(callback, fallback = ()=>{}) {
    let called = false;
    return function() {
        if (!called) {
            called = true;
            callback.apply(this, arguments);
        } else fallback.apply(this, arguments);
    };
}
// packages/alpinejs/src/directives/x-transition.js
$f111f945f972b324$var$directive("transition", (el, { value: value, modifiers: modifiers, expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "function") expression = evaluate2(expression);
    if (expression === false) return;
    if (!expression || typeof expression === "boolean") $f111f945f972b324$var$registerTransitionsFromHelper(el, modifiers, value);
    else $f111f945f972b324$var$registerTransitionsFromClassString(el, expression, value);
});
function $f111f945f972b324$var$registerTransitionsFromClassString(el, classString, stage) {
    $f111f945f972b324$var$registerTransitionObject(el, $f111f945f972b324$var$setClasses, "");
    let directiveStorageMap = {
        "enter": (classes)=>{
            el._x_transition.enter.during = classes;
        },
        "enter-start": (classes)=>{
            el._x_transition.enter.start = classes;
        },
        "enter-end": (classes)=>{
            el._x_transition.enter.end = classes;
        },
        "leave": (classes)=>{
            el._x_transition.leave.during = classes;
        },
        "leave-start": (classes)=>{
            el._x_transition.leave.start = classes;
        },
        "leave-end": (classes)=>{
            el._x_transition.leave.end = classes;
        }
    };
    directiveStorageMap[stage](classString);
}
function $f111f945f972b324$var$registerTransitionsFromHelper(el, modifiers, stage) {
    $f111f945f972b324$var$registerTransitionObject(el, $f111f945f972b324$var$setStyles);
    let doesntSpecify = !modifiers.includes("in") && !modifiers.includes("out") && !stage;
    let transitioningIn = doesntSpecify || modifiers.includes("in") || [
        "enter"
    ].includes(stage);
    let transitioningOut = doesntSpecify || modifiers.includes("out") || [
        "leave"
    ].includes(stage);
    if (modifiers.includes("in") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index < modifiers.indexOf("out"));
    if (modifiers.includes("out") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index > modifiers.indexOf("out"));
    let wantsAll = !modifiers.includes("opacity") && !modifiers.includes("scale");
    let wantsOpacity = wantsAll || modifiers.includes("opacity");
    let wantsScale = wantsAll || modifiers.includes("scale");
    let opacityValue = wantsOpacity ? 0 : 1;
    let scaleValue = wantsScale ? $f111f945f972b324$var$modifierValue(modifiers, "scale", 95) / 100 : 1;
    let delay = $f111f945f972b324$var$modifierValue(modifiers, "delay", 0) / 1e3;
    let origin = $f111f945f972b324$var$modifierValue(modifiers, "origin", "center");
    let property = "opacity, transform";
    let durationIn = $f111f945f972b324$var$modifierValue(modifiers, "duration", 150) / 1e3;
    let durationOut = $f111f945f972b324$var$modifierValue(modifiers, "duration", 75) / 1e3;
    let easing = `cubic-bezier(0.4, 0.0, 0.2, 1)`;
    if (transitioningIn) {
        el._x_transition.enter.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationIn}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.enter.start = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
        el._x_transition.enter.end = {
            opacity: 1,
            transform: `scale(1)`
        };
    }
    if (transitioningOut) {
        el._x_transition.leave.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationOut}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.leave.start = {
            opacity: 1,
            transform: `scale(1)`
        };
        el._x_transition.leave.end = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
    }
}
function $f111f945f972b324$var$registerTransitionObject(el, setFunction, defaultValue = {}) {
    if (!el._x_transition) el._x_transition = {
        enter: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        leave: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        in (before = ()=>{}, after = ()=>{}) {
            $f111f945f972b324$var$transition(el, setFunction, {
                during: this.enter.during,
                start: this.enter.start,
                end: this.enter.end
            }, before, after);
        },
        out (before = ()=>{}, after = ()=>{}) {
            $f111f945f972b324$var$transition(el, setFunction, {
                during: this.leave.during,
                start: this.leave.start,
                end: this.leave.end
            }, before, after);
        }
    };
}
window.Element.prototype._x_toggleAndCascadeWithTransitions = function(el, value, show, hide) {
    const nextTick2 = document.visibilityState === "visible" ? requestAnimationFrame : setTimeout;
    let clickAwayCompatibleShow = ()=>nextTick2(show);
    if (value) {
        if (el._x_transition && (el._x_transition.enter || el._x_transition.leave)) el._x_transition.enter && (Object.entries(el._x_transition.enter.during).length || Object.entries(el._x_transition.enter.start).length || Object.entries(el._x_transition.enter.end).length) ? el._x_transition.in(show) : clickAwayCompatibleShow();
        else el._x_transition ? el._x_transition.in(show) : clickAwayCompatibleShow();
        return;
    }
    el._x_hidePromise = el._x_transition ? new Promise((resolve, reject)=>{
        el._x_transition.out(()=>{}, ()=>resolve(hide));
        el._x_transitioning && el._x_transitioning.beforeCancel(()=>reject({
                isFromCancelledTransition: true
            }));
    }) : Promise.resolve(hide);
    queueMicrotask(()=>{
        let closest = $f111f945f972b324$var$closestHide(el);
        if (closest) {
            if (!closest._x_hideChildren) closest._x_hideChildren = [];
            closest._x_hideChildren.push(el);
        } else nextTick2(()=>{
            let hideAfterChildren = (el2)=>{
                let carry = Promise.all([
                    el2._x_hidePromise,
                    ...(el2._x_hideChildren || []).map(hideAfterChildren)
                ]).then(([i])=>i());
                delete el2._x_hidePromise;
                delete el2._x_hideChildren;
                return carry;
            };
            hideAfterChildren(el).catch((e)=>{
                if (!e.isFromCancelledTransition) throw e;
            });
        });
    });
};
function $f111f945f972b324$var$closestHide(el) {
    let parent = el.parentNode;
    if (!parent) return;
    return parent._x_hidePromise ? parent : $f111f945f972b324$var$closestHide(parent);
}
function $f111f945f972b324$var$transition(el, setFunction, { during: during, start: start2, end: end } = {}, before = ()=>{}, after = ()=>{}) {
    if (el._x_transitioning) el._x_transitioning.cancel();
    if (Object.keys(during).length === 0 && Object.keys(start2).length === 0 && Object.keys(end).length === 0) {
        before();
        after();
        return;
    }
    let undoStart, undoDuring, undoEnd;
    $f111f945f972b324$var$performTransition(el, {
        start () {
            undoStart = setFunction(el, start2);
        },
        during () {
            undoDuring = setFunction(el, during);
        },
        before: before,
        end () {
            undoStart();
            undoEnd = setFunction(el, end);
        },
        after: after,
        cleanup () {
            undoDuring();
            undoEnd();
        }
    });
}
function $f111f945f972b324$var$performTransition(el, stages) {
    let interrupted, reachedBefore, reachedEnd;
    let finish = $f111f945f972b324$var$once(()=>{
        $f111f945f972b324$var$mutateDom(()=>{
            interrupted = true;
            if (!reachedBefore) stages.before();
            if (!reachedEnd) {
                stages.end();
                $f111f945f972b324$var$releaseNextTicks();
            }
            stages.after();
            if (el.isConnected) stages.cleanup();
            delete el._x_transitioning;
        });
    });
    el._x_transitioning = {
        beforeCancels: [],
        beforeCancel (callback) {
            this.beforeCancels.push(callback);
        },
        cancel: $f111f945f972b324$var$once(function() {
            while(this.beforeCancels.length)this.beforeCancels.shift()();
            finish();
        }),
        finish: finish
    };
    $f111f945f972b324$var$mutateDom(()=>{
        stages.start();
        stages.during();
    });
    $f111f945f972b324$var$holdNextTicks();
    requestAnimationFrame(()=>{
        if (interrupted) return;
        let duration = Number(getComputedStyle(el).transitionDuration.replace(/,.*/, "").replace("s", "")) * 1e3;
        let delay = Number(getComputedStyle(el).transitionDelay.replace(/,.*/, "").replace("s", "")) * 1e3;
        if (duration === 0) duration = Number(getComputedStyle(el).animationDuration.replace("s", "")) * 1e3;
        $f111f945f972b324$var$mutateDom(()=>{
            stages.before();
        });
        reachedBefore = true;
        requestAnimationFrame(()=>{
            if (interrupted) return;
            $f111f945f972b324$var$mutateDom(()=>{
                stages.end();
            });
            $f111f945f972b324$var$releaseNextTicks();
            setTimeout(el._x_transitioning.finish, duration + delay);
            reachedEnd = true;
        });
    });
}
function $f111f945f972b324$var$modifierValue(modifiers, key, fallback) {
    if (modifiers.indexOf(key) === -1) return fallback;
    const rawValue = modifiers[modifiers.indexOf(key) + 1];
    if (!rawValue) return fallback;
    if (key === "scale") {
        if (isNaN(rawValue)) return fallback;
    }
    if (key === "duration" || key === "delay") {
        let match = rawValue.match(/([0-9]+)ms/);
        if (match) return match[1];
    }
    if (key === "origin") {
        if ([
            "top",
            "right",
            "left",
            "center",
            "bottom"
        ].includes(modifiers[modifiers.indexOf(key) + 2])) return [
            rawValue,
            modifiers[modifiers.indexOf(key) + 2]
        ].join(" ");
    }
    return rawValue;
}
// packages/alpinejs/src/clone.js
var $f111f945f972b324$var$isCloning = false;
function $f111f945f972b324$var$skipDuringClone(callback, fallback = ()=>{}) {
    return (...args)=>$f111f945f972b324$var$isCloning ? fallback(...args) : callback(...args);
}
function $f111f945f972b324$var$onlyDuringClone(callback) {
    return (...args)=>$f111f945f972b324$var$isCloning && callback(...args);
}
var $f111f945f972b324$var$interceptors = [];
function $f111f945f972b324$var$interceptClone(callback) {
    $f111f945f972b324$var$interceptors.push(callback);
}
function $f111f945f972b324$var$cloneNode(from, to) {
    $f111f945f972b324$var$interceptors.forEach((i)=>i(from, to));
    $f111f945f972b324$var$isCloning = true;
    $f111f945f972b324$var$dontRegisterReactiveSideEffects(()=>{
        $f111f945f972b324$var$initTree(to, (el, callback)=>{
            callback(el, ()=>{});
        });
    });
    $f111f945f972b324$var$isCloning = false;
}
var $f111f945f972b324$var$isCloningLegacy = false;
function $f111f945f972b324$var$clone(oldEl, newEl) {
    if (!newEl._x_dataStack) newEl._x_dataStack = oldEl._x_dataStack;
    $f111f945f972b324$var$isCloning = true;
    $f111f945f972b324$var$isCloningLegacy = true;
    $f111f945f972b324$var$dontRegisterReactiveSideEffects(()=>{
        $f111f945f972b324$var$cloneTree(newEl);
    });
    $f111f945f972b324$var$isCloning = false;
    $f111f945f972b324$var$isCloningLegacy = false;
}
function $f111f945f972b324$var$cloneTree(el) {
    let hasRunThroughFirstEl = false;
    let shallowWalker = (el2, callback)=>{
        $f111f945f972b324$var$walk(el2, (el3, skip)=>{
            if (hasRunThroughFirstEl && $f111f945f972b324$var$isRoot(el3)) return skip();
            hasRunThroughFirstEl = true;
            callback(el3, skip);
        });
    };
    $f111f945f972b324$var$initTree(el, shallowWalker);
}
function $f111f945f972b324$var$dontRegisterReactiveSideEffects(callback) {
    let cache = $f111f945f972b324$var$effect;
    $f111f945f972b324$var$overrideEffect((callback2, el)=>{
        let storedEffect = cache(callback2);
        $f111f945f972b324$var$release(storedEffect);
        return ()=>{};
    });
    callback();
    $f111f945f972b324$var$overrideEffect(cache);
}
// packages/alpinejs/src/utils/bind.js
function $f111f945f972b324$var$bind(el, name, value, modifiers = []) {
    if (!el._x_bindings) el._x_bindings = $f111f945f972b324$var$reactive({});
    el._x_bindings[name] = value;
    name = modifiers.includes("camel") ? $f111f945f972b324$var$camelCase(name) : name;
    switch(name){
        case "value":
            $f111f945f972b324$var$bindInputValue(el, value);
            break;
        case "style":
            $f111f945f972b324$var$bindStyles(el, value);
            break;
        case "class":
            $f111f945f972b324$var$bindClasses(el, value);
            break;
        case "selected":
        case "checked":
            $f111f945f972b324$var$bindAttributeAndProperty(el, name, value);
            break;
        default:
            $f111f945f972b324$var$bindAttribute(el, name, value);
            break;
    }
}
function $f111f945f972b324$var$bindInputValue(el, value) {
    if (el.type === "radio") {
        if (el.attributes.value === void 0) el.value = value;
        if (window.fromModel) {
            if (typeof value === "boolean") el.checked = $f111f945f972b324$var$safeParseBoolean(el.value) === value;
            else el.checked = $f111f945f972b324$var$checkedAttrLooseCompare(el.value, value);
        }
    } else if (el.type === "checkbox") {
        if (Number.isInteger(value)) el.value = value;
        else if (!Array.isArray(value) && typeof value !== "boolean" && ![
            null,
            void 0
        ].includes(value)) el.value = String(value);
        else if (Array.isArray(value)) el.checked = value.some((val)=>$f111f945f972b324$var$checkedAttrLooseCompare(val, el.value));
        else el.checked = !!value;
    } else if (el.tagName === "SELECT") $f111f945f972b324$var$updateSelect(el, value);
    else {
        if (el.value === value) return;
        el.value = value === void 0 ? "" : value;
    }
}
function $f111f945f972b324$var$bindClasses(el, value) {
    if (el._x_undoAddedClasses) el._x_undoAddedClasses();
    el._x_undoAddedClasses = $f111f945f972b324$var$setClasses(el, value);
}
function $f111f945f972b324$var$bindStyles(el, value) {
    if (el._x_undoAddedStyles) el._x_undoAddedStyles();
    el._x_undoAddedStyles = $f111f945f972b324$var$setStyles(el, value);
}
function $f111f945f972b324$var$bindAttributeAndProperty(el, name, value) {
    $f111f945f972b324$var$bindAttribute(el, name, value);
    $f111f945f972b324$var$setPropertyIfChanged(el, name, value);
}
function $f111f945f972b324$var$bindAttribute(el, name, value) {
    if ([
        null,
        void 0,
        false
    ].includes(value) && $f111f945f972b324$var$attributeShouldntBePreservedIfFalsy(name)) el.removeAttribute(name);
    else {
        if ($f111f945f972b324$var$isBooleanAttr(name)) value = name;
        $f111f945f972b324$var$setIfChanged(el, name, value);
    }
}
function $f111f945f972b324$var$setIfChanged(el, attrName, value) {
    if (el.getAttribute(attrName) != value) el.setAttribute(attrName, value);
}
function $f111f945f972b324$var$setPropertyIfChanged(el, propName, value) {
    if (el[propName] !== value) el[propName] = value;
}
function $f111f945f972b324$var$updateSelect(el, value) {
    const arrayWrappedValue = [].concat(value).map((value2)=>{
        return value2 + "";
    });
    Array.from(el.options).forEach((option)=>{
        option.selected = arrayWrappedValue.includes(option.value);
    });
}
function $f111f945f972b324$var$camelCase(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $f111f945f972b324$var$checkedAttrLooseCompare(valueA, valueB) {
    return valueA == valueB;
}
function $f111f945f972b324$var$safeParseBoolean(rawValue) {
    if ([
        1,
        "1",
        "true",
        "on",
        "yes",
        true
    ].includes(rawValue)) return true;
    if ([
        0,
        "0",
        "false",
        "off",
        "no",
        false
    ].includes(rawValue)) return false;
    return rawValue ? Boolean(rawValue) : null;
}
function $f111f945f972b324$var$isBooleanAttr(attrName) {
    const booleanAttributes = [
        "disabled",
        "checked",
        "required",
        "readonly",
        "hidden",
        "open",
        "selected",
        "autofocus",
        "itemscope",
        "multiple",
        "novalidate",
        "allowfullscreen",
        "allowpaymentrequest",
        "formnovalidate",
        "autoplay",
        "controls",
        "loop",
        "muted",
        "playsinline",
        "default",
        "ismap",
        "reversed",
        "async",
        "defer",
        "nomodule"
    ];
    return booleanAttributes.includes(attrName);
}
function $f111f945f972b324$var$attributeShouldntBePreservedIfFalsy(name) {
    return ![
        "aria-pressed",
        "aria-checked",
        "aria-expanded",
        "aria-selected"
    ].includes(name);
}
function $f111f945f972b324$var$getBinding(el, name, fallback) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    return $f111f945f972b324$var$getAttributeBinding(el, name, fallback);
}
function $f111f945f972b324$var$extractProp(el, name, fallback, extract = true) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    if (el._x_inlineBindings && el._x_inlineBindings[name] !== void 0) {
        let binding = el._x_inlineBindings[name];
        binding.extract = extract;
        return $f111f945f972b324$var$dontAutoEvaluateFunctions(()=>{
            return $f111f945f972b324$var$evaluate(el, binding.expression);
        });
    }
    return $f111f945f972b324$var$getAttributeBinding(el, name, fallback);
}
function $f111f945f972b324$var$getAttributeBinding(el, name, fallback) {
    let attr = el.getAttribute(name);
    if (attr === null) return typeof fallback === "function" ? fallback() : fallback;
    if (attr === "") return true;
    if ($f111f945f972b324$var$isBooleanAttr(name)) return !![
        name,
        "true"
    ].includes(attr);
    return attr;
}
// packages/alpinejs/src/utils/debounce.js
function $f111f945f972b324$var$debounce(func, wait) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            func.apply(context, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}
// packages/alpinejs/src/utils/throttle.js
function $f111f945f972b324$var$throttle(func, limit) {
    let inThrottle;
    return function() {
        let context = this, args = arguments;
        if (!inThrottle) {
            func.apply(context, args);
            inThrottle = true;
            setTimeout(()=>inThrottle = false, limit);
        }
    };
}
// packages/alpinejs/src/entangle.js
function $f111f945f972b324$var$entangle({ get: outerGet, set: outerSet }, { get: innerGet, set: innerSet }) {
    let firstRun = true;
    let outerHash;
    let reference = $f111f945f972b324$var$effect(()=>{
        const outer = outerGet();
        const inner = innerGet();
        if (firstRun) {
            innerSet($f111f945f972b324$var$cloneIfObject(outer));
            firstRun = false;
            outerHash = JSON.stringify(outer);
        } else {
            const outerHashLatest = JSON.stringify(outer);
            if (outerHashLatest !== outerHash) {
                innerSet($f111f945f972b324$var$cloneIfObject(outer));
                outerHash = outerHashLatest;
            } else {
                outerSet($f111f945f972b324$var$cloneIfObject(inner));
                outerHash = JSON.stringify(inner);
            }
        }
        JSON.stringify(innerGet());
        JSON.stringify(outerGet());
    });
    return ()=>{
        $f111f945f972b324$var$release(reference);
    };
}
function $f111f945f972b324$var$cloneIfObject(value) {
    return typeof value === "object" ? JSON.parse(JSON.stringify(value)) : value;
}
// packages/alpinejs/src/plugin.js
function $f111f945f972b324$var$plugin(callback) {
    let callbacks = Array.isArray(callback) ? callback : [
        callback
    ];
    callbacks.forEach((i)=>i($f111f945f972b324$var$alpine_default));
}
// packages/alpinejs/src/store.js
var $f111f945f972b324$var$stores = {};
var $f111f945f972b324$var$isReactive = false;
function $f111f945f972b324$var$store(name, value) {
    if (!$f111f945f972b324$var$isReactive) {
        $f111f945f972b324$var$stores = $f111f945f972b324$var$reactive($f111f945f972b324$var$stores);
        $f111f945f972b324$var$isReactive = true;
    }
    if (value === void 0) return $f111f945f972b324$var$stores[name];
    $f111f945f972b324$var$stores[name] = value;
    if (typeof value === "object" && value !== null && value.hasOwnProperty("init") && typeof value.init === "function") $f111f945f972b324$var$stores[name].init();
    $f111f945f972b324$var$initInterceptors2($f111f945f972b324$var$stores[name]);
}
function $f111f945f972b324$var$getStores() {
    return $f111f945f972b324$var$stores;
}
// packages/alpinejs/src/binds.js
var $f111f945f972b324$var$binds = {};
function $f111f945f972b324$var$bind2(name, bindings) {
    let getBindings = typeof bindings !== "function" ? ()=>bindings : bindings;
    if (name instanceof Element) return $f111f945f972b324$var$applyBindingsObject(name, getBindings());
    else $f111f945f972b324$var$binds[name] = getBindings;
    return ()=>{};
}
function $f111f945f972b324$var$injectBindingProviders(obj) {
    Object.entries($f111f945f972b324$var$binds).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback(...args);
                };
            }
        });
    });
    return obj;
}
function $f111f945f972b324$var$applyBindingsObject(el, obj, original) {
    let cleanupRunners = [];
    while(cleanupRunners.length)cleanupRunners.pop()();
    let attributes = Object.entries(obj).map(([name, value])=>({
            name: name,
            value: value
        }));
    let staticAttributes = $f111f945f972b324$var$attributesOnly(attributes);
    attributes = attributes.map((attribute)=>{
        if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
            name: `x-bind:${attribute.name}`,
            value: `"${attribute.value}"`
        };
        return attribute;
    });
    $f111f945f972b324$var$directives(el, attributes, original).map((handle)=>{
        cleanupRunners.push(handle.runCleanups);
        handle();
    });
    return ()=>{
        while(cleanupRunners.length)cleanupRunners.pop()();
    };
}
// packages/alpinejs/src/datas.js
var $f111f945f972b324$var$datas = {};
function $f111f945f972b324$var$data(name, callback) {
    $f111f945f972b324$var$datas[name] = callback;
}
function $f111f945f972b324$var$injectDataProviders(obj, context) {
    Object.entries($f111f945f972b324$var$datas).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback.bind(context)(...args);
                };
            },
            enumerable: false
        });
    });
    return obj;
}
// packages/alpinejs/src/alpine.js
var $f111f945f972b324$var$Alpine = {
    get reactive () {
        return $f111f945f972b324$var$reactive;
    },
    get release () {
        return $f111f945f972b324$var$release;
    },
    get effect () {
        return $f111f945f972b324$var$effect;
    },
    get raw () {
        return $f111f945f972b324$var$raw;
    },
    version: "3.13.3",
    flushAndStopDeferringMutations: $f111f945f972b324$var$flushAndStopDeferringMutations,
    dontAutoEvaluateFunctions: $f111f945f972b324$var$dontAutoEvaluateFunctions,
    disableEffectScheduling: $f111f945f972b324$var$disableEffectScheduling,
    startObservingMutations: $f111f945f972b324$var$startObservingMutations,
    stopObservingMutations: $f111f945f972b324$var$stopObservingMutations,
    setReactivityEngine: $f111f945f972b324$var$setReactivityEngine,
    onAttributeRemoved: $f111f945f972b324$var$onAttributeRemoved,
    onAttributesAdded: $f111f945f972b324$var$onAttributesAdded,
    closestDataStack: $f111f945f972b324$var$closestDataStack,
    skipDuringClone: $f111f945f972b324$var$skipDuringClone,
    onlyDuringClone: $f111f945f972b324$var$onlyDuringClone,
    addRootSelector: $f111f945f972b324$var$addRootSelector,
    addInitSelector: $f111f945f972b324$var$addInitSelector,
    interceptClone: $f111f945f972b324$var$interceptClone,
    addScopeToNode: $f111f945f972b324$var$addScopeToNode,
    deferMutations: $f111f945f972b324$var$deferMutations,
    mapAttributes: $f111f945f972b324$var$mapAttributes,
    evaluateLater: $f111f945f972b324$var$evaluateLater,
    interceptInit: $f111f945f972b324$var$interceptInit,
    setEvaluator: $f111f945f972b324$var$setEvaluator,
    mergeProxies: $f111f945f972b324$var$mergeProxies,
    extractProp: $f111f945f972b324$var$extractProp,
    findClosest: $f111f945f972b324$var$findClosest,
    onElRemoved: $f111f945f972b324$var$onElRemoved,
    closestRoot: $f111f945f972b324$var$closestRoot,
    destroyTree: $f111f945f972b324$var$destroyTree,
    interceptor: $f111f945f972b324$var$interceptor,
    transition: // INTERNAL: not public API and is subject to change without major release.
    $f111f945f972b324$var$transition,
    setStyles: // INTERNAL
    $f111f945f972b324$var$setStyles,
    mutateDom: // INTERNAL
    $f111f945f972b324$var$mutateDom,
    directive: $f111f945f972b324$var$directive,
    entangle: $f111f945f972b324$var$entangle,
    throttle: $f111f945f972b324$var$throttle,
    debounce: $f111f945f972b324$var$debounce,
    evaluate: $f111f945f972b324$var$evaluate,
    initTree: $f111f945f972b324$var$initTree,
    nextTick: $f111f945f972b324$var$nextTick,
    prefixed: $f111f945f972b324$var$prefix,
    prefix: $f111f945f972b324$var$setPrefix,
    plugin: $f111f945f972b324$var$plugin,
    magic: $f111f945f972b324$var$magic,
    store: $f111f945f972b324$var$store,
    start: $f111f945f972b324$var$start,
    clone: $f111f945f972b324$var$clone,
    cloneNode: // INTERNAL
    $f111f945f972b324$var$cloneNode,
    // INTERNAL
    bound: $f111f945f972b324$var$getBinding,
    $data: $f111f945f972b324$var$scope,
    walk: $f111f945f972b324$var$walk,
    data: $f111f945f972b324$var$data,
    bind: $f111f945f972b324$var$bind2
};
var $f111f945f972b324$var$alpine_default = $f111f945f972b324$var$Alpine;
// node_modules/@vue/shared/dist/shared.esm-bundler.js
function $f111f945f972b324$var$makeMap(str, expectsLowerCase) {
    const map = /* @__PURE__ */ Object.create(null);
    const list = str.split(",");
    for(let i = 0; i < list.length; i++)map[list[i]] = true;
    return expectsLowerCase ? (val)=>!!map[val.toLowerCase()] : (val)=>!!map[val];
}
var $f111f945f972b324$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
var $f111f945f972b324$var$isBooleanAttr2 = /* @__PURE__ */ $f111f945f972b324$var$makeMap($f111f945f972b324$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
var $f111f945f972b324$var$EMPTY_OBJ = Object.freeze({});
var $f111f945f972b324$var$EMPTY_ARR = Object.freeze([]);
var $f111f945f972b324$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $f111f945f972b324$var$hasOwn = (val, key)=>$f111f945f972b324$var$hasOwnProperty.call(val, key);
var $f111f945f972b324$var$isArray = Array.isArray;
var $f111f945f972b324$var$isMap = (val)=>$f111f945f972b324$var$toTypeString(val) === "[object Map]";
var $f111f945f972b324$var$isString = (val)=>typeof val === "string";
var $f111f945f972b324$var$isSymbol = (val)=>typeof val === "symbol";
var $f111f945f972b324$var$isObject = (val)=>val !== null && typeof val === "object";
var $f111f945f972b324$var$objectToString = Object.prototype.toString;
var $f111f945f972b324$var$toTypeString = (value)=>$f111f945f972b324$var$objectToString.call(value);
var $f111f945f972b324$var$toRawType = (value)=>{
    return $f111f945f972b324$var$toTypeString(value).slice(8, -1);
};
var $f111f945f972b324$var$isIntegerKey = (key)=>$f111f945f972b324$var$isString(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
var $f111f945f972b324$var$cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
var $f111f945f972b324$var$camelizeRE = /-(\w)/g;
var $f111f945f972b324$var$camelize = $f111f945f972b324$var$cacheStringFunction((str)=>{
    return str.replace($f111f945f972b324$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
var $f111f945f972b324$var$hyphenateRE = /\B([A-Z])/g;
var $f111f945f972b324$var$hyphenate = $f111f945f972b324$var$cacheStringFunction((str)=>str.replace($f111f945f972b324$var$hyphenateRE, "-$1").toLowerCase());
var $f111f945f972b324$var$capitalize = $f111f945f972b324$var$cacheStringFunction((str)=>str.charAt(0).toUpperCase() + str.slice(1));
var $f111f945f972b324$var$toHandlerKey = $f111f945f972b324$var$cacheStringFunction((str)=>str ? `on${$f111f945f972b324$var$capitalize(str)}` : ``);
var $f111f945f972b324$var$hasChanged = (value, oldValue)=>value !== oldValue && (value === value || oldValue === oldValue);
// node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js
var $f111f945f972b324$var$targetMap = /* @__PURE__ */ new WeakMap();
var $f111f945f972b324$var$effectStack = [];
var $f111f945f972b324$var$activeEffect;
var $f111f945f972b324$var$ITERATE_KEY = Symbol("iterate");
var $f111f945f972b324$var$MAP_KEY_ITERATE_KEY = Symbol("Map key iterate");
function $f111f945f972b324$var$isEffect(fn) {
    return fn && fn._isEffect === true;
}
function $f111f945f972b324$var$effect2(fn, options = $f111f945f972b324$var$EMPTY_OBJ) {
    if ($f111f945f972b324$var$isEffect(fn)) fn = fn.raw;
    const effect3 = $f111f945f972b324$var$createReactiveEffect(fn, options);
    if (!options.lazy) effect3();
    return effect3;
}
function $f111f945f972b324$var$stop(effect3) {
    if (effect3.active) {
        $f111f945f972b324$var$cleanup(effect3);
        if (effect3.options.onStop) effect3.options.onStop();
        effect3.active = false;
    }
}
var $f111f945f972b324$var$uid = 0;
function $f111f945f972b324$var$createReactiveEffect(fn, options) {
    const effect3 = function reactiveEffect() {
        if (!effect3.active) return fn();
        if (!$f111f945f972b324$var$effectStack.includes(effect3)) {
            $f111f945f972b324$var$cleanup(effect3);
            try {
                $f111f945f972b324$var$enableTracking();
                $f111f945f972b324$var$effectStack.push(effect3);
                $f111f945f972b324$var$activeEffect = effect3;
                return fn();
            } finally{
                $f111f945f972b324$var$effectStack.pop();
                $f111f945f972b324$var$resetTracking();
                $f111f945f972b324$var$activeEffect = $f111f945f972b324$var$effectStack[$f111f945f972b324$var$effectStack.length - 1];
            }
        }
    };
    effect3.id = $f111f945f972b324$var$uid++;
    effect3.allowRecurse = !!options.allowRecurse;
    effect3._isEffect = true;
    effect3.active = true;
    effect3.raw = fn;
    effect3.deps = [];
    effect3.options = options;
    return effect3;
}
function $f111f945f972b324$var$cleanup(effect3) {
    const { deps: deps } = effect3;
    if (deps.length) {
        for(let i = 0; i < deps.length; i++)deps[i].delete(effect3);
        deps.length = 0;
    }
}
var $f111f945f972b324$var$shouldTrack = true;
var $f111f945f972b324$var$trackStack = [];
function $f111f945f972b324$var$pauseTracking() {
    $f111f945f972b324$var$trackStack.push($f111f945f972b324$var$shouldTrack);
    $f111f945f972b324$var$shouldTrack = false;
}
function $f111f945f972b324$var$enableTracking() {
    $f111f945f972b324$var$trackStack.push($f111f945f972b324$var$shouldTrack);
    $f111f945f972b324$var$shouldTrack = true;
}
function $f111f945f972b324$var$resetTracking() {
    const last = $f111f945f972b324$var$trackStack.pop();
    $f111f945f972b324$var$shouldTrack = last === void 0 ? true : last;
}
function $f111f945f972b324$var$track(target, type, key) {
    if (!$f111f945f972b324$var$shouldTrack || $f111f945f972b324$var$activeEffect === void 0) return;
    let depsMap = $f111f945f972b324$var$targetMap.get(target);
    if (!depsMap) $f111f945f972b324$var$targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
    let dep = depsMap.get(key);
    if (!dep) depsMap.set(key, dep = /* @__PURE__ */ new Set());
    if (!dep.has($f111f945f972b324$var$activeEffect)) {
        dep.add($f111f945f972b324$var$activeEffect);
        $f111f945f972b324$var$activeEffect.deps.push(dep);
        if ($f111f945f972b324$var$activeEffect.options.onTrack) $f111f945f972b324$var$activeEffect.options.onTrack({
            effect: $f111f945f972b324$var$activeEffect,
            target: target,
            type: type,
            key: key
        });
    }
}
function $f111f945f972b324$var$trigger(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $f111f945f972b324$var$targetMap.get(target);
    if (!depsMap) return;
    const effects = /* @__PURE__ */ new Set();
    const add2 = (effectsToAdd)=>{
        if (effectsToAdd) effectsToAdd.forEach((effect3)=>{
            if (effect3 !== $f111f945f972b324$var$activeEffect || effect3.allowRecurse) effects.add(effect3);
        });
    };
    if (type === "clear") depsMap.forEach(add2);
    else if (key === "length" && $f111f945f972b324$var$isArray(target)) depsMap.forEach((dep, key2)=>{
        if (key2 === "length" || key2 >= newValue) add2(dep);
    });
    else {
        if (key !== void 0) add2(depsMap.get(key));
        switch(type){
            case "add":
                if (!$f111f945f972b324$var$isArray(target)) {
                    add2(depsMap.get($f111f945f972b324$var$ITERATE_KEY));
                    if ($f111f945f972b324$var$isMap(target)) add2(depsMap.get($f111f945f972b324$var$MAP_KEY_ITERATE_KEY));
                } else if ($f111f945f972b324$var$isIntegerKey(key)) add2(depsMap.get("length"));
                break;
            case "delete":
                if (!$f111f945f972b324$var$isArray(target)) {
                    add2(depsMap.get($f111f945f972b324$var$ITERATE_KEY));
                    if ($f111f945f972b324$var$isMap(target)) add2(depsMap.get($f111f945f972b324$var$MAP_KEY_ITERATE_KEY));
                }
                break;
            case "set":
                if ($f111f945f972b324$var$isMap(target)) add2(depsMap.get($f111f945f972b324$var$ITERATE_KEY));
                break;
        }
    }
    const run = (effect3)=>{
        if (effect3.options.onTrigger) effect3.options.onTrigger({
            effect: effect3,
            target: target,
            key: key,
            type: type,
            newValue: newValue,
            oldValue: oldValue,
            oldTarget: oldTarget
        });
        if (effect3.options.scheduler) effect3.options.scheduler(effect3);
        else effect3();
    };
    effects.forEach(run);
}
var $f111f945f972b324$var$isNonTrackableKeys = /* @__PURE__ */ $f111f945f972b324$var$makeMap(`__proto__,__v_isRef,__isVue`);
var $f111f945f972b324$var$builtInSymbols = new Set(Object.getOwnPropertyNames(Symbol).map((key)=>Symbol[key]).filter($f111f945f972b324$var$isSymbol));
var $f111f945f972b324$var$get2 = /* @__PURE__ */ $f111f945f972b324$var$createGetter();
var $f111f945f972b324$var$readonlyGet = /* @__PURE__ */ $f111f945f972b324$var$createGetter(true);
var $f111f945f972b324$var$arrayInstrumentations = /* @__PURE__ */ $f111f945f972b324$var$createArrayInstrumentations();
function $f111f945f972b324$var$createArrayInstrumentations() {
    const instrumentations = {};
    [
        "includes",
        "indexOf",
        "lastIndexOf"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            const arr = $f111f945f972b324$var$toRaw(this);
            for(let i = 0, l = this.length; i < l; i++)$f111f945f972b324$var$track(arr, "get", i + "");
            const res = arr[key](...args);
            if (res === -1 || res === false) return arr[key](...args.map($f111f945f972b324$var$toRaw));
            else return res;
        };
    });
    [
        "push",
        "pop",
        "shift",
        "unshift",
        "splice"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            $f111f945f972b324$var$pauseTracking();
            const res = $f111f945f972b324$var$toRaw(this)[key].apply(this, args);
            $f111f945f972b324$var$resetTracking();
            return res;
        };
    });
    return instrumentations;
}
function $f111f945f972b324$var$createGetter(isReadonly = false, shallow = false) {
    return function get3(target, key, receiver) {
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw" && receiver === (isReadonly ? shallow ? $f111f945f972b324$var$shallowReadonlyMap : $f111f945f972b324$var$readonlyMap : shallow ? $f111f945f972b324$var$shallowReactiveMap : $f111f945f972b324$var$reactiveMap).get(target)) return target;
        const targetIsArray = $f111f945f972b324$var$isArray(target);
        if (!isReadonly && targetIsArray && $f111f945f972b324$var$hasOwn($f111f945f972b324$var$arrayInstrumentations, key)) return Reflect.get($f111f945f972b324$var$arrayInstrumentations, key, receiver);
        const res = Reflect.get(target, key, receiver);
        if ($f111f945f972b324$var$isSymbol(key) ? $f111f945f972b324$var$builtInSymbols.has(key) : $f111f945f972b324$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly) $f111f945f972b324$var$track(target, "get", key);
        if (shallow) return res;
        if ($f111f945f972b324$var$isRef(res)) {
            const shouldUnwrap = !targetIsArray || !$f111f945f972b324$var$isIntegerKey(key);
            return shouldUnwrap ? res.value : res;
        }
        if ($f111f945f972b324$var$isObject(res)) return isReadonly ? $f111f945f972b324$var$readonly(res) : $f111f945f972b324$var$reactive2(res);
        return res;
    };
}
var $f111f945f972b324$var$set2 = /* @__PURE__ */ $f111f945f972b324$var$createSetter();
function $f111f945f972b324$var$createSetter(shallow = false) {
    return function set3(target, key, value, receiver) {
        let oldValue = target[key];
        if (!shallow) {
            value = $f111f945f972b324$var$toRaw(value);
            oldValue = $f111f945f972b324$var$toRaw(oldValue);
            if (!$f111f945f972b324$var$isArray(target) && $f111f945f972b324$var$isRef(oldValue) && !$f111f945f972b324$var$isRef(value)) {
                oldValue.value = value;
                return true;
            }
        }
        const hadKey = $f111f945f972b324$var$isArray(target) && $f111f945f972b324$var$isIntegerKey(key) ? Number(key) < target.length : $f111f945f972b324$var$hasOwn(target, key);
        const result = Reflect.set(target, key, value, receiver);
        if (target === $f111f945f972b324$var$toRaw(receiver)) {
            if (!hadKey) $f111f945f972b324$var$trigger(target, "add", key, value);
            else if ($f111f945f972b324$var$hasChanged(value, oldValue)) $f111f945f972b324$var$trigger(target, "set", key, value, oldValue);
        }
        return result;
    };
}
function $f111f945f972b324$var$deleteProperty(target, key) {
    const hadKey = $f111f945f972b324$var$hasOwn(target, key);
    const oldValue = target[key];
    const result = Reflect.deleteProperty(target, key);
    if (result && hadKey) $f111f945f972b324$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $f111f945f972b324$var$has(target, key) {
    const result = Reflect.has(target, key);
    if (!$f111f945f972b324$var$isSymbol(key) || !$f111f945f972b324$var$builtInSymbols.has(key)) $f111f945f972b324$var$track(target, "has", key);
    return result;
}
function $f111f945f972b324$var$ownKeys(target) {
    $f111f945f972b324$var$track(target, "iterate", $f111f945f972b324$var$isArray(target) ? "length" : $f111f945f972b324$var$ITERATE_KEY);
    return Reflect.ownKeys(target);
}
var $f111f945f972b324$var$mutableHandlers = {
    get: $f111f945f972b324$var$get2,
    set: $f111f945f972b324$var$set2,
    deleteProperty: $f111f945f972b324$var$deleteProperty,
    has: $f111f945f972b324$var$has,
    ownKeys: $f111f945f972b324$var$ownKeys
};
var $f111f945f972b324$var$readonlyHandlers = {
    get: $f111f945f972b324$var$readonlyGet,
    set (target, key) {
        console.warn(`Set operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    },
    deleteProperty (target, key) {
        console.warn(`Delete operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    }
};
var $f111f945f972b324$var$toReactive = (value)=>$f111f945f972b324$var$isObject(value) ? $f111f945f972b324$var$reactive2(value) : value;
var $f111f945f972b324$var$toReadonly = (value)=>$f111f945f972b324$var$isObject(value) ? $f111f945f972b324$var$readonly(value) : value;
var $f111f945f972b324$var$toShallow = (value)=>value;
var $f111f945f972b324$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $f111f945f972b324$var$get$1(target, key, isReadonly = false, isShallow = false) {
    target = target["__v_raw"];
    const rawTarget = $f111f945f972b324$var$toRaw(target);
    const rawKey = $f111f945f972b324$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $f111f945f972b324$var$track(rawTarget, "get", key);
    !isReadonly && $f111f945f972b324$var$track(rawTarget, "get", rawKey);
    const { has: has2 } = $f111f945f972b324$var$getProto(rawTarget);
    const wrap = isShallow ? $f111f945f972b324$var$toShallow : isReadonly ? $f111f945f972b324$var$toReadonly : $f111f945f972b324$var$toReactive;
    if (has2.call(rawTarget, key)) return wrap(target.get(key));
    else if (has2.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
    else if (target !== rawTarget) target.get(key);
}
function $f111f945f972b324$var$has$1(key, isReadonly = false) {
    const target = this["__v_raw"];
    const rawTarget = $f111f945f972b324$var$toRaw(target);
    const rawKey = $f111f945f972b324$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $f111f945f972b324$var$track(rawTarget, "has", key);
    !isReadonly && $f111f945f972b324$var$track(rawTarget, "has", rawKey);
    return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
}
function $f111f945f972b324$var$size(target, isReadonly = false) {
    target = target["__v_raw"];
    !isReadonly && $f111f945f972b324$var$track($f111f945f972b324$var$toRaw(target), "iterate", $f111f945f972b324$var$ITERATE_KEY);
    return Reflect.get(target, "size", target);
}
function $f111f945f972b324$var$add(value) {
    value = $f111f945f972b324$var$toRaw(value);
    const target = $f111f945f972b324$var$toRaw(this);
    const proto = $f111f945f972b324$var$getProto(target);
    const hadKey = proto.has.call(target, value);
    if (!hadKey) {
        target.add(value);
        $f111f945f972b324$var$trigger(target, "add", value, value);
    }
    return this;
}
function $f111f945f972b324$var$set$1(key, value) {
    value = $f111f945f972b324$var$toRaw(value);
    const target = $f111f945f972b324$var$toRaw(this);
    const { has: has2, get: get3 } = $f111f945f972b324$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $f111f945f972b324$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $f111f945f972b324$var$checkIdentityKeys(target, has2, key);
    const oldValue = get3.call(target, key);
    target.set(key, value);
    if (!hadKey) $f111f945f972b324$var$trigger(target, "add", key, value);
    else if ($f111f945f972b324$var$hasChanged(value, oldValue)) $f111f945f972b324$var$trigger(target, "set", key, value, oldValue);
    return this;
}
function $f111f945f972b324$var$deleteEntry(key) {
    const target = $f111f945f972b324$var$toRaw(this);
    const { has: has2, get: get3 } = $f111f945f972b324$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $f111f945f972b324$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $f111f945f972b324$var$checkIdentityKeys(target, has2, key);
    const oldValue = get3 ? get3.call(target, key) : void 0;
    const result = target.delete(key);
    if (hadKey) $f111f945f972b324$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $f111f945f972b324$var$clear() {
    const target = $f111f945f972b324$var$toRaw(this);
    const hadItems = target.size !== 0;
    const oldTarget = $f111f945f972b324$var$isMap(target) ? new Map(target) : new Set(target);
    const result = target.clear();
    if (hadItems) $f111f945f972b324$var$trigger(target, "clear", void 0, void 0, oldTarget);
    return result;
}
function $f111f945f972b324$var$createForEach(isReadonly, isShallow) {
    return function forEach(callback, thisArg) {
        const observed = this;
        const target = observed["__v_raw"];
        const rawTarget = $f111f945f972b324$var$toRaw(target);
        const wrap = isShallow ? $f111f945f972b324$var$toShallow : isReadonly ? $f111f945f972b324$var$toReadonly : $f111f945f972b324$var$toReactive;
        !isReadonly && $f111f945f972b324$var$track(rawTarget, "iterate", $f111f945f972b324$var$ITERATE_KEY);
        return target.forEach((value, key)=>{
            return callback.call(thisArg, wrap(value), wrap(key), observed);
        });
    };
}
function $f111f945f972b324$var$createIterableMethod(method, isReadonly, isShallow) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = $f111f945f972b324$var$toRaw(target);
        const targetIsMap = $f111f945f972b324$var$isMap(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow ? $f111f945f972b324$var$toShallow : isReadonly ? $f111f945f972b324$var$toReadonly : $f111f945f972b324$var$toReactive;
        !isReadonly && $f111f945f972b324$var$track(rawTarget, "iterate", isKeyOnly ? $f111f945f972b324$var$MAP_KEY_ITERATE_KEY : $f111f945f972b324$var$ITERATE_KEY);
        return {
            // iterator protocol
            next () {
                const { value: value, done: done } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            },
            // iterable protocol
            [Symbol.iterator] () {
                return this;
            }
        };
    };
}
function $f111f945f972b324$var$createReadonlyMethod(type) {
    return function(...args) {
        {
            const key = args[0] ? `on key "${args[0]}" ` : ``;
            console.warn(`${$f111f945f972b324$var$capitalize(type)} operation ${key}failed: target is readonly.`, $f111f945f972b324$var$toRaw(this));
        }
        return type === "delete" ? false : this;
    };
}
function $f111f945f972b324$var$createInstrumentations() {
    const mutableInstrumentations2 = {
        get (key) {
            return $f111f945f972b324$var$get$1(this, key);
        },
        get size () {
            return $f111f945f972b324$var$size(this);
        },
        has: $f111f945f972b324$var$has$1,
        add: $f111f945f972b324$var$add,
        set: $f111f945f972b324$var$set$1,
        delete: $f111f945f972b324$var$deleteEntry,
        clear: $f111f945f972b324$var$clear,
        forEach: $f111f945f972b324$var$createForEach(false, false)
    };
    const shallowInstrumentations2 = {
        get (key) {
            return $f111f945f972b324$var$get$1(this, key, false, true);
        },
        get size () {
            return $f111f945f972b324$var$size(this);
        },
        has: $f111f945f972b324$var$has$1,
        add: $f111f945f972b324$var$add,
        set: $f111f945f972b324$var$set$1,
        delete: $f111f945f972b324$var$deleteEntry,
        clear: $f111f945f972b324$var$clear,
        forEach: $f111f945f972b324$var$createForEach(false, true)
    };
    const readonlyInstrumentations2 = {
        get (key) {
            return $f111f945f972b324$var$get$1(this, key, true);
        },
        get size () {
            return $f111f945f972b324$var$size(this, true);
        },
        has (key) {
            return $f111f945f972b324$var$has$1.call(this, key, true);
        },
        add: $f111f945f972b324$var$createReadonlyMethod("add"),
        set: $f111f945f972b324$var$createReadonlyMethod("set"),
        delete: $f111f945f972b324$var$createReadonlyMethod("delete"),
        clear: $f111f945f972b324$var$createReadonlyMethod("clear"),
        forEach: $f111f945f972b324$var$createForEach(true, false)
    };
    const shallowReadonlyInstrumentations2 = {
        get (key) {
            return $f111f945f972b324$var$get$1(this, key, true, true);
        },
        get size () {
            return $f111f945f972b324$var$size(this, true);
        },
        has (key) {
            return $f111f945f972b324$var$has$1.call(this, key, true);
        },
        add: $f111f945f972b324$var$createReadonlyMethod("add"),
        set: $f111f945f972b324$var$createReadonlyMethod("set"),
        delete: $f111f945f972b324$var$createReadonlyMethod("delete"),
        clear: $f111f945f972b324$var$createReadonlyMethod("clear"),
        forEach: $f111f945f972b324$var$createForEach(true, true)
    };
    const iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        mutableInstrumentations2[method] = $f111f945f972b324$var$createIterableMethod(method, false, false);
        readonlyInstrumentations2[method] = $f111f945f972b324$var$createIterableMethod(method, true, false);
        shallowInstrumentations2[method] = $f111f945f972b324$var$createIterableMethod(method, false, true);
        shallowReadonlyInstrumentations2[method] = $f111f945f972b324$var$createIterableMethod(method, true, true);
    });
    return [
        mutableInstrumentations2,
        readonlyInstrumentations2,
        shallowInstrumentations2,
        shallowReadonlyInstrumentations2
    ];
}
var [$f111f945f972b324$var$mutableInstrumentations, $f111f945f972b324$var$readonlyInstrumentations, $f111f945f972b324$var$shallowInstrumentations, $f111f945f972b324$var$shallowReadonlyInstrumentations] = /* @__PURE__ */ $f111f945f972b324$var$createInstrumentations();
function $f111f945f972b324$var$createInstrumentationGetter(isReadonly, shallow) {
    const instrumentations = shallow ? isReadonly ? $f111f945f972b324$var$shallowReadonlyInstrumentations : $f111f945f972b324$var$shallowInstrumentations : isReadonly ? $f111f945f972b324$var$readonlyInstrumentations : $f111f945f972b324$var$mutableInstrumentations;
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw") return target;
        return Reflect.get($f111f945f972b324$var$hasOwn(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
var $f111f945f972b324$var$mutableCollectionHandlers = {
    get: /* @__PURE__ */ $f111f945f972b324$var$createInstrumentationGetter(false, false)
};
var $f111f945f972b324$var$readonlyCollectionHandlers = {
    get: /* @__PURE__ */ $f111f945f972b324$var$createInstrumentationGetter(true, false)
};
function $f111f945f972b324$var$checkIdentityKeys(target, has2, key) {
    const rawKey = $f111f945f972b324$var$toRaw(key);
    if (rawKey !== key && has2.call(target, rawKey)) {
        const type = $f111f945f972b324$var$toRawType(target);
        console.warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
var $f111f945f972b324$var$reactiveMap = /* @__PURE__ */ new WeakMap();
var $f111f945f972b324$var$shallowReactiveMap = /* @__PURE__ */ new WeakMap();
var $f111f945f972b324$var$readonlyMap = /* @__PURE__ */ new WeakMap();
var $f111f945f972b324$var$shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function $f111f945f972b324$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2;
        default:
            return 0;
    }
}
function $f111f945f972b324$var$getTargetType(value) {
    return value["__v_skip"] || !Object.isExtensible(value) ? 0 : $f111f945f972b324$var$targetTypeMap($f111f945f972b324$var$toRawType(value));
}
function $f111f945f972b324$var$reactive2(target) {
    if (target && target["__v_isReadonly"]) return target;
    return $f111f945f972b324$var$createReactiveObject(target, false, $f111f945f972b324$var$mutableHandlers, $f111f945f972b324$var$mutableCollectionHandlers, $f111f945f972b324$var$reactiveMap);
}
function $f111f945f972b324$var$readonly(target) {
    return $f111f945f972b324$var$createReactiveObject(target, true, $f111f945f972b324$var$readonlyHandlers, $f111f945f972b324$var$readonlyCollectionHandlers, $f111f945f972b324$var$readonlyMap);
}
function $f111f945f972b324$var$createReactiveObject(target, isReadonly, baseHandlers, collectionHandlers, proxyMap) {
    if (!$f111f945f972b324$var$isObject(target)) {
        console.warn(`value cannot be made reactive: ${String(target)}`);
        return target;
    }
    if (target["__v_raw"] && !(isReadonly && target["__v_isReactive"])) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const targetType = $f111f945f972b324$var$getTargetType(target);
    if (targetType === 0) return target;
    const proxy = new Proxy(target, targetType === 2 ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function $f111f945f972b324$var$toRaw(observed) {
    return observed && $f111f945f972b324$var$toRaw(observed["__v_raw"]) || observed;
}
function $f111f945f972b324$var$isRef(r) {
    return Boolean(r && r.__v_isRef === true);
}
// packages/alpinejs/src/magics/$nextTick.js
$f111f945f972b324$var$magic("nextTick", ()=>$f111f945f972b324$var$nextTick);
// packages/alpinejs/src/magics/$dispatch.js
$f111f945f972b324$var$magic("dispatch", (el)=>$f111f945f972b324$var$dispatch.bind($f111f945f972b324$var$dispatch, el));
// packages/alpinejs/src/magics/$watch.js
$f111f945f972b324$var$magic("watch", (el, { evaluateLater: evaluateLater2, effect: effect3 })=>(key, callback)=>{
        let evaluate2 = evaluateLater2(key);
        let firstTime = true;
        let oldValue;
        let effectReference = effect3(()=>evaluate2((value)=>{
                JSON.stringify(value);
                if (!firstTime) queueMicrotask(()=>{
                    callback(value, oldValue);
                    oldValue = value;
                });
                else oldValue = value;
                firstTime = false;
            }));
        el._x_effects.delete(effectReference);
    });
// packages/alpinejs/src/magics/$store.js
$f111f945f972b324$var$magic("store", $f111f945f972b324$var$getStores);
// packages/alpinejs/src/magics/$data.js
$f111f945f972b324$var$magic("data", (el)=>$f111f945f972b324$var$scope(el));
// packages/alpinejs/src/magics/$root.js
$f111f945f972b324$var$magic("root", (el)=>$f111f945f972b324$var$closestRoot(el));
// packages/alpinejs/src/magics/$refs.js
$f111f945f972b324$var$magic("refs", (el)=>{
    if (el._x_refs_proxy) return el._x_refs_proxy;
    el._x_refs_proxy = $f111f945f972b324$var$mergeProxies($f111f945f972b324$var$getArrayOfRefObject(el));
    return el._x_refs_proxy;
});
function $f111f945f972b324$var$getArrayOfRefObject(el) {
    let refObjects = [];
    let currentEl = el;
    while(currentEl){
        if (currentEl._x_refs) refObjects.push(currentEl._x_refs);
        currentEl = currentEl.parentNode;
    }
    return refObjects;
}
// packages/alpinejs/src/ids.js
var $f111f945f972b324$var$globalIdMemo = {};
function $f111f945f972b324$var$findAndIncrementId(name) {
    if (!$f111f945f972b324$var$globalIdMemo[name]) $f111f945f972b324$var$globalIdMemo[name] = 0;
    return ++$f111f945f972b324$var$globalIdMemo[name];
}
function $f111f945f972b324$var$closestIdRoot(el, name) {
    return $f111f945f972b324$var$findClosest(el, (element)=>{
        if (element._x_ids && element._x_ids[name]) return true;
    });
}
function $f111f945f972b324$var$setIdRoot(el, name) {
    if (!el._x_ids) el._x_ids = {};
    if (!el._x_ids[name]) el._x_ids[name] = $f111f945f972b324$var$findAndIncrementId(name);
}
// packages/alpinejs/src/magics/$id.js
$f111f945f972b324$var$magic("id", (el)=>(name, key = null)=>{
        let root = $f111f945f972b324$var$closestIdRoot(el, name);
        let id = root ? root._x_ids[name] : $f111f945f972b324$var$findAndIncrementId(name);
        return key ? `${name}-${id}-${key}` : `${name}-${id}`;
    });
// packages/alpinejs/src/magics/$el.js
$f111f945f972b324$var$magic("el", (el)=>el);
// packages/alpinejs/src/magics/index.js
$f111f945f972b324$var$warnMissingPluginMagic("Focus", "focus", "focus");
$f111f945f972b324$var$warnMissingPluginMagic("Persist", "persist", "persist");
function $f111f945f972b324$var$warnMissingPluginMagic(name, magicName, slug) {
    $f111f945f972b324$var$magic(magicName, (el)=>$f111f945f972b324$var$warn(`You can't use [$${magicName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/directives/x-modelable.js
$f111f945f972b324$var$directive("modelable", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2, cleanup: cleanup2 })=>{
    let func = evaluateLater2(expression);
    let innerGet = ()=>{
        let result;
        func((i)=>result = i);
        return result;
    };
    let evaluateInnerSet = evaluateLater2(`${expression} = __placeholder`);
    let innerSet = (val)=>evaluateInnerSet(()=>{}, {
            scope: {
                "__placeholder": val
            }
        });
    let initialValue = innerGet();
    innerSet(initialValue);
    queueMicrotask(()=>{
        if (!el._x_model) return;
        el._x_removeModelListeners["default"]();
        let outerGet = el._x_model.get;
        let outerSet = el._x_model.set;
        let releaseEntanglement = $f111f945f972b324$var$entangle({
            get () {
                return outerGet();
            },
            set (value) {
                outerSet(value);
            }
        }, {
            get () {
                return innerGet();
            },
            set (value) {
                innerSet(value);
            }
        });
        cleanup2(releaseEntanglement);
    });
});
// packages/alpinejs/src/directives/x-teleport.js
$f111f945f972b324$var$directive("teleport", (el, { modifiers: modifiers, expression: expression }, { cleanup: cleanup2 })=>{
    if (el.tagName.toLowerCase() !== "template") $f111f945f972b324$var$warn("x-teleport can only be used on a <template> tag", el);
    let target = $f111f945f972b324$var$getTarget(expression);
    let clone2 = el.content.cloneNode(true).firstElementChild;
    el._x_teleport = clone2;
    clone2._x_teleportBack = el;
    el.setAttribute("data-teleport-template", true);
    clone2.setAttribute("data-teleport-target", true);
    if (el._x_forwardEvents) el._x_forwardEvents.forEach((eventName)=>{
        clone2.addEventListener(eventName, (e)=>{
            e.stopPropagation();
            el.dispatchEvent(new e.constructor(e.type, e));
        });
    });
    $f111f945f972b324$var$addScopeToNode(clone2, {}, el);
    let placeInDom = (clone3, target2, modifiers2)=>{
        if (modifiers2.includes("prepend")) target2.parentNode.insertBefore(clone3, target2);
        else if (modifiers2.includes("append")) target2.parentNode.insertBefore(clone3, target2.nextSibling);
        else target2.appendChild(clone3);
    };
    $f111f945f972b324$var$mutateDom(()=>{
        placeInDom(clone2, target, modifiers);
        $f111f945f972b324$var$initTree(clone2);
        clone2._x_ignore = true;
    });
    el._x_teleportPutBack = ()=>{
        let target2 = $f111f945f972b324$var$getTarget(expression);
        $f111f945f972b324$var$mutateDom(()=>{
            placeInDom(el._x_teleport, target2, modifiers);
        });
    };
    cleanup2(()=>clone2.remove());
});
var $f111f945f972b324$var$teleportContainerDuringClone = document.createElement("div");
function $f111f945f972b324$var$getTarget(expression) {
    let target = $f111f945f972b324$var$skipDuringClone(()=>{
        return document.querySelector(expression);
    }, ()=>{
        return $f111f945f972b324$var$teleportContainerDuringClone;
    })();
    if (!target) $f111f945f972b324$var$warn(`Cannot find x-teleport element for selector: "${expression}"`);
    return target;
}
// packages/alpinejs/src/directives/x-ignore.js
var $f111f945f972b324$var$handler = ()=>{};
$f111f945f972b324$var$handler.inline = (el, { modifiers: modifiers }, { cleanup: cleanup2 })=>{
    modifiers.includes("self") ? el._x_ignoreSelf = true : el._x_ignore = true;
    cleanup2(()=>{
        modifiers.includes("self") ? delete el._x_ignoreSelf : delete el._x_ignore;
    });
};
$f111f945f972b324$var$directive("ignore", $f111f945f972b324$var$handler);
// packages/alpinejs/src/directives/x-effect.js
$f111f945f972b324$var$directive("effect", $f111f945f972b324$var$skipDuringClone((el, { expression: expression }, { effect: effect3 })=>{
    effect3($f111f945f972b324$var$evaluateLater(el, expression));
}));
// packages/alpinejs/src/utils/on.js
function $f111f945f972b324$var$on(el, event, modifiers, callback) {
    let listenerTarget = el;
    let handler4 = (e)=>callback(e);
    let options = {};
    let wrapHandler = (callback2, wrapper)=>(e)=>wrapper(callback2, e);
    if (modifiers.includes("dot")) event = $f111f945f972b324$var$dotSyntax(event);
    if (modifiers.includes("camel")) event = $f111f945f972b324$var$camelCase2(event);
    if (modifiers.includes("passive")) options.passive = true;
    if (modifiers.includes("capture")) options.capture = true;
    if (modifiers.includes("window")) listenerTarget = window;
    if (modifiers.includes("document")) listenerTarget = document;
    if (modifiers.includes("debounce")) {
        let nextModifier = modifiers[modifiers.indexOf("debounce") + 1] || "invalid-wait";
        let wait = $f111f945f972b324$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $f111f945f972b324$var$debounce(handler4, wait);
    }
    if (modifiers.includes("throttle")) {
        let nextModifier = modifiers[modifiers.indexOf("throttle") + 1] || "invalid-wait";
        let wait = $f111f945f972b324$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $f111f945f972b324$var$throttle(handler4, wait);
    }
    if (modifiers.includes("prevent")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.preventDefault();
        next(e);
    });
    if (modifiers.includes("stop")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.stopPropagation();
        next(e);
    });
    if (modifiers.includes("self")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.target === el && next(e);
    });
    if (modifiers.includes("away") || modifiers.includes("outside")) {
        listenerTarget = document;
        handler4 = wrapHandler(handler4, (next, e)=>{
            if (el.contains(e.target)) return;
            if (e.target.isConnected === false) return;
            if (el.offsetWidth < 1 && el.offsetHeight < 1) return;
            if (el._x_isShown === false) return;
            next(e);
        });
    }
    if (modifiers.includes("once")) handler4 = wrapHandler(handler4, (next, e)=>{
        next(e);
        listenerTarget.removeEventListener(event, handler4, options);
    });
    handler4 = wrapHandler(handler4, (next, e)=>{
        if ($f111f945f972b324$var$isKeyEvent(event)) {
            if ($f111f945f972b324$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers)) return;
        }
        next(e);
    });
    listenerTarget.addEventListener(event, handler4, options);
    return ()=>{
        listenerTarget.removeEventListener(event, handler4, options);
    };
}
function $f111f945f972b324$var$dotSyntax(subject) {
    return subject.replace(/-/g, ".");
}
function $f111f945f972b324$var$camelCase2(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $f111f945f972b324$var$isNumeric(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $f111f945f972b324$var$kebabCase2(subject) {
    if ([
        " ",
        "_"
    ].includes(subject)) return subject;
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[_\s]/, "-").toLowerCase();
}
function $f111f945f972b324$var$isKeyEvent(event) {
    return [
        "keydown",
        "keyup"
    ].includes(event);
}
function $f111f945f972b324$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers) {
    let keyModifiers = modifiers.filter((i)=>{
        return ![
            "window",
            "document",
            "prevent",
            "stop",
            "once",
            "capture"
        ].includes(i);
    });
    if (keyModifiers.includes("debounce")) {
        let debounceIndex = keyModifiers.indexOf("debounce");
        keyModifiers.splice(debounceIndex, $f111f945f972b324$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.includes("throttle")) {
        let debounceIndex = keyModifiers.indexOf("throttle");
        keyModifiers.splice(debounceIndex, $f111f945f972b324$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.length === 0) return false;
    if (keyModifiers.length === 1 && $f111f945f972b324$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
    const systemKeyModifiers = [
        "ctrl",
        "shift",
        "alt",
        "meta",
        "cmd",
        "super"
    ];
    const selectedSystemKeyModifiers = systemKeyModifiers.filter((modifier)=>keyModifiers.includes(modifier));
    keyModifiers = keyModifiers.filter((i)=>!selectedSystemKeyModifiers.includes(i));
    if (selectedSystemKeyModifiers.length > 0) {
        const activelyPressedKeyModifiers = selectedSystemKeyModifiers.filter((modifier)=>{
            if (modifier === "cmd" || modifier === "super") modifier = "meta";
            return e[`${modifier}Key`];
        });
        if (activelyPressedKeyModifiers.length === selectedSystemKeyModifiers.length) {
            if ($f111f945f972b324$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
        }
    }
    return true;
}
function $f111f945f972b324$var$keyToModifiers(key) {
    if (!key) return [];
    key = $f111f945f972b324$var$kebabCase2(key);
    let modifierToKeyMap = {
        "ctrl": "control",
        "slash": "/",
        "space": " ",
        "spacebar": " ",
        "cmd": "meta",
        "esc": "escape",
        "up": "arrow-up",
        "down": "arrow-down",
        "left": "arrow-left",
        "right": "arrow-right",
        "period": ".",
        "equal": "=",
        "minus": "-",
        "underscore": "_"
    };
    modifierToKeyMap[key] = key;
    return Object.keys(modifierToKeyMap).map((modifier)=>{
        if (modifierToKeyMap[modifier] === key) return modifier;
    }).filter((modifier)=>modifier);
}
// packages/alpinejs/src/directives/x-model.js
$f111f945f972b324$var$directive("model", (el, { modifiers: modifiers, expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let scopeTarget = el;
    if (modifiers.includes("parent")) scopeTarget = el.parentNode;
    let evaluateGet = $f111f945f972b324$var$evaluateLater(scopeTarget, expression);
    let evaluateSet;
    if (typeof expression === "string") evaluateSet = $f111f945f972b324$var$evaluateLater(scopeTarget, `${expression} = __placeholder`);
    else if (typeof expression === "function" && typeof expression() === "string") evaluateSet = $f111f945f972b324$var$evaluateLater(scopeTarget, `${expression()} = __placeholder`);
    else evaluateSet = ()=>{};
    let getValue = ()=>{
        let result;
        evaluateGet((value)=>result = value);
        return $f111f945f972b324$var$isGetterSetter(result) ? result.get() : result;
    };
    let setValue = (value)=>{
        let result;
        evaluateGet((value2)=>result = value2);
        if ($f111f945f972b324$var$isGetterSetter(result)) result.set(value);
        else evaluateSet(()=>{}, {
            scope: {
                "__placeholder": value
            }
        });
    };
    if (typeof expression === "string" && el.type === "radio") $f111f945f972b324$var$mutateDom(()=>{
        if (!el.hasAttribute("name")) el.setAttribute("name", expression);
    });
    var event = el.tagName.toLowerCase() === "select" || [
        "checkbox",
        "radio"
    ].includes(el.type) || modifiers.includes("lazy") ? "change" : "input";
    let removeListener = $f111f945f972b324$var$isCloning ? ()=>{} : $f111f945f972b324$var$on(el, event, modifiers, (e)=>{
        setValue($f111f945f972b324$var$getInputValue(el, modifiers, e, getValue()));
    });
    if (modifiers.includes("fill")) {
        if ([
            null,
            ""
        ].includes(getValue()) || el.type === "checkbox" && Array.isArray(getValue())) el.dispatchEvent(new Event(event, {}));
    }
    if (!el._x_removeModelListeners) el._x_removeModelListeners = {};
    el._x_removeModelListeners["default"] = removeListener;
    cleanup2(()=>el._x_removeModelListeners["default"]());
    if (el.form) {
        let removeResetListener = $f111f945f972b324$var$on(el.form, "reset", [], (e)=>{
            $f111f945f972b324$var$nextTick(()=>el._x_model && el._x_model.set(el.value));
        });
        cleanup2(()=>removeResetListener());
    }
    el._x_model = {
        get () {
            return getValue();
        },
        set (value) {
            setValue(value);
        }
    };
    el._x_forceModelUpdate = (value)=>{
        if (value === void 0 && typeof expression === "string" && expression.match(/\./)) value = "";
        window.fromModel = true;
        $f111f945f972b324$var$mutateDom(()=>$f111f945f972b324$var$bind(el, "value", value));
        delete window.fromModel;
    };
    effect3(()=>{
        let value = getValue();
        if (modifiers.includes("unintrusive") && document.activeElement.isSameNode(el)) return;
        el._x_forceModelUpdate(value);
    });
});
function $f111f945f972b324$var$getInputValue(el, modifiers, event, currentValue) {
    return $f111f945f972b324$var$mutateDom(()=>{
        if (event instanceof CustomEvent && event.detail !== void 0) return event.detail !== null && event.detail !== void 0 ? event.detail : event.target.value;
        else if (el.type === "checkbox") {
            if (Array.isArray(currentValue)) {
                let newValue = null;
                if (modifiers.includes("number")) newValue = $f111f945f972b324$var$safeParseNumber(event.target.value);
                else if (modifiers.includes("boolean")) newValue = $f111f945f972b324$var$safeParseBoolean(event.target.value);
                else newValue = event.target.value;
                return event.target.checked ? currentValue.concat([
                    newValue
                ]) : currentValue.filter((el2)=>!$f111f945f972b324$var$checkedAttrLooseCompare2(el2, newValue));
            } else return event.target.checked;
        } else if (el.tagName.toLowerCase() === "select" && el.multiple) {
            if (modifiers.includes("number")) return Array.from(event.target.selectedOptions).map((option)=>{
                let rawValue = option.value || option.text;
                return $f111f945f972b324$var$safeParseNumber(rawValue);
            });
            else if (modifiers.includes("boolean")) return Array.from(event.target.selectedOptions).map((option)=>{
                let rawValue = option.value || option.text;
                return $f111f945f972b324$var$safeParseBoolean(rawValue);
            });
            return Array.from(event.target.selectedOptions).map((option)=>{
                return option.value || option.text;
            });
        } else {
            if (modifiers.includes("number")) return $f111f945f972b324$var$safeParseNumber(event.target.value);
            else if (modifiers.includes("boolean")) return $f111f945f972b324$var$safeParseBoolean(event.target.value);
            return modifiers.includes("trim") ? event.target.value.trim() : event.target.value;
        }
    });
}
function $f111f945f972b324$var$safeParseNumber(rawValue) {
    let number = rawValue ? parseFloat(rawValue) : null;
    return $f111f945f972b324$var$isNumeric2(number) ? number : rawValue;
}
function $f111f945f972b324$var$checkedAttrLooseCompare2(valueA, valueB) {
    return valueA == valueB;
}
function $f111f945f972b324$var$isNumeric2(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $f111f945f972b324$var$isGetterSetter(value) {
    return value !== null && typeof value === "object" && typeof value.get === "function" && typeof value.set === "function";
}
// packages/alpinejs/src/directives/x-cloak.js
$f111f945f972b324$var$directive("cloak", (el)=>queueMicrotask(()=>$f111f945f972b324$var$mutateDom(()=>el.removeAttribute($f111f945f972b324$var$prefix("cloak")))));
// packages/alpinejs/src/directives/x-init.js
$f111f945f972b324$var$addInitSelector(()=>`[${$f111f945f972b324$var$prefix("init")}]`);
$f111f945f972b324$var$directive("init", $f111f945f972b324$var$skipDuringClone((el, { expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "string") return !!expression.trim() && evaluate2(expression, {}, false);
    return evaluate2(expression, {}, false);
}));
// packages/alpinejs/src/directives/x-text.js
$f111f945f972b324$var$directive("text", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $f111f945f972b324$var$mutateDom(()=>{
                el.textContent = value;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-html.js
$f111f945f972b324$var$directive("html", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $f111f945f972b324$var$mutateDom(()=>{
                el.innerHTML = value;
                el._x_ignoreSelf = true;
                $f111f945f972b324$var$initTree(el);
                delete el._x_ignoreSelf;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-bind.js
$f111f945f972b324$var$mapAttributes($f111f945f972b324$var$startingWith(":", $f111f945f972b324$var$into($f111f945f972b324$var$prefix("bind:"))));
var $f111f945f972b324$var$handler2 = (el, { value: value, modifiers: modifiers, expression: expression, original: original }, { effect: effect3 })=>{
    if (!value) {
        let bindingProviders = {};
        $f111f945f972b324$var$injectBindingProviders(bindingProviders);
        let getBindings = $f111f945f972b324$var$evaluateLater(el, expression);
        getBindings((bindings)=>{
            $f111f945f972b324$var$applyBindingsObject(el, bindings, original);
        }, {
            scope: bindingProviders
        });
        return;
    }
    if (value === "key") return $f111f945f972b324$var$storeKeyForXFor(el, expression);
    if (el._x_inlineBindings && el._x_inlineBindings[value] && el._x_inlineBindings[value].extract) return;
    let evaluate2 = $f111f945f972b324$var$evaluateLater(el, expression);
    effect3(()=>evaluate2((result)=>{
            if (result === void 0 && typeof expression === "string" && expression.match(/\./)) result = "";
            $f111f945f972b324$var$mutateDom(()=>$f111f945f972b324$var$bind(el, value, result, modifiers));
        }));
};
$f111f945f972b324$var$handler2.inline = (el, { value: value, modifiers: modifiers, expression: expression })=>{
    if (!value) return;
    if (!el._x_inlineBindings) el._x_inlineBindings = {};
    el._x_inlineBindings[value] = {
        expression: expression,
        extract: false
    };
};
$f111f945f972b324$var$directive("bind", $f111f945f972b324$var$handler2);
function $f111f945f972b324$var$storeKeyForXFor(el, expression) {
    el._x_keyExpression = expression;
}
// packages/alpinejs/src/directives/x-data.js
$f111f945f972b324$var$addRootSelector(()=>`[${$f111f945f972b324$var$prefix("data")}]`);
$f111f945f972b324$var$directive("data", (el, { expression: expression }, { cleanup: cleanup2 })=>{
    if ($f111f945f972b324$var$shouldSkipRegisteringDataDuringClone(el)) return;
    expression = expression === "" ? "{}" : expression;
    let magicContext = {};
    $f111f945f972b324$var$injectMagics(magicContext, el);
    let dataProviderContext = {};
    $f111f945f972b324$var$injectDataProviders(dataProviderContext, magicContext);
    let data2 = $f111f945f972b324$var$evaluate(el, expression, {
        scope: dataProviderContext
    });
    if (data2 === void 0 || data2 === true) data2 = {};
    $f111f945f972b324$var$injectMagics(data2, el);
    let reactiveData = $f111f945f972b324$var$reactive(data2);
    $f111f945f972b324$var$initInterceptors2(reactiveData);
    let undo = $f111f945f972b324$var$addScopeToNode(el, reactiveData);
    reactiveData["init"] && $f111f945f972b324$var$evaluate(el, reactiveData["init"]);
    cleanup2(()=>{
        reactiveData["destroy"] && $f111f945f972b324$var$evaluate(el, reactiveData["destroy"]);
        undo();
    });
});
$f111f945f972b324$var$interceptClone((from, to)=>{
    if (from._x_dataStack) {
        to._x_dataStack = from._x_dataStack;
        to.setAttribute("data-has-alpine-state", true);
    }
});
function $f111f945f972b324$var$shouldSkipRegisteringDataDuringClone(el) {
    if (!$f111f945f972b324$var$isCloning) return false;
    if ($f111f945f972b324$var$isCloningLegacy) return true;
    return el.hasAttribute("data-has-alpine-state");
}
// packages/alpinejs/src/directives/x-show.js
$f111f945f972b324$var$directive("show", (el, { modifiers: modifiers, expression: expression }, { effect: effect3 })=>{
    let evaluate2 = $f111f945f972b324$var$evaluateLater(el, expression);
    if (!el._x_doHide) el._x_doHide = ()=>{
        $f111f945f972b324$var$mutateDom(()=>{
            el.style.setProperty("display", "none", modifiers.includes("important") ? "important" : void 0);
        });
    };
    if (!el._x_doShow) el._x_doShow = ()=>{
        $f111f945f972b324$var$mutateDom(()=>{
            if (el.style.length === 1 && el.style.display === "none") el.removeAttribute("style");
            else el.style.removeProperty("display");
        });
    };
    let hide = ()=>{
        el._x_doHide();
        el._x_isShown = false;
    };
    let show = ()=>{
        el._x_doShow();
        el._x_isShown = true;
    };
    let clickAwayCompatibleShow = ()=>setTimeout(show);
    let toggle = $f111f945f972b324$var$once((value)=>value ? show() : hide(), (value)=>{
        if (typeof el._x_toggleAndCascadeWithTransitions === "function") el._x_toggleAndCascadeWithTransitions(el, value, show, hide);
        else value ? clickAwayCompatibleShow() : hide();
    });
    let oldValue;
    let firstTime = true;
    effect3(()=>evaluate2((value)=>{
            if (!firstTime && value === oldValue) return;
            if (modifiers.includes("immediate")) value ? clickAwayCompatibleShow() : hide();
            toggle(value);
            oldValue = value;
            firstTime = false;
        }));
});
// packages/alpinejs/src/directives/x-for.js
$f111f945f972b324$var$directive("for", (el, { expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let iteratorNames = $f111f945f972b324$var$parseForExpression(expression);
    let evaluateItems = $f111f945f972b324$var$evaluateLater(el, iteratorNames.items);
    let evaluateKey = $f111f945f972b324$var$evaluateLater(el, // the x-bind:key expression is stored for our use instead of evaluated.
    el._x_keyExpression || "index");
    el._x_prevKeys = [];
    el._x_lookup = {};
    effect3(()=>$f111f945f972b324$var$loop(el, iteratorNames, evaluateItems, evaluateKey));
    cleanup2(()=>{
        Object.values(el._x_lookup).forEach((el2)=>el2.remove());
        delete el._x_prevKeys;
        delete el._x_lookup;
    });
});
function $f111f945f972b324$var$loop(el, iteratorNames, evaluateItems, evaluateKey) {
    let isObject2 = (i)=>typeof i === "object" && !Array.isArray(i);
    let templateEl = el;
    evaluateItems((items)=>{
        if ($f111f945f972b324$var$isNumeric3(items) && items >= 0) items = Array.from(Array(items).keys(), (i)=>i + 1);
        if (items === void 0) items = [];
        let lookup = el._x_lookup;
        let prevKeys = el._x_prevKeys;
        let scopes = [];
        let keys = [];
        if (isObject2(items)) items = Object.entries(items).map(([key, value])=>{
            let scope2 = $f111f945f972b324$var$getIterationScopeVariables(iteratorNames, value, key, items);
            evaluateKey((value2)=>keys.push(value2), {
                scope: {
                    index: key,
                    ...scope2
                }
            });
            scopes.push(scope2);
        });
        else for(let i = 0; i < items.length; i++){
            let scope2 = $f111f945f972b324$var$getIterationScopeVariables(iteratorNames, items[i], i, items);
            evaluateKey((value)=>keys.push(value), {
                scope: {
                    index: i,
                    ...scope2
                }
            });
            scopes.push(scope2);
        }
        let adds = [];
        let moves = [];
        let removes = [];
        let sames = [];
        for(let i = 0; i < prevKeys.length; i++){
            let key = prevKeys[i];
            if (keys.indexOf(key) === -1) removes.push(key);
        }
        prevKeys = prevKeys.filter((key)=>!removes.includes(key));
        let lastKey = "template";
        for(let i = 0; i < keys.length; i++){
            let key = keys[i];
            let prevIndex = prevKeys.indexOf(key);
            if (prevIndex === -1) {
                prevKeys.splice(i, 0, key);
                adds.push([
                    lastKey,
                    i
                ]);
            } else if (prevIndex !== i) {
                let keyInSpot = prevKeys.splice(i, 1)[0];
                let keyForSpot = prevKeys.splice(prevIndex - 1, 1)[0];
                prevKeys.splice(i, 0, keyForSpot);
                prevKeys.splice(prevIndex, 0, keyInSpot);
                moves.push([
                    keyInSpot,
                    keyForSpot
                ]);
            } else sames.push(key);
            lastKey = key;
        }
        for(let i = 0; i < removes.length; i++){
            let key = removes[i];
            if (!!lookup[key]._x_effects) lookup[key]._x_effects.forEach($f111f945f972b324$var$dequeueJob);
            lookup[key].remove();
            lookup[key] = null;
            delete lookup[key];
        }
        for(let i = 0; i < moves.length; i++){
            let [keyInSpot, keyForSpot] = moves[i];
            let elInSpot = lookup[keyInSpot];
            let elForSpot = lookup[keyForSpot];
            let marker = document.createElement("div");
            $f111f945f972b324$var$mutateDom(()=>{
                if (!elForSpot) $f111f945f972b324$var$warn(`x-for ":key" is undefined or invalid`, templateEl);
                elForSpot.after(marker);
                elInSpot.after(elForSpot);
                elForSpot._x_currentIfEl && elForSpot.after(elForSpot._x_currentIfEl);
                marker.before(elInSpot);
                elInSpot._x_currentIfEl && elInSpot.after(elInSpot._x_currentIfEl);
                marker.remove();
            });
            elForSpot._x_refreshXForScope(scopes[keys.indexOf(keyForSpot)]);
        }
        for(let i = 0; i < adds.length; i++){
            let [lastKey2, index] = adds[i];
            let lastEl = lastKey2 === "template" ? templateEl : lookup[lastKey2];
            if (lastEl._x_currentIfEl) lastEl = lastEl._x_currentIfEl;
            let scope2 = scopes[index];
            let key = keys[index];
            let clone2 = document.importNode(templateEl.content, true).firstElementChild;
            let reactiveScope = $f111f945f972b324$var$reactive(scope2);
            $f111f945f972b324$var$addScopeToNode(clone2, reactiveScope, templateEl);
            clone2._x_refreshXForScope = (newScope)=>{
                Object.entries(newScope).forEach(([key2, value])=>{
                    reactiveScope[key2] = value;
                });
            };
            $f111f945f972b324$var$mutateDom(()=>{
                lastEl.after(clone2);
                $f111f945f972b324$var$initTree(clone2);
            });
            if (typeof key === "object") $f111f945f972b324$var$warn("x-for key cannot be an object, it must be a string or an integer", templateEl);
            lookup[key] = clone2;
        }
        for(let i = 0; i < sames.length; i++)lookup[sames[i]]._x_refreshXForScope(scopes[keys.indexOf(sames[i])]);
        templateEl._x_prevKeys = keys;
    });
}
function $f111f945f972b324$var$parseForExpression(expression) {
    let forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
    let stripParensRE = /^\s*\(|\)\s*$/g;
    let forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
    let inMatch = expression.match(forAliasRE);
    if (!inMatch) return;
    let res = {};
    res.items = inMatch[2].trim();
    let item = inMatch[1].replace(stripParensRE, "").trim();
    let iteratorMatch = item.match(forIteratorRE);
    if (iteratorMatch) {
        res.item = item.replace(forIteratorRE, "").trim();
        res.index = iteratorMatch[1].trim();
        if (iteratorMatch[2]) res.collection = iteratorMatch[2].trim();
    } else res.item = item;
    return res;
}
function $f111f945f972b324$var$getIterationScopeVariables(iteratorNames, item, index, items) {
    let scopeVariables = {};
    if (/^\[.*\]$/.test(iteratorNames.item) && Array.isArray(item)) {
        let names = iteratorNames.item.replace("[", "").replace("]", "").split(",").map((i)=>i.trim());
        names.forEach((name, i)=>{
            scopeVariables[name] = item[i];
        });
    } else if (/^\{.*\}$/.test(iteratorNames.item) && !Array.isArray(item) && typeof item === "object") {
        let names = iteratorNames.item.replace("{", "").replace("}", "").split(",").map((i)=>i.trim());
        names.forEach((name)=>{
            scopeVariables[name] = item[name];
        });
    } else scopeVariables[iteratorNames.item] = item;
    if (iteratorNames.index) scopeVariables[iteratorNames.index] = index;
    if (iteratorNames.collection) scopeVariables[iteratorNames.collection] = items;
    return scopeVariables;
}
function $f111f945f972b324$var$isNumeric3(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
// packages/alpinejs/src/directives/x-ref.js
function $f111f945f972b324$var$handler3() {}
$f111f945f972b324$var$handler3.inline = (el, { expression: expression }, { cleanup: cleanup2 })=>{
    let root = $f111f945f972b324$var$closestRoot(el);
    if (!root._x_refs) root._x_refs = {};
    root._x_refs[expression] = el;
    cleanup2(()=>delete root._x_refs[expression]);
};
$f111f945f972b324$var$directive("ref", $f111f945f972b324$var$handler3);
// packages/alpinejs/src/directives/x-if.js
$f111f945f972b324$var$directive("if", (el, { expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    if (el.tagName.toLowerCase() !== "template") $f111f945f972b324$var$warn("x-if can only be used on a <template> tag", el);
    let evaluate2 = $f111f945f972b324$var$evaluateLater(el, expression);
    let show = ()=>{
        if (el._x_currentIfEl) return el._x_currentIfEl;
        let clone2 = el.content.cloneNode(true).firstElementChild;
        $f111f945f972b324$var$addScopeToNode(clone2, {}, el);
        $f111f945f972b324$var$mutateDom(()=>{
            el.after(clone2);
            $f111f945f972b324$var$initTree(clone2);
        });
        el._x_currentIfEl = clone2;
        el._x_undoIf = ()=>{
            $f111f945f972b324$var$walk(clone2, (node)=>{
                if (!!node._x_effects) node._x_effects.forEach($f111f945f972b324$var$dequeueJob);
            });
            clone2.remove();
            delete el._x_currentIfEl;
        };
        return clone2;
    };
    let hide = ()=>{
        if (!el._x_undoIf) return;
        el._x_undoIf();
        delete el._x_undoIf;
    };
    effect3(()=>evaluate2((value)=>{
            value ? show() : hide();
        }));
    cleanup2(()=>el._x_undoIf && el._x_undoIf());
});
// packages/alpinejs/src/directives/x-id.js
$f111f945f972b324$var$directive("id", (el, { expression: expression }, { evaluate: evaluate2 })=>{
    let names = evaluate2(expression);
    names.forEach((name)=>$f111f945f972b324$var$setIdRoot(el, name));
});
// packages/alpinejs/src/directives/x-on.js
$f111f945f972b324$var$mapAttributes($f111f945f972b324$var$startingWith("@", $f111f945f972b324$var$into($f111f945f972b324$var$prefix("on:"))));
$f111f945f972b324$var$directive("on", $f111f945f972b324$var$skipDuringClone((el, { value: value, modifiers: modifiers, expression: expression }, { cleanup: cleanup2 })=>{
    let evaluate2 = expression ? $f111f945f972b324$var$evaluateLater(el, expression) : ()=>{};
    if (el.tagName.toLowerCase() === "template") {
        if (!el._x_forwardEvents) el._x_forwardEvents = [];
        if (!el._x_forwardEvents.includes(value)) el._x_forwardEvents.push(value);
    }
    let removeListener = $f111f945f972b324$var$on(el, value, modifiers, (e)=>{
        evaluate2(()=>{}, {
            scope: {
                "$event": e
            },
            params: [
                e
            ]
        });
    });
    cleanup2(()=>removeListener());
}));
// packages/alpinejs/src/directives/index.js
$f111f945f972b324$var$warnMissingPluginDirective("Collapse", "collapse", "collapse");
$f111f945f972b324$var$warnMissingPluginDirective("Intersect", "intersect", "intersect");
$f111f945f972b324$var$warnMissingPluginDirective("Focus", "trap", "focus");
$f111f945f972b324$var$warnMissingPluginDirective("Mask", "mask", "mask");
function $f111f945f972b324$var$warnMissingPluginDirective(name, directiveName, slug) {
    $f111f945f972b324$var$directive(directiveName, (el)=>$f111f945f972b324$var$warn(`You can't use [x-${directiveName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/index.js
$f111f945f972b324$var$alpine_default.setEvaluator($f111f945f972b324$var$normalEvaluator);
$f111f945f972b324$var$alpine_default.setReactivityEngine({
    reactive: $f111f945f972b324$var$reactive2,
    effect: $f111f945f972b324$var$effect2,
    release: $f111f945f972b324$var$stop,
    raw: $f111f945f972b324$var$toRaw
});
var $f111f945f972b324$var$src_default = $f111f945f972b324$var$alpine_default;
// packages/alpinejs/builds/module.js
var $f111f945f972b324$export$2e2bcd8739ae039 = $f111f945f972b324$var$src_default;


const $a7539de1d140ddd7$export$86fbec116b87613f = (fn)=>{
    if (document.readyState != "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
};
var $a7539de1d140ddd7$export$2e2bcd8739ae039 = $a7539de1d140ddd7$export$86fbec116b87613f;


/*!
 * Mmenu Light
 * mmenujs.com/mmenu-light
 *
 * Copyright (c) Fred Heusschen
 * www.frebsite.nl
 *
 * License: CC-BY-4.0
 * http://creativecommons.org/licenses/by/4.0/
 */ //	The module
/**
 * Class for a match media toggler.
 */ var $e9a7650f9edc633d$var$MmToggler = /** @class */ function() {
    /**
     * Create the match media.
     *
     * @param {string} mediaquery Media query to use.
     */ function MmToggler(mediaquery) {
        var _this = this;
        this.listener = function(evnt) {
            (evnt.matches ? _this.matchFns : _this.unmatchFns).forEach(function(listener) {
                listener();
            });
        };
        this.toggler = window.matchMedia(mediaquery);
        this.toggler.addListener(this.listener);
        this.matchFns = [];
        this.unmatchFns = [];
    }
    /**
     * Add a function to the list,
     * also fires the added function.
     *
     * @param {Function} match      Function to fire when the media query matches.
     * @param {Function} unmatch    Function to fire when the media query does not match.
     */ MmToggler.prototype.add = function(match, unmatch) {
        this.matchFns.push(match);
        this.unmatchFns.push(unmatch);
        (this.toggler.matches ? match : unmatch)();
    };
    return MmToggler;
}();
var $e9a7650f9edc633d$export$2e2bcd8739ae039 = $e9a7650f9edc633d$var$MmToggler;


/**
 * Convert a list to an array.
 *
 * @param 	{NodeList|HTMLCollection} list 	The list or collection to convert into an array.
 * @return	{array}							The array.
 */ var $d7677316a8c6addf$export$43caf9889c228507 = function(list) {
    return Array.prototype.slice.call(list);
};
var $d7677316a8c6addf$export$3d8c2f653ac9d0b9 = function(selector, context) {
    return $d7677316a8c6addf$export$43caf9889c228507((context || document).querySelectorAll(selector));
};


var $5ec059fed8aecdee$var$prefix = "mm-spn";
/**
 * Class for navigating in a mobile menu.
 */ var $5ec059fed8aecdee$var$MmSlidingPanelsNavigation = /** @class */ function() {
    /**
     * Class for navigating in a mobile menu.
     *
     * @param {HTMLElement} node            HTMLElement for the menu.
     * @param {string}      title           The title for the menu.
     * @param {string}      selectedClass   The class for selected listitems.
     * @param {boolean}     slidingSubmenus Whether or not to use sliding submenus.
     * @param {string}      theme           The color scheme for the menu.
     */ function MmSlidingPanelsNavigation(node, title, selectedClass, slidingSubmenus, theme) {
        this.node = node;
        this.title = title;
        this.slidingSubmenus = slidingSubmenus;
        this.selectedClass = selectedClass;
        //  Add classname.
        this.node.classList.add($5ec059fed8aecdee$var$prefix);
        this.node.classList.add($5ec059fed8aecdee$var$prefix + "--" + theme);
        this.node.classList.add($5ec059fed8aecdee$var$prefix + "--" + (this.slidingSubmenus ? "navbar" : "vertical"));
        this._setSelectedl();
        this._initAnchors();
    }
    Object.defineProperty(MmSlidingPanelsNavigation.prototype, "prefix", {
        /** Prefix for the class. */ get: function() {
            return $5ec059fed8aecdee$var$prefix;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Open the given panel.
     *
     * @param {HTMLElement} panel Panel to open.
     */ MmSlidingPanelsNavigation.prototype.openPanel = function(panel) {
        /** Parent LI for the panel.  */ var listitem = panel.parentElement;
        //  Sliding submenus
        if (this.slidingSubmenus) {
            /** Title above the panel to open. */ var title_1 = panel.dataset.mmSpnTitle;
            //  Opening the main level UL.
            if (listitem === this.node) this.node.classList.add($5ec059fed8aecdee$var$prefix + "--main");
            else {
                this.node.classList.remove($5ec059fed8aecdee$var$prefix + "--main");
                //  Find title from parent LI.
                if (!title_1) (0, $d7677316a8c6addf$export$43caf9889c228507)(listitem.children).forEach(function(child) {
                    if (child.matches("a, span")) title_1 = child.textContent;
                });
            }
            //  Use the default title.
            if (!title_1) title_1 = this.title;
            //  Set the title.
            this.node.dataset.mmSpnTitle = title_1;
            //  Unset all panels from being opened and parent.
            (0, $d7677316a8c6addf$export$3d8c2f653ac9d0b9)("." + $5ec059fed8aecdee$var$prefix + "--open", this.node).forEach(function(open) {
                open.classList.remove($5ec059fed8aecdee$var$prefix + "--open");
                open.classList.remove($5ec059fed8aecdee$var$prefix + "--parent");
            });
            //  Set the current panel as being opened.
            panel.classList.add($5ec059fed8aecdee$var$prefix + "--open");
            panel.classList.remove($5ec059fed8aecdee$var$prefix + "--parent");
            //  Set all parent panels as being parent.
            var parent_1 = panel.parentElement.closest("ul");
            while(parent_1){
                parent_1.classList.add($5ec059fed8aecdee$var$prefix + "--open");
                parent_1.classList.add($5ec059fed8aecdee$var$prefix + "--parent");
                parent_1 = parent_1.parentElement.closest("ul");
            }
        } else {
            /** Whether or not the panel is currently opened. */ var isOpened = panel.matches("." + $5ec059fed8aecdee$var$prefix + "--open");
            //  Unset all panels from being opened and parent.
            (0, $d7677316a8c6addf$export$3d8c2f653ac9d0b9)("." + $5ec059fed8aecdee$var$prefix + "--open", this.node).forEach(function(open) {
                open.classList.remove($5ec059fed8aecdee$var$prefix + "--open");
            });
            //  Toggle the current panel.
            panel.classList[isOpened ? "remove" : "add"]($5ec059fed8aecdee$var$prefix + "--open");
            //  Set all parent panels as being opened.
            var parent_2 = panel.parentElement.closest("ul");
            while(parent_2){
                parent_2.classList.add($5ec059fed8aecdee$var$prefix + "--open");
                parent_2 = parent_2.parentElement.closest("ul");
            }
        }
    };
    /**
     * Initiate the selected listitem / open the current panel.
     */ MmSlidingPanelsNavigation.prototype._setSelectedl = function() {
        /** All selected LIs. */ var listitems = (0, $d7677316a8c6addf$export$3d8c2f653ac9d0b9)("." + this.selectedClass, this.node);
        /** The last selected LI. */ var listitem = listitems[listitems.length - 1];
        /** The opened UL. */ var panel = null;
        if (listitem) panel = listitem.closest("ul");
        if (!panel) panel = this.node.querySelector("ul");
        this.openPanel(panel);
    };
    /**
     * Initialize the click event handlers.
     */ MmSlidingPanelsNavigation.prototype._initAnchors = function() {
        var _this = this;
        /**
         * Clicking an A in the menu: prevent bubbling up to the LI.
         *
         * @param   {HTMLElement}    target The clicked element.
         * @return  {boolean}       handled Whether or not the event was handled.
         */ var clickAnchor = function(target) {
            if (target.matches("a")) return true;
            return false;
        };
        /**
         * Click a LI or SPAN in the menu: open its submenu (if present).
         *
         * @param   {HTMLElement}    target The clicked element.
         * @return  {boolean}               Whether or not the event was handled.
         */ var openSubmenu = function(target) {
            /** Parent listitem for the submenu.  */ var listitem;
            //  Find the parent listitem.
            if (target.closest("span")) listitem = target.parentElement;
            else if (target.closest("li")) listitem = target;
            else listitem = false;
            if (listitem) {
                (0, $d7677316a8c6addf$export$43caf9889c228507)(listitem.children).forEach(function(panel) {
                    if (panel.matches("ul")) _this.openPanel(panel);
                });
                return true;
            }
            return false;
        };
        /**
         * Click the menu (the navbar): close the last opened submenu.
         *
         * @param   {HTMLElement}    target The clicked element.
         * @return  {boolean}               Whether or not the event was handled.
         */ var closeSubmenu = function(target) {
            /** The opened ULs. */ var panels = (0, $d7677316a8c6addf$export$3d8c2f653ac9d0b9)("." + $5ec059fed8aecdee$var$prefix + "--open", target);
            /** The last opened UL. */ var panel = panels[panels.length - 1];
            if (panel) {
                /** The second to last opened UL. */ var parent_3 = panel.parentElement.closest("ul");
                if (parent_3) {
                    _this.openPanel(parent_3);
                    return true;
                }
            }
            return false;
        };
        this.node.addEventListener("click", function(evnt) {
            var target = evnt.target;
            var handled = false;
            handled = handled || clickAnchor(target);
            handled = handled || openSubmenu(target);
            handled = handled || closeSubmenu(target);
            if (handled) evnt.stopImmediatePropagation();
        });
    };
    return MmSlidingPanelsNavigation;
}();
var $5ec059fed8aecdee$export$2e2bcd8739ae039 = $5ec059fed8aecdee$var$MmSlidingPanelsNavigation;


var $3abf6dfb44642550$var$prefix = "mm-ocd";
/**
 * Class for off-canvas behavior.
 */ var $3abf6dfb44642550$var$MmOffCanvasDrawer = /** @class */ function() {
    /**
     * Class for off-canvas drawer.
     *
     * @param {HTMLElement} [node]          The element to put in the drawer.
     * @param {String}      [position=left] The position of the drawer, can be "left" or "right".
     */ function MmOffCanvasDrawer(node, position) {
        var _this = this;
        if (node === void 0) node = null;
        //  Create the wrapper.
        this.wrapper = document.createElement("div");
        this.wrapper.classList.add("" + $3abf6dfb44642550$var$prefix);
        this.wrapper.classList.add($3abf6dfb44642550$var$prefix + "--" + position);
        //  Create the drawer.
        this.content = document.createElement("div");
        this.content.classList.add($3abf6dfb44642550$var$prefix + "__content");
        this.wrapper.append(this.content);
        //  Create the backdrop.
        this.backdrop = document.createElement("div");
        this.backdrop.classList.add($3abf6dfb44642550$var$prefix + "__backdrop");
        this.wrapper.append(this.backdrop);
        //  Add the nodes to the <body>.
        document.body.append(this.wrapper);
        if (node) this.content.append(node);
        //  Click the backdrop.
        var close = function(evnt) {
            _this.close();
            evnt.stopImmediatePropagation();
        };
        this.backdrop.addEventListener("touchstart", close, {
            passive: true
        });
        this.backdrop.addEventListener("mousedown", close, {
            passive: true
        });
    }
    Object.defineProperty(MmOffCanvasDrawer.prototype, "prefix", {
        /** Prefix for the class. */ get: function() {
            return $3abf6dfb44642550$var$prefix;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Open the drawer.
     */ MmOffCanvasDrawer.prototype.open = function() {
        this.wrapper.classList.add($3abf6dfb44642550$var$prefix + "--open");
        document.body.classList.add($3abf6dfb44642550$var$prefix + "-opened");
    };
    /**
     * Close the drawer.
     */ MmOffCanvasDrawer.prototype.close = function() {
        this.wrapper.classList.remove($3abf6dfb44642550$var$prefix + "--open");
        document.body.classList.remove($3abf6dfb44642550$var$prefix + "-opened");
    };
    return MmOffCanvasDrawer;
}();
var $3abf6dfb44642550$export$2e2bcd8739ae039 = $3abf6dfb44642550$var$MmOffCanvasDrawer;


/**
 * Class for a lightweight mobile menu.
 */ var $641107e8558fba76$var$MmenuLight = /** @class */ function() {
    /**
     * Create a lightweight mobile menu.
     *
     * @param {HTMLElement} menu                HTML element for the menu.
     * @param {string}      [mediaQuery='all']  Media queury to match for the menu.
     */ function MmenuLight(menu, mediaQuery) {
        if (mediaQuery === void 0) mediaQuery = "all";
        //  Store the menu node.
        this.menu = menu;
        //  Create the toggler instance.
        this.toggler = new (0, $e9a7650f9edc633d$export$2e2bcd8739ae039)(mediaQuery);
    }
    /**
     * Add navigation for the menu.
     *
     * @param {object} options Options for the navigation.
     */ MmenuLight.prototype.navigation = function(options) {
        var _this = this;
        //  Only needs to be done ones.
        if (!this.navigator) {
            options = options || {};
            var _a = options.title, title = _a === void 0 ? "Menu" : _a, _b = options.selectedClass, selectedClass = _b === void 0 ? "Selected" : _b, _c = options.slidingSubmenus, slidingSubmenus = _c === void 0 ? true : _c, _d = options.theme, theme = _d === void 0 ? "light" : _d;
            this.navigator = new (0, $5ec059fed8aecdee$export$2e2bcd8739ae039)(this.menu, title, selectedClass, slidingSubmenus, theme);
            //  En-/disable
            this.toggler.add(function() {
                return _this.menu.classList.add(_this.navigator.prefix);
            }, function() {
                return _this.menu.classList.remove(_this.navigator.prefix);
            });
        }
        return this.navigator;
    };
    /**
     * Add off-canvas behavior to the menu.
     *
     * @param {object} options Options for the off-canvas drawer.
     */ MmenuLight.prototype.offcanvas = function(options) {
        var _this = this;
        //  Only needs to be done ones.
        if (!this.drawer) {
            options = options || {};
            var _a = options.position, position = _a === void 0 ? "left" : _a;
            this.drawer = new (0, $3abf6dfb44642550$export$2e2bcd8739ae039)(null, position);
            /** Original location in the DOM for the menu. */ var orgLocation_1 = document.createComment("original menu location");
            this.menu.after(orgLocation_1);
            //  En-/disable
            this.toggler.add(function() {
                // Move the menu to the drawer.
                _this.drawer.content.append(_this.menu);
            }, function() {
                // Close the drawer.
                _this.drawer.close();
                // Move the menu to the original position.
                orgLocation_1.after(_this.menu);
            });
        }
        return this.drawer;
    };
    return MmenuLight;
}();
var $641107e8558fba76$export$2e2bcd8739ae039 = $641107e8558fba76$var$MmenuLight;


var //  Export module
$e6a2f7a4a514e817$export$2e2bcd8739ae039 = (0, $641107e8558fba76$export$2e2bcd8739ae039);
//	Global namespace
window.MmenuLight = (0, $641107e8558fba76$export$2e2bcd8739ae039);


function $3c3eaba7ed460a04$export$b61d4be8ddba9539() {
    console.debug("Lade MobileMenu.");
    var element = document.querySelector("#menu");
    console.debug(element);
    if (!element) return;
    const menu = new (0, $e6a2f7a4a514e817$export$2e2bcd8739ae039)(element, "(max-width: 1024px)");
    const navigator = menu.navigation({
    });
    const drawer = menu.offcanvas({
    });
    document.querySelector('a[href="#menu"]')?.addEventListener("click", (evnt)=>{
        console.log("click!");
        evnt.preventDefault();
        drawer.open();
    });
}


// import function to register Swiper custom elements
// import { register } from 'swiper/swiper-element-bundle.mjs';
// register Swiper custom elements
function $844a571b0bb01553$export$d8cf031a7c97f17b() {
// register();
}


function $225372f33665d118$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $67c84f7b9d68974e$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $225372f33665d118$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $67c84f7b9d68974e$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $225372f33665d118$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $67c84f7b9d68974e$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, $225372f33665d118$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


var $e0beaf1fc26deee3$export$8960430cfd85939f = Math.max;
var $e0beaf1fc26deee3$export$96ec731ed4dcb222 = Math.min;
var $e0beaf1fc26deee3$export$2077e0241d6afd3c = Math.round;



function $6394c1ff52742048$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(" ");
    return navigator.userAgent;
}


function $df11fd8e9d8c1389$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $6394c1ff52742048$export$2e2bcd8739ae039)());
}


function $1a6f7dd7003a50a1$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $67c84f7b9d68974e$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $e0beaf1fc26deee3$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $e0beaf1fc26deee3$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $67c84f7b9d68974e$export$45a5e7f76e0caa8d)(element) ? (0, $225372f33665d118$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $df11fd8e9d8c1389$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}



function $1ed31100e25348a7$export$2e2bcd8739ae039(node) {
    var win = (0, $225372f33665d118$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}




function $729cc555c22ff063$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $bfa783b4c9ad111f$export$2e2bcd8739ae039(node) {
    if (node === (0, $225372f33665d118$export$2e2bcd8739ae039)(node) || !(0, $67c84f7b9d68974e$export$1b3bfaa9684536aa)(node)) return (0, $1ed31100e25348a7$export$2e2bcd8739ae039)(node);
    else return (0, $729cc555c22ff063$export$2e2bcd8739ae039)(node);
}


function $b053670add32783c$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}





function $1d3b5d4e772ef8d4$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $67c84f7b9d68974e$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $9875449f0bf8dff4$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $1a6f7dd7003a50a1$export$2e2bcd8739ae039)((0, $1d3b5d4e772ef8d4$export$2e2bcd8739ae039)(element)).left + (0, $1ed31100e25348a7$export$2e2bcd8739ae039)(element).scrollLeft;
}




function $c125cc314f75f1af$export$2e2bcd8739ae039(element) {
    return (0, $225372f33665d118$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}


function $a527afd9af1fd91d$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $c125cc314f75f1af$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}



function $d861eebf1f8322fe$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $e0beaf1fc26deee3$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $e0beaf1fc26deee3$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $d861eebf1f8322fe$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $67c84f7b9d68974e$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $67c84f7b9d68974e$export$1b3bfaa9684536aa)(offsetParent) && $d861eebf1f8322fe$var$isElementScaled(offsetParent);
    var documentElement = (0, $1d3b5d4e772ef8d4$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $1a6f7dd7003a50a1$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $b053670add32783c$export$2e2bcd8739ae039)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, $a527afd9af1fd91d$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $bfa783b4c9ad111f$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $67c84f7b9d68974e$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $1a6f7dd7003a50a1$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $9875449f0bf8dff4$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}



function $c0579089f336dea9$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $1a6f7dd7003a50a1$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}





function $49c4da5606d9971e$export$2e2bcd8739ae039(element) {
    if ((0, $b053670add32783c$export$2e2bcd8739ae039)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $67c84f7b9d68974e$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $1d3b5d4e772ef8d4$export$2e2bcd8739ae039)(element) // fallback
    );
}





function $c2945e92d9880f1c$export$2e2bcd8739ae039(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, $b053670add32783c$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $67c84f7b9d68974e$export$1b3bfaa9684536aa)(node) && (0, $a527afd9af1fd91d$export$2e2bcd8739ae039)(node)) return node;
    return $c2945e92d9880f1c$export$2e2bcd8739ae039((0, $49c4da5606d9971e$export$2e2bcd8739ae039)(node));
}





function $354a82c9e8edb67d$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $c2945e92d9880f1c$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $225372f33665d118$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $a527afd9af1fd91d$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($354a82c9e8edb67d$export$2e2bcd8739ae039((0, $49c4da5606d9971e$export$2e2bcd8739ae039)(target)));
}







function $d29f6785fa19ef29$export$2e2bcd8739ae039(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, $b053670add32783c$export$2e2bcd8739ae039)(element)) >= 0;
}




function $1fdd6cf5db426e4d$var$getTrueOffsetParent(element) {
    if (!(0, $67c84f7b9d68974e$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $c125cc314f75f1af$export$2e2bcd8739ae039)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $1fdd6cf5db426e4d$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $6394c1ff52742048$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $6394c1ff52742048$export$2e2bcd8739ae039)());
    if (isIE && (0, $67c84f7b9d68974e$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $c125cc314f75f1af$export$2e2bcd8739ae039)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, $49c4da5606d9971e$export$2e2bcd8739ae039)(element);
    if ((0, $67c84f7b9d68974e$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $67c84f7b9d68974e$export$1b3bfaa9684536aa)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, $b053670add32783c$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $c125cc314f75f1af$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $1fdd6cf5db426e4d$export$2e2bcd8739ae039(element) {
    var window = (0, $225372f33665d118$export$2e2bcd8739ae039)(element);
    var offsetParent = $1fdd6cf5db426e4d$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $d29f6785fa19ef29$export$2e2bcd8739ae039)(offsetParent) && (0, $c125cc314f75f1af$export$2e2bcd8739ae039)(offsetParent).position === "static")offsetParent = $1fdd6cf5db426e4d$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $b053670add32783c$export$2e2bcd8739ae039)(offsetParent) === "html" || (0, $b053670add32783c$export$2e2bcd8739ae039)(offsetParent) === "body" && (0, $c125cc314f75f1af$export$2e2bcd8739ae039)(offsetParent).position === "static")) return window;
    return offsetParent || $1fdd6cf5db426e4d$var$getContainingBlock(element) || window;
}


var $a94704e3133fbe16$export$1e95b668f3b82d = "top";
var $a94704e3133fbe16$export$40e543e69a8b3fbb = "bottom";
var $a94704e3133fbe16$export$79ffe56a765070d2 = "right";
var $a94704e3133fbe16$export$eabcd2c8791e7bf4 = "left";
var $a94704e3133fbe16$export$dfb5619354ba860 = "auto";
var $a94704e3133fbe16$export$aec2ce47c367b8c3 = [
    $a94704e3133fbe16$export$1e95b668f3b82d,
    $a94704e3133fbe16$export$40e543e69a8b3fbb,
    $a94704e3133fbe16$export$79ffe56a765070d2,
    $a94704e3133fbe16$export$eabcd2c8791e7bf4
];
var $a94704e3133fbe16$export$b3571188c770cc5a = "start";
var $a94704e3133fbe16$export$bd5df0f255a350f8 = "end";
var $a94704e3133fbe16$export$390fd549c5303b4d = "clippingParents";
var $a94704e3133fbe16$export$d7b7311ec04a3e8f = "viewport";
var $a94704e3133fbe16$export$ae5ab1c730825774 = "popper";
var $a94704e3133fbe16$export$ca50aac9f3ba507f = "reference";
var $a94704e3133fbe16$export$368f9a87e87fa4e1 = /*#__PURE__*/ $a94704e3133fbe16$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $a94704e3133fbe16$export$b3571188c770cc5a,
        placement + "-" + $a94704e3133fbe16$export$bd5df0f255a350f8
    ]);
}, []);
var $a94704e3133fbe16$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($a94704e3133fbe16$export$aec2ce47c367b8c3, [
    $a94704e3133fbe16$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $a94704e3133fbe16$export$b3571188c770cc5a,
        placement + "-" + $a94704e3133fbe16$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $a94704e3133fbe16$export$421679a7c3d56e = "beforeRead";
var $a94704e3133fbe16$export$aafa59e2e03f2942 = "read";
var $a94704e3133fbe16$export$6964f6c886723980 = "afterRead"; // pure-logic modifiers
var $a94704e3133fbe16$export$c65e99957a05207c = "beforeMain";
var $a94704e3133fbe16$export$f22da7240b7add18 = "main";
var $a94704e3133fbe16$export$bab79516f2d662fe = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var $a94704e3133fbe16$export$8d4d2d70e7d46032 = "beforeWrite";
var $a94704e3133fbe16$export$68d8715fc104d294 = "write";
var $a94704e3133fbe16$export$70a6e5159acce2e6 = "afterWrite";
var $a94704e3133fbe16$export$d087d3878fdf71d5 = [
    $a94704e3133fbe16$export$421679a7c3d56e,
    $a94704e3133fbe16$export$aafa59e2e03f2942,
    $a94704e3133fbe16$export$6964f6c886723980,
    $a94704e3133fbe16$export$c65e99957a05207c,
    $a94704e3133fbe16$export$f22da7240b7add18,
    $a94704e3133fbe16$export$bab79516f2d662fe,
    $a94704e3133fbe16$export$8d4d2d70e7d46032,
    $a94704e3133fbe16$export$68d8715fc104d294,
    $a94704e3133fbe16$export$70a6e5159acce2e6
];


function $3ba14eba4f91aa83$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $3ba14eba4f91aa83$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $3ba14eba4f91aa83$var$order(modifiers); // order based on phase
    return (0, $a94704e3133fbe16$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $0f1640117aceffba$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $fe67b122da4891e2$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $5bebade71559124e$var$DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function $5bebade71559124e$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function $5bebade71559124e$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $5bebade71559124e$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, $5bebade71559124e$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $67c84f7b9d68974e$export$45a5e7f76e0caa8d)(reference) ? (0, $354a82c9e8edb67d$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $354a82c9e8edb67d$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $354a82c9e8edb67d$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $3ba14eba4f91aa83$export$2e2bcd8739ae039)((0, $fe67b122da4891e2$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$5bebade71559124e$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $d861eebf1f8322fe$export$2e2bcd8739ae039)(reference, (0, $1fdd6cf5db426e4d$export$2e2bcd8739ae039)(popper), state.options.strategy === "fixed"),
                    popper: (0, $c0579089f336dea9$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $0f1640117aceffba$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$5bebade71559124e$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $5bebade71559124e$export$8f7491d57c8f97a9 = /*#__PURE__*/ $5bebade71559124e$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules



var $41bc2dfc6eb96248$var$passive = {
    passive: true
};
function $41bc2dfc6eb96248$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $225372f33665d118$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, $41bc2dfc6eb96248$var$passive);
    });
    if (resize) window.addEventListener("resize", instance.update, $41bc2dfc6eb96248$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, $41bc2dfc6eb96248$var$passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, $41bc2dfc6eb96248$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $41bc2dfc6eb96248$export$2e2bcd8739ae039 = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: $41bc2dfc6eb96248$var$effect,
    data: {}
};



function $62df636877274c69$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[0];
}


function $873b81dce61132cd$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[1];
}


function $8cdaee54ad91b509$export$2e2bcd8739ae039(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}



function $36cc5fd00eec4fbb$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $62df636877274c69$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $873b81dce61132cd$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $a94704e3133fbe16$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $a94704e3133fbe16$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $a94704e3133fbe16$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $a94704e3133fbe16$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $8cdaee54ad91b509$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, $a94704e3133fbe16$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $a94704e3133fbe16$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}


function $13f1c3bc9b36621c$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $36cc5fd00eec4fbb$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $13f1c3bc9b36621c$export$2e2bcd8739ae039 = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: $13f1c3bc9b36621c$var$popperOffsets,
    data: {}
};










var $5106537fe02a42d1$var$unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $5106537fe02a42d1$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $e0beaf1fc26deee3$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $e0beaf1fc26deee3$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $5106537fe02a42d1$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, $a94704e3133fbe16$export$eabcd2c8791e7bf4);
    var sideY = (0, $a94704e3133fbe16$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $1fdd6cf5db426e4d$export$2e2bcd8739ae039)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, $225372f33665d118$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $1d3b5d4e772ef8d4$export$2e2bcd8739ae039)(popper);
            if ((0, $c125cc314f75f1af$export$2e2bcd8739ae039)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $a94704e3133fbe16$export$1e95b668f3b82d) || (placement === (0, $a94704e3133fbe16$export$eabcd2c8791e7bf4) || placement === (0, $a94704e3133fbe16$export$79ffe56a765070d2)) && variation === (0, $a94704e3133fbe16$export$bd5df0f255a350f8)) {
            sideY = (0, $a94704e3133fbe16$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $a94704e3133fbe16$export$eabcd2c8791e7bf4) || (placement === (0, $a94704e3133fbe16$export$1e95b668f3b82d) || placement === (0, $a94704e3133fbe16$export$40e543e69a8b3fbb)) && variation === (0, $a94704e3133fbe16$export$bd5df0f255a350f8)) {
            sideX = (0, $a94704e3133fbe16$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $5106537fe02a42d1$var$unsetSides);
    var _ref4 = roundOffsets === true ? $5106537fe02a42d1$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $225372f33665d118$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function $5106537fe02a42d1$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $62df636877274c69$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $873b81dce61132cd$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $5106537fe02a42d1$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $5106537fe02a42d1$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $5106537fe02a42d1$export$2e2bcd8739ae039 = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: $5106537fe02a42d1$var$computeStyles,
    data: {}
};




// and applies them to the HTMLElements such as popper and arrow
function $89d890c165874cff$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $67c84f7b9d68974e$export$1b3bfaa9684536aa)(element) || !(0, $b053670add32783c$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? "" : value);
        });
    });
}
function $89d890c165874cff$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: "0",
            top: "0",
            margin: "0"
        },
        arrow: {
            position: "absolute"
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = "";
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $67c84f7b9d68974e$export$1b3bfaa9684536aa)(element) || !(0, $b053670add32783c$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $89d890c165874cff$export$2e2bcd8739ae039 = {
    name: "applyStyles",
    enabled: true,
    phase: "write",
    fn: $89d890c165874cff$var$applyStyles,
    effect: $89d890c165874cff$var$effect,
    requires: [
        "computeStyles"
    ]
};




function $bea6e8d498694752$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $62df636877274c69$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $a94704e3133fbe16$export$eabcd2c8791e7bf4),
        (0, $a94704e3133fbe16$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $a94704e3133fbe16$export$eabcd2c8791e7bf4),
        (0, $a94704e3133fbe16$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $bea6e8d498694752$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $a94704e3133fbe16$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $bea6e8d498694752$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $bea6e8d498694752$export$2e2bcd8739ae039 = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: $bea6e8d498694752$var$offset
};


var $d8d1c19fcab8b98a$var$hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $d8d1c19fcab8b98a$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $d8d1c19fcab8b98a$var$hash[matched];
    });
}



var $3d8b1e96ae7b2b33$var$hash = {
    start: "end",
    end: "start"
};
function $3d8b1e96ae7b2b33$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $3d8b1e96ae7b2b33$var$hash[matched];
    });
}







function $99269cfb0c30a849$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $225372f33665d118$export$2e2bcd8739ae039)(element);
    var html = (0, $1d3b5d4e772ef8d4$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $df11fd8e9d8c1389$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $9875449f0bf8dff4$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $e10e7e39ab68972d$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $1d3b5d4e772ef8d4$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $1ed31100e25348a7$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $e0beaf1fc26deee3$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $e0beaf1fc26deee3$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $9875449f0bf8dff4$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $c125cc314f75f1af$export$2e2bcd8739ae039)(body || html).direction === "rtl") x += (0, $e0beaf1fc26deee3$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}










function $fe95fa72fab69498$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $67c84f7b9d68974e$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $dec119a2e5377521$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $b15c2dc09d4d708d$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $1a6f7dd7003a50a1$export$2e2bcd8739ae039)(element, false, strategy === "fixed");
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $b15c2dc09d4d708d$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $a94704e3133fbe16$export$d7b7311ec04a3e8f) ? (0, $dec119a2e5377521$export$2e2bcd8739ae039)((0, $99269cfb0c30a849$export$2e2bcd8739ae039)(element, strategy)) : (0, $67c84f7b9d68974e$export$45a5e7f76e0caa8d)(clippingParent) ? $b15c2dc09d4d708d$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $dec119a2e5377521$export$2e2bcd8739ae039)((0, $e10e7e39ab68972d$export$2e2bcd8739ae039)((0, $1d3b5d4e772ef8d4$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $b15c2dc09d4d708d$var$getClippingParents(element) {
    var clippingParents = (0, $354a82c9e8edb67d$export$2e2bcd8739ae039)((0, $49c4da5606d9971e$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, $c125cc314f75f1af$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $67c84f7b9d68974e$export$1b3bfaa9684536aa)(element) ? (0, $1fdd6cf5db426e4d$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $67c84f7b9d68974e$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $67c84f7b9d68974e$export$45a5e7f76e0caa8d)(clippingParent) && (0, $fe95fa72fab69498$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $b053670add32783c$export$2e2bcd8739ae039)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function $b15c2dc09d4d708d$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === "clippingParents" ? $b15c2dc09d4d708d$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $b15c2dc09d4d708d$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $e0beaf1fc26deee3$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $e0beaf1fc26deee3$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $e0beaf1fc26deee3$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $e0beaf1fc26deee3$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $b15c2dc09d4d708d$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $f7baa3d7766ddfd5$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $c11f65b1ae4396ba$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $f7baa3d7766ddfd5$export$2e2bcd8739ae039)(), paddingObject);
}


function $8c698fce3c6fce96$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


function $724adaa25380997c$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $a94704e3133fbe16$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $a94704e3133fbe16$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $a94704e3133fbe16$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $c11f65b1ae4396ba$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $8c698fce3c6fce96$export$2e2bcd8739ae039)(padding, (0, $a94704e3133fbe16$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $a94704e3133fbe16$export$ae5ab1c730825774) ? (0, $a94704e3133fbe16$export$ca50aac9f3ba507f) : (0, $a94704e3133fbe16$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $b15c2dc09d4d708d$export$2e2bcd8739ae039)((0, $67c84f7b9d68974e$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $1d3b5d4e772ef8d4$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $1a6f7dd7003a50a1$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $36cc5fd00eec4fbb$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, $dec119a2e5377521$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $a94704e3133fbe16$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $a94704e3133fbe16$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $a94704e3133fbe16$export$79ffe56a765070d2),
                (0, $a94704e3133fbe16$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $a94704e3133fbe16$export$1e95b668f3b82d),
                (0, $a94704e3133fbe16$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $f977f9f0436520a0$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $a94704e3133fbe16$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $873b81dce61132cd$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $a94704e3133fbe16$export$368f9a87e87fa4e1) : (0, $a94704e3133fbe16$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $873b81dce61132cd$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $a94704e3133fbe16$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $724adaa25380997c$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $62df636877274c69$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $5fa2f8fc84eb9429$var$getExpandedFallbackPlacements(placement) {
    if ((0, $62df636877274c69$export$2e2bcd8739ae039)(placement) === (0, $a94704e3133fbe16$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $d8d1c19fcab8b98a$export$2e2bcd8739ae039)(placement);
    return [
        (0, $3d8b1e96ae7b2b33$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $3d8b1e96ae7b2b33$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $5fa2f8fc84eb9429$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $62df636877274c69$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $d8d1c19fcab8b98a$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $5fa2f8fc84eb9429$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $62df636877274c69$export$2e2bcd8739ae039)(placement) === (0, $a94704e3133fbe16$export$dfb5619354ba860) ? (0, $f977f9f0436520a0$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $62df636877274c69$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $873b81dce61132cd$export$2e2bcd8739ae039)(placement) === (0, $a94704e3133fbe16$export$b3571188c770cc5a);
        var isVertical = [
            (0, $a94704e3133fbe16$export$1e95b668f3b82d),
            (0, $a94704e3133fbe16$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, $724adaa25380997c$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $a94704e3133fbe16$export$79ffe56a765070d2) : (0, $a94704e3133fbe16$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $a94704e3133fbe16$export$40e543e69a8b3fbb) : (0, $a94704e3133fbe16$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $d8d1c19fcab8b98a$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $d8d1c19fcab8b98a$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $5fa2f8fc84eb9429$export$2e2bcd8739ae039 = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: $5fa2f8fc84eb9429$var$flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};





function $4f97934e8dbef3cc$export$2e2bcd8739ae039(axis) {
    return axis === "x" ? "y" : "x";
}



function $711bed0e4fb75d3f$export$f28d906d67a997f3(min, value, max) {
    return (0, $e0beaf1fc26deee3$export$8960430cfd85939f)(min, (0, $e0beaf1fc26deee3$export$96ec731ed4dcb222)(value, max));
}
function $711bed0e4fb75d3f$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $711bed0e4fb75d3f$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}








function $0598b84f7e68d489$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $724adaa25380997c$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $62df636877274c69$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $873b81dce61132cd$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $8cdaee54ad91b509$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $4f97934e8dbef3cc$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, $a94704e3133fbe16$export$1e95b668f3b82d) : (0, $a94704e3133fbe16$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === "y" ? (0, $a94704e3133fbe16$export$40e543e69a8b3fbb) : (0, $a94704e3133fbe16$export$79ffe56a765070d2);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $a94704e3133fbe16$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $a94704e3133fbe16$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $c0579089f336dea9$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, $f7baa3d7766ddfd5$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $711bed0e4fb75d3f$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $1fdd6cf5db426e4d$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $711bed0e4fb75d3f$export$f28d906d67a997f3)(tether ? (0, $e0beaf1fc26deee3$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $e0beaf1fc26deee3$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, $a94704e3133fbe16$export$1e95b668f3b82d) : (0, $a94704e3133fbe16$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === "x" ? (0, $a94704e3133fbe16$export$40e543e69a8b3fbb) : (0, $a94704e3133fbe16$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $a94704e3133fbe16$export$1e95b668f3b82d),
            (0, $a94704e3133fbe16$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $711bed0e4fb75d3f$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $711bed0e4fb75d3f$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $0598b84f7e68d489$export$2e2bcd8739ae039 = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: $0598b84f7e68d489$var$preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};











var $671483b845900ee3$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $c11f65b1ae4396ba$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $8c698fce3c6fce96$export$2e2bcd8739ae039)(padding, (0, $a94704e3133fbe16$export$aec2ce47c367b8c3)));
};
function $671483b845900ee3$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $62df636877274c69$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $8cdaee54ad91b509$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $a94704e3133fbe16$export$eabcd2c8791e7bf4),
        (0, $a94704e3133fbe16$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $671483b845900ee3$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $c0579089f336dea9$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === "y" ? (0, $a94704e3133fbe16$export$1e95b668f3b82d) : (0, $a94704e3133fbe16$export$eabcd2c8791e7bf4);
    var maxProp = axis === "y" ? (0, $a94704e3133fbe16$export$40e543e69a8b3fbb) : (0, $a94704e3133fbe16$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $1fdd6cf5db426e4d$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $711bed0e4fb75d3f$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $671483b845900ee3$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $fe95fa72fab69498$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $671483b845900ee3$export$2e2bcd8739ae039 = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: $671483b845900ee3$var$arrow,
    effect: $671483b845900ee3$var$effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};




function $be0e5a97b5c4f0a9$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $be0e5a97b5c4f0a9$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $a94704e3133fbe16$export$1e95b668f3b82d),
        (0, $a94704e3133fbe16$export$79ffe56a765070d2),
        (0, $a94704e3133fbe16$export$40e543e69a8b3fbb),
        (0, $a94704e3133fbe16$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $be0e5a97b5c4f0a9$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $724adaa25380997c$export$2e2bcd8739ae039)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, $724adaa25380997c$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $be0e5a97b5c4f0a9$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $be0e5a97b5c4f0a9$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $be0e5a97b5c4f0a9$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $be0e5a97b5c4f0a9$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $be0e5a97b5c4f0a9$export$2e2bcd8739ae039 = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: $be0e5a97b5c4f0a9$var$hide
};




var $55c7f2385d3e922b$export$d34966752335dd47 = [
    (0, $41bc2dfc6eb96248$export$2e2bcd8739ae039),
    (0, $13f1c3bc9b36621c$export$2e2bcd8739ae039),
    (0, $5106537fe02a42d1$export$2e2bcd8739ae039),
    (0, $89d890c165874cff$export$2e2bcd8739ae039),
    (0, $bea6e8d498694752$export$2e2bcd8739ae039),
    (0, $5fa2f8fc84eb9429$export$2e2bcd8739ae039),
    (0, $0598b84f7e68d489$export$2e2bcd8739ae039),
    (0, $671483b845900ee3$export$2e2bcd8739ae039),
    (0, $be0e5a97b5c4f0a9$export$2e2bcd8739ae039)
];
var $55c7f2385d3e922b$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $5bebade71559124e$export$ed5e13716264f202)({
    defaultModifiers: $55c7f2385d3e922b$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules


/**
 * Swiper 11.0.6
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2024 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: February 5, 2024
 */ /**
 * SSR Window 4.0.2
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2021, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: December 13, 2021
 */ /* eslint-disable no-param-reassign */ function $73cf9966c142bfa0$var$isObject(obj) {
    return obj !== null && typeof obj === "object" && "constructor" in obj && obj.constructor === Object;
}
function $73cf9966c142bfa0$var$extend(target, src) {
    if (target === void 0) target = {};
    if (src === void 0) src = {};
    Object.keys(src).forEach((key)=>{
        if (typeof target[key] === "undefined") target[key] = src[key];
        else if ($73cf9966c142bfa0$var$isObject(src[key]) && $73cf9966c142bfa0$var$isObject(target[key]) && Object.keys(src[key]).length > 0) $73cf9966c142bfa0$var$extend(target[key], src[key]);
    });
}
const $73cf9966c142bfa0$var$ssrDocument = {
    body: {},
    addEventListener () {},
    removeEventListener () {},
    activeElement: {
        blur () {},
        nodeName: ""
    },
    querySelector () {
        return null;
    },
    querySelectorAll () {
        return [];
    },
    getElementById () {
        return null;
    },
    createEvent () {
        return {
            initEvent () {}
        };
    },
    createElement () {
        return {
            children: [],
            childNodes: [],
            style: {},
            setAttribute () {},
            getElementsByTagName () {
                return [];
            }
        };
    },
    createElementNS () {
        return {};
    },
    importNode () {
        return null;
    },
    location: {
        hash: "",
        host: "",
        hostname: "",
        href: "",
        origin: "",
        pathname: "",
        protocol: "",
        search: ""
    }
};
function $73cf9966c142bfa0$export$39b482c5e57630a8() {
    const doc = typeof document !== "undefined" ? document : {};
    $73cf9966c142bfa0$var$extend(doc, $73cf9966c142bfa0$var$ssrDocument);
    return doc;
}
const $73cf9966c142bfa0$var$ssrWindow = {
    document: $73cf9966c142bfa0$var$ssrDocument,
    navigator: {
        userAgent: ""
    },
    location: {
        hash: "",
        host: "",
        hostname: "",
        href: "",
        origin: "",
        pathname: "",
        protocol: "",
        search: ""
    },
    history: {
        replaceState () {},
        pushState () {},
        go () {},
        back () {}
    },
    CustomEvent: function CustomEvent() {
        return this;
    },
    addEventListener () {},
    removeEventListener () {},
    getComputedStyle () {
        return {
            getPropertyValue () {
                return "";
            }
        };
    },
    Image () {},
    Date () {},
    screen: {},
    setTimeout () {},
    clearTimeout () {},
    matchMedia () {
        return {};
    },
    requestAnimationFrame (callback) {
        if (typeof setTimeout === "undefined") {
            callback();
            return null;
        }
        return setTimeout(callback, 0);
    },
    cancelAnimationFrame (id) {
        if (typeof setTimeout === "undefined") return;
        clearTimeout(id);
    }
};
function $73cf9966c142bfa0$export$407448d2b89b1813() {
    const win = typeof window !== "undefined" ? window : {};
    $73cf9966c142bfa0$var$extend(win, $73cf9966c142bfa0$var$ssrWindow);
    return win;
}



function $95ca904041552da4$export$dda1d9f60106f0e9(classes) {
    if (classes === void 0) classes = "";
    return classes.trim().split(" ").filter((c)=>!!c.trim());
}
function $95ca904041552da4$export$90a7f3efeed30595(obj) {
    const object = obj;
    Object.keys(object).forEach((key)=>{
        try {
            object[key] = null;
        } catch (e) {
        // no getter for object
        }
        try {
            delete object[key];
        } catch (e) {
        // something got wrong
        }
    });
}
function $95ca904041552da4$export$7ccc53e8f1e7dfc5(callback, delay) {
    if (delay === void 0) delay = 0;
    return setTimeout(callback, delay);
}
function $95ca904041552da4$export$4368d992c4eafac0() {
    return Date.now();
}
function $95ca904041552da4$var$getComputedStyle(el) {
    const window1 = (0, $73cf9966c142bfa0$export$407448d2b89b1813)();
    let style;
    if (window1.getComputedStyle) style = window1.getComputedStyle(el, null);
    if (!style && el.currentStyle) style = el.currentStyle;
    if (!style) style = el.style;
    return style;
}
function $95ca904041552da4$export$23f2a1d2818174ef(el, axis) {
    if (axis === void 0) axis = "x";
    const window1 = (0, $73cf9966c142bfa0$export$407448d2b89b1813)();
    let matrix;
    let curTransform;
    let transformMatrix;
    const curStyle = $95ca904041552da4$var$getComputedStyle(el);
    if (window1.WebKitCSSMatrix) {
        curTransform = curStyle.transform || curStyle.webkitTransform;
        if (curTransform.split(",").length > 6) curTransform = curTransform.split(", ").map((a)=>a.replace(",", ".")).join(", ");
        // Some old versions of Webkit choke when 'none' is passed; pass
        // empty string instead in this case
        transformMatrix = new window1.WebKitCSSMatrix(curTransform === "none" ? "" : curTransform);
    } else {
        transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,");
        matrix = transformMatrix.toString().split(",");
    }
    if (axis === "x") {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m41;
        else if (matrix.length === 16) curTransform = parseFloat(matrix[12]);
        else curTransform = parseFloat(matrix[4]);
    }
    if (axis === "y") {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m42;
        else if (matrix.length === 16) curTransform = parseFloat(matrix[13]);
        else curTransform = parseFloat(matrix[5]);
    }
    return curTransform || 0;
}
function $95ca904041552da4$export$342063e11d6c3cad(o) {
    return typeof o === "object" && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === "Object";
}
function $95ca904041552da4$var$isNode(node) {
    // eslint-disable-next-line
    if (typeof window !== "undefined" && typeof window.HTMLElement !== "undefined") return node instanceof HTMLElement;
    return node && (node.nodeType === 1 || node.nodeType === 11);
}
function $95ca904041552da4$export$3b14a55fb2447963() {
    const to = Object(arguments.length <= 0 ? undefined : arguments[0]);
    const noExtend = [
        "__proto__",
        "constructor",
        "prototype"
    ];
    for(let i = 1; i < arguments.length; i += 1){
        const nextSource = i < 0 || arguments.length <= i ? undefined : arguments[i];
        if (nextSource !== undefined && nextSource !== null && !$95ca904041552da4$var$isNode(nextSource)) {
            const keysArray = Object.keys(Object(nextSource)).filter((key)=>noExtend.indexOf(key) < 0);
            for(let nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1){
                const nextKey = keysArray[nextIndex];
                const desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
                if (desc !== undefined && desc.enumerable) {
                    if ($95ca904041552da4$export$342063e11d6c3cad(to[nextKey]) && $95ca904041552da4$export$342063e11d6c3cad(nextSource[nextKey])) {
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else $95ca904041552da4$export$3b14a55fb2447963(to[nextKey], nextSource[nextKey]);
                    } else if (!$95ca904041552da4$export$342063e11d6c3cad(to[nextKey]) && $95ca904041552da4$export$342063e11d6c3cad(nextSource[nextKey])) {
                        to[nextKey] = {};
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else $95ca904041552da4$export$3b14a55fb2447963(to[nextKey], nextSource[nextKey]);
                    } else to[nextKey] = nextSource[nextKey];
                }
            }
        }
    }
    return to;
}
function $95ca904041552da4$export$2408f22a0fab9ae5(el, varName, varValue) {
    el.style.setProperty(varName, varValue);
}
function $95ca904041552da4$export$43caf9889c228507(_ref) {
    let { swiper: swiper, targetPosition: targetPosition, side: side } = _ref;
    const window1 = (0, $73cf9966c142bfa0$export$407448d2b89b1813)();
    const startPosition = -swiper.translate;
    let startTime = null;
    let time;
    const duration = swiper.params.speed;
    swiper.wrapperEl.style.scrollSnapType = "none";
    window1.cancelAnimationFrame(swiper.cssModeFrameID);
    const dir = targetPosition > startPosition ? "next" : "prev";
    const isOutOfBound = (current, target)=>{
        return dir === "next" && current >= target || dir === "prev" && current <= target;
    };
    const animate = ()=>{
        time = new Date().getTime();
        if (startTime === null) startTime = time;
        const progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
        const easeProgress = 0.5 - Math.cos(progress * Math.PI) / 2;
        let currentPosition = startPosition + easeProgress * (targetPosition - startPosition);
        if (isOutOfBound(currentPosition, targetPosition)) currentPosition = targetPosition;
        swiper.wrapperEl.scrollTo({
            [side]: currentPosition
        });
        if (isOutOfBound(currentPosition, targetPosition)) {
            swiper.wrapperEl.style.overflow = "hidden";
            swiper.wrapperEl.style.scrollSnapType = "";
            setTimeout(()=>{
                swiper.wrapperEl.style.overflow = "";
                swiper.wrapperEl.scrollTo({
                    [side]: currentPosition
                });
            });
            window1.cancelAnimationFrame(swiper.cssModeFrameID);
            return;
        }
        swiper.cssModeFrameID = window1.requestAnimationFrame(animate);
    };
    animate();
}
function $95ca904041552da4$export$882b5998b3b9117c(slideEl) {
    return slideEl.querySelector(".swiper-slide-transform") || slideEl.shadowRoot && slideEl.shadowRoot.querySelector(".swiper-slide-transform") || slideEl;
}
function $95ca904041552da4$export$f1e1789686576879(element, selector) {
    if (selector === void 0) selector = "";
    return [
        ...element.children
    ].filter((el)=>el.matches(selector));
}
function $95ca904041552da4$export$625550452a3fa3ec(text) {
    try {
        console.warn(text);
        return;
    } catch (err) {
    // err
    }
}
function $95ca904041552da4$export$db3b6bfb95261072(tag, classes) {
    if (classes === void 0) classes = [];
    const el = document.createElement(tag);
    el.classList.add(...Array.isArray(classes) ? classes : $95ca904041552da4$export$dda1d9f60106f0e9(classes));
    return el;
}
function $95ca904041552da4$export$8b22cf2602fb60ce(el) {
    const window1 = (0, $73cf9966c142bfa0$export$407448d2b89b1813)();
    const document1 = (0, $73cf9966c142bfa0$export$39b482c5e57630a8)();
    const box = el.getBoundingClientRect();
    const body = document1.body;
    const clientTop = el.clientTop || body.clientTop || 0;
    const clientLeft = el.clientLeft || body.clientLeft || 0;
    const scrollTop = el === window1 ? window1.scrollY : el.scrollTop;
    const scrollLeft = el === window1 ? window1.scrollX : el.scrollLeft;
    return {
        top: box.top + scrollTop - clientTop,
        left: box.left + scrollLeft - clientLeft
    };
}
function $95ca904041552da4$export$9e5f44173e64f162(el, selector) {
    const prevEls = [];
    while(el.previousElementSibling){
        const prev = el.previousElementSibling; // eslint-disable-line
        if (selector) {
            if (prev.matches(selector)) prevEls.push(prev);
        } else prevEls.push(prev);
        el = prev;
    }
    return prevEls;
}
function $95ca904041552da4$export$ffb5f4729a158638(el, selector) {
    const nextEls = [];
    while(el.nextElementSibling){
        const next = el.nextElementSibling; // eslint-disable-line
        if (selector) {
            if (next.matches(selector)) nextEls.push(next);
        } else nextEls.push(next);
        el = next;
    }
    return nextEls;
}
function $95ca904041552da4$export$ae1af26003f05816(el, prop) {
    const window1 = (0, $73cf9966c142bfa0$export$407448d2b89b1813)();
    return window1.getComputedStyle(el, null).getPropertyValue(prop);
}
function $95ca904041552da4$export$39b482c5e57630a8(el) {
    let child = el;
    let i;
    if (child) {
        i = 0;
        // eslint-disable-next-line
        while((child = child.previousSibling) !== null)if (child.nodeType === 1) i += 1;
        return i;
    }
    return undefined;
}
function $95ca904041552da4$export$407448d2b89b1813(el, selector) {
    const parents = []; // eslint-disable-line
    let parent = el.parentElement; // eslint-disable-line
    while(parent){
        if (selector) {
            if (parent.matches(selector)) parents.push(parent);
        } else parents.push(parent);
        parent = parent.parentElement;
    }
    return parents;
}
function $95ca904041552da4$export$35e795649ee09318(el, callback) {
    function fireCallBack(e) {
        if (e.target !== el) return;
        callback.call(el, e);
        el.removeEventListener("transitionend", fireCallBack);
    }
    if (callback) el.addEventListener("transitionend", fireCallBack);
}
function $95ca904041552da4$export$2d1720544b23b823(el, size, includeMargins) {
    const window1 = (0, $73cf9966c142bfa0$export$407448d2b89b1813)();
    if (includeMargins) return el[size === "width" ? "offsetWidth" : "offsetHeight"] + parseFloat(window1.getComputedStyle(el, null).getPropertyValue(size === "width" ? "margin-right" : "margin-top")) + parseFloat(window1.getComputedStyle(el, null).getPropertyValue(size === "width" ? "margin-left" : "margin-bottom"));
    return el.offsetWidth;
}
function $95ca904041552da4$export$953cecd6e717a553(el) {
    return (Array.isArray(el) ? el : [
        el
    ]).filter((e)=>!!e);
}


let $0d6016762a387e31$var$support;
function $0d6016762a387e31$var$calcSupport() {
    const window1 = (0, $73cf9966c142bfa0$export$407448d2b89b1813)();
    const document1 = (0, $73cf9966c142bfa0$export$39b482c5e57630a8)();
    return {
        smoothScroll: document1.documentElement && document1.documentElement.style && "scrollBehavior" in document1.documentElement.style,
        touch: !!("ontouchstart" in window1 || window1.DocumentTouch && document1 instanceof window1.DocumentTouch)
    };
}
function $0d6016762a387e31$var$getSupport() {
    if (!$0d6016762a387e31$var$support) $0d6016762a387e31$var$support = $0d6016762a387e31$var$calcSupport();
    return $0d6016762a387e31$var$support;
}
let $0d6016762a387e31$var$deviceCached;
function $0d6016762a387e31$var$calcDevice(_temp) {
    let { userAgent: userAgent } = _temp === void 0 ? {} : _temp;
    const support = $0d6016762a387e31$var$getSupport();
    const window1 = (0, $73cf9966c142bfa0$export$407448d2b89b1813)();
    const platform = window1.navigator.platform;
    const ua = userAgent || window1.navigator.userAgent;
    const device = {
        ios: false,
        android: false
    };
    const screenWidth = window1.screen.width;
    const screenHeight = window1.screen.height;
    const android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line
    let ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
    const ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
    const iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
    const windows = platform === "Win32";
    let macos = platform === "MacIntel";
    // iPadOs 13 fix
    const iPadScreens = [
        "1024x1366",
        "1366x1024",
        "834x1194",
        "1194x834",
        "834x1112",
        "1112x834",
        "768x1024",
        "1024x768",
        "820x1180",
        "1180x820",
        "810x1080",
        "1080x810"
    ];
    if (!ipad && macos && support.touch && iPadScreens.indexOf(`${screenWidth}x${screenHeight}`) >= 0) {
        ipad = ua.match(/(Version)\/([\d.]+)/);
        if (!ipad) ipad = [
            0,
            1,
            "13_0_0"
        ];
        macos = false;
    }
    // Android
    if (android && !windows) {
        device.os = "android";
        device.android = true;
    }
    if (ipad || iphone || ipod) {
        device.os = "ios";
        device.ios = true;
    }
    // Export object
    return device;
}
function $0d6016762a387e31$var$getDevice(overrides) {
    if (overrides === void 0) overrides = {};
    if (!$0d6016762a387e31$var$deviceCached) $0d6016762a387e31$var$deviceCached = $0d6016762a387e31$var$calcDevice(overrides);
    return $0d6016762a387e31$var$deviceCached;
}
let $0d6016762a387e31$var$browser;
function $0d6016762a387e31$var$calcBrowser() {
    const window1 = (0, $73cf9966c142bfa0$export$407448d2b89b1813)();
    const device = $0d6016762a387e31$var$getDevice();
    let needPerspectiveFix = false;
    function isSafari() {
        const ua = window1.navigator.userAgent.toLowerCase();
        return ua.indexOf("safari") >= 0 && ua.indexOf("chrome") < 0 && ua.indexOf("android") < 0;
    }
    if (isSafari()) {
        const ua = String(window1.navigator.userAgent);
        if (ua.includes("Version/")) {
            const [major, minor] = ua.split("Version/")[1].split(" ")[0].split(".").map((num)=>Number(num));
            needPerspectiveFix = major < 16 || major === 16 && minor < 2;
        }
    }
    const isWebView = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window1.navigator.userAgent);
    const isSafariBrowser = isSafari();
    const need3dFix = isSafariBrowser || isWebView && device.ios;
    return {
        isSafari: needPerspectiveFix || isSafariBrowser,
        needPerspectiveFix: needPerspectiveFix,
        need3dFix: need3dFix,
        isWebView: isWebView
    };
}
function $0d6016762a387e31$var$getBrowser() {
    if (!$0d6016762a387e31$var$browser) $0d6016762a387e31$var$browser = $0d6016762a387e31$var$calcBrowser();
    return $0d6016762a387e31$var$browser;
}
function $0d6016762a387e31$var$Resize(_ref) {
    let { swiper: swiper, on: on, emit: emit } = _ref;
    const window1 = (0, $73cf9966c142bfa0$export$407448d2b89b1813)();
    let observer = null;
    let animationFrame = null;
    const resizeHandler = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit("beforeResize");
        emit("resize");
    };
    const createObserver = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        observer = new ResizeObserver((entries)=>{
            animationFrame = window1.requestAnimationFrame(()=>{
                const { width: width, height: height } = swiper;
                let newWidth = width;
                let newHeight = height;
                entries.forEach((_ref2)=>{
                    let { contentBoxSize: contentBoxSize, contentRect: contentRect, target: target } = _ref2;
                    if (target && target !== swiper.el) return;
                    newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
                    newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
                });
                if (newWidth !== width || newHeight !== height) resizeHandler();
            });
        });
        observer.observe(swiper.el);
    };
    const removeObserver = ()=>{
        if (animationFrame) window1.cancelAnimationFrame(animationFrame);
        if (observer && observer.unobserve && swiper.el) {
            observer.unobserve(swiper.el);
            observer = null;
        }
    };
    const orientationChangeHandler = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit("orientationchange");
    };
    on("init", ()=>{
        if (swiper.params.resizeObserver && typeof window1.ResizeObserver !== "undefined") {
            createObserver();
            return;
        }
        window1.addEventListener("resize", resizeHandler);
        window1.addEventListener("orientationchange", orientationChangeHandler);
    });
    on("destroy", ()=>{
        removeObserver();
        window1.removeEventListener("resize", resizeHandler);
        window1.removeEventListener("orientationchange", orientationChangeHandler);
    });
}
function $0d6016762a387e31$var$Observer(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    const observers = [];
    const window1 = (0, $73cf9966c142bfa0$export$407448d2b89b1813)();
    const attach = function(target, options) {
        if (options === void 0) options = {};
        const ObserverFunc = window1.MutationObserver || window1.WebkitMutationObserver;
        const observer = new ObserverFunc((mutations)=>{
            // The observerUpdate event should only be triggered
            // once despite the number of mutations.  Additional
            // triggers are redundant and are very costly
            if (swiper.__preventObserver__) return;
            if (mutations.length === 1) {
                emit("observerUpdate", mutations[0]);
                return;
            }
            const observerUpdate = function observerUpdate() {
                emit("observerUpdate", mutations[0]);
            };
            if (window1.requestAnimationFrame) window1.requestAnimationFrame(observerUpdate);
            else window1.setTimeout(observerUpdate, 0);
        });
        observer.observe(target, {
            attributes: typeof options.attributes === "undefined" ? true : options.attributes,
            childList: typeof options.childList === "undefined" ? true : options.childList,
            characterData: typeof options.characterData === "undefined" ? true : options.characterData
        });
        observers.push(observer);
    };
    const init = ()=>{
        if (!swiper.params.observer) return;
        if (swiper.params.observeParents) {
            const containerParents = (0, $95ca904041552da4$export$407448d2b89b1813)(swiper.hostEl);
            for(let i = 0; i < containerParents.length; i += 1)attach(containerParents[i]);
        }
        // Observe container
        attach(swiper.hostEl, {
            childList: swiper.params.observeSlideChildren
        });
        // Observe wrapper
        attach(swiper.wrapperEl, {
            attributes: false
        });
    };
    const destroy = ()=>{
        observers.forEach((observer)=>{
            observer.disconnect();
        });
        observers.splice(0, observers.length);
    };
    extendParams({
        observer: false,
        observeParents: false,
        observeSlideChildren: false
    });
    on("init", init);
    on("destroy", destroy);
}
/* eslint-disable no-underscore-dangle */ var $0d6016762a387e31$var$eventsEmitter = {
    on (events, handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== "function") return self;
        const method = priority ? "unshift" : "push";
        events.split(" ").forEach((event)=>{
            if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
            self.eventsListeners[event][method](handler);
        });
        return self;
    },
    once (events, handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== "function") return self;
        function onceHandler() {
            self.off(events, onceHandler);
            if (onceHandler.__emitterProxy) delete onceHandler.__emitterProxy;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            handler.apply(self, args);
        }
        onceHandler.__emitterProxy = handler;
        return self.on(events, onceHandler, priority);
    },
    onAny (handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== "function") return self;
        const method = priority ? "unshift" : "push";
        if (self.eventsAnyListeners.indexOf(handler) < 0) self.eventsAnyListeners[method](handler);
        return self;
    },
    offAny (handler) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsAnyListeners) return self;
        const index = self.eventsAnyListeners.indexOf(handler);
        if (index >= 0) self.eventsAnyListeners.splice(index, 1);
        return self;
    },
    off (events, handler) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        events.split(" ").forEach((event)=>{
            if (typeof handler === "undefined") self.eventsListeners[event] = [];
            else if (self.eventsListeners[event]) self.eventsListeners[event].forEach((eventHandler, index)=>{
                if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) self.eventsListeners[event].splice(index, 1);
            });
        });
        return self;
    },
    emit () {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        let events;
        let data;
        let context;
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        if (typeof args[0] === "string" || Array.isArray(args[0])) {
            events = args[0];
            data = args.slice(1, args.length);
            context = self;
        } else {
            events = args[0].events;
            data = args[0].data;
            context = args[0].context || self;
        }
        data.unshift(context);
        const eventsArray = Array.isArray(events) ? events : events.split(" ");
        eventsArray.forEach((event)=>{
            if (self.eventsAnyListeners && self.eventsAnyListeners.length) self.eventsAnyListeners.forEach((eventHandler)=>{
                eventHandler.apply(context, [
                    event,
                    ...data
                ]);
            });
            if (self.eventsListeners && self.eventsListeners[event]) self.eventsListeners[event].forEach((eventHandler)=>{
                eventHandler.apply(context, data);
            });
        });
        return self;
    }
};
function $0d6016762a387e31$var$updateSize() {
    const swiper = this;
    let width;
    let height;
    const el = swiper.el;
    if (typeof swiper.params.width !== "undefined" && swiper.params.width !== null) width = swiper.params.width;
    else width = el.clientWidth;
    if (typeof swiper.params.height !== "undefined" && swiper.params.height !== null) height = swiper.params.height;
    else height = el.clientHeight;
    if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) return;
    // Subtract paddings
    width = width - parseInt((0, $95ca904041552da4$export$ae1af26003f05816)(el, "padding-left") || 0, 10) - parseInt((0, $95ca904041552da4$export$ae1af26003f05816)(el, "padding-right") || 0, 10);
    height = height - parseInt((0, $95ca904041552da4$export$ae1af26003f05816)(el, "padding-top") || 0, 10) - parseInt((0, $95ca904041552da4$export$ae1af26003f05816)(el, "padding-bottom") || 0, 10);
    if (Number.isNaN(width)) width = 0;
    if (Number.isNaN(height)) height = 0;
    Object.assign(swiper, {
        width: width,
        height: height,
        size: swiper.isHorizontal() ? width : height
    });
}
function $0d6016762a387e31$var$updateSlides() {
    const swiper = this;
    function getDirectionPropertyValue(node, label) {
        return parseFloat(node.getPropertyValue(swiper.getDirectionLabel(label)) || 0);
    }
    const params = swiper.params;
    const { wrapperEl: wrapperEl, slidesEl: slidesEl, size: swiperSize, rtlTranslate: rtl, wrongRTL: wrongRTL } = swiper;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    const previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
    const slides = (0, $95ca904041552da4$export$f1e1789686576879)(slidesEl, `.${swiper.params.slideClass}, swiper-slide`);
    const slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
    let snapGrid = [];
    const slidesGrid = [];
    const slidesSizesGrid = [];
    let offsetBefore = params.slidesOffsetBefore;
    if (typeof offsetBefore === "function") offsetBefore = params.slidesOffsetBefore.call(swiper);
    let offsetAfter = params.slidesOffsetAfter;
    if (typeof offsetAfter === "function") offsetAfter = params.slidesOffsetAfter.call(swiper);
    const previousSnapGridLength = swiper.snapGrid.length;
    const previousSlidesGridLength = swiper.slidesGrid.length;
    let spaceBetween = params.spaceBetween;
    let slidePosition = -offsetBefore;
    let prevSlideSize = 0;
    let index = 0;
    if (typeof swiperSize === "undefined") return;
    if (typeof spaceBetween === "string" && spaceBetween.indexOf("%") >= 0) spaceBetween = parseFloat(spaceBetween.replace("%", "")) / 100 * swiperSize;
    else if (typeof spaceBetween === "string") spaceBetween = parseFloat(spaceBetween);
    swiper.virtualSize = -spaceBetween;
    // reset margins
    slides.forEach((slideEl)=>{
        if (rtl) slideEl.style.marginLeft = "";
        else slideEl.style.marginRight = "";
        slideEl.style.marginBottom = "";
        slideEl.style.marginTop = "";
    });
    // reset cssMode offsets
    if (params.centeredSlides && params.cssMode) {
        (0, $95ca904041552da4$export$2408f22a0fab9ae5)(wrapperEl, "--swiper-centered-offset-before", "");
        (0, $95ca904041552da4$export$2408f22a0fab9ae5)(wrapperEl, "--swiper-centered-offset-after", "");
    }
    const gridEnabled = params.grid && params.grid.rows > 1 && swiper.grid;
    if (gridEnabled) swiper.grid.initSlides(slides);
    else if (swiper.grid) swiper.grid.unsetSlides();
    // Calc slides
    let slideSize;
    const shouldResetSlideSize = params.slidesPerView === "auto" && params.breakpoints && Object.keys(params.breakpoints).filter((key)=>{
        return typeof params.breakpoints[key].slidesPerView !== "undefined";
    }).length > 0;
    for(let i = 0; i < slidesLength; i += 1){
        slideSize = 0;
        let slide;
        if (slides[i]) slide = slides[i];
        if (gridEnabled) swiper.grid.updateSlide(i, slide, slides);
        if (slides[i] && (0, $95ca904041552da4$export$ae1af26003f05816)(slide, "display") === "none") continue; // eslint-disable-line
        if (params.slidesPerView === "auto") {
            if (shouldResetSlideSize) slides[i].style[swiper.getDirectionLabel("width")] = ``;
            const slideStyles = getComputedStyle(slide);
            const currentTransform = slide.style.transform;
            const currentWebKitTransform = slide.style.webkitTransform;
            if (currentTransform) slide.style.transform = "none";
            if (currentWebKitTransform) slide.style.webkitTransform = "none";
            if (params.roundLengths) slideSize = swiper.isHorizontal() ? (0, $95ca904041552da4$export$2d1720544b23b823)(slide, "width", true) : (0, $95ca904041552da4$export$2d1720544b23b823)(slide, "height", true);
            else {
                // eslint-disable-next-line
                const width = getDirectionPropertyValue(slideStyles, "width");
                const paddingLeft = getDirectionPropertyValue(slideStyles, "padding-left");
                const paddingRight = getDirectionPropertyValue(slideStyles, "padding-right");
                const marginLeft = getDirectionPropertyValue(slideStyles, "margin-left");
                const marginRight = getDirectionPropertyValue(slideStyles, "margin-right");
                const boxSizing = slideStyles.getPropertyValue("box-sizing");
                if (boxSizing && boxSizing === "border-box") slideSize = width + marginLeft + marginRight;
                else {
                    const { clientWidth: clientWidth, offsetWidth: offsetWidth } = slide;
                    slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
                }
            }
            if (currentTransform) slide.style.transform = currentTransform;
            if (currentWebKitTransform) slide.style.webkitTransform = currentWebKitTransform;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
        } else {
            slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
            if (slides[i]) slides[i].style[swiper.getDirectionLabel("width")] = `${slideSize}px`;
        }
        if (slides[i]) slides[i].swiperSlideSize = slideSize;
        slidesSizesGrid.push(slideSize);
        if (params.centeredSlides) {
            slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
            if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (Math.abs(slidePosition) < 0.001) slidePosition = 0;
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
        } else {
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
            slidePosition = slidePosition + slideSize + spaceBetween;
        }
        swiper.virtualSize += slideSize + spaceBetween;
        prevSlideSize = slideSize;
        index += 1;
    }
    swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
    if (rtl && wrongRTL && (params.effect === "slide" || params.effect === "coverflow")) wrapperEl.style.width = `${swiper.virtualSize + spaceBetween}px`;
    if (params.setWrapperSize) wrapperEl.style[swiper.getDirectionLabel("width")] = `${swiper.virtualSize + spaceBetween}px`;
    if (gridEnabled) swiper.grid.updateWrapperSize(slideSize, snapGrid);
    // Remove last grid elements depending on width
    if (!params.centeredSlides) {
        const newSlidesGrid = [];
        for(let i = 0; i < snapGrid.length; i += 1){
            let slidesGridItem = snapGrid[i];
            if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
            if (snapGrid[i] <= swiper.virtualSize - swiperSize) newSlidesGrid.push(slidesGridItem);
        }
        snapGrid = newSlidesGrid;
        if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) snapGrid.push(swiper.virtualSize - swiperSize);
    }
    if (isVirtual && params.loop) {
        const size = slidesSizesGrid[0] + spaceBetween;
        if (params.slidesPerGroup > 1) {
            const groups = Math.ceil((swiper.virtual.slidesBefore + swiper.virtual.slidesAfter) / params.slidesPerGroup);
            const groupSize = size * params.slidesPerGroup;
            for(let i = 0; i < groups; i += 1)snapGrid.push(snapGrid[snapGrid.length - 1] + groupSize);
        }
        for(let i = 0; i < swiper.virtual.slidesBefore + swiper.virtual.slidesAfter; i += 1){
            if (params.slidesPerGroup === 1) snapGrid.push(snapGrid[snapGrid.length - 1] + size);
            slidesGrid.push(slidesGrid[slidesGrid.length - 1] + size);
            swiper.virtualSize += size;
        }
    }
    if (snapGrid.length === 0) snapGrid = [
        0
    ];
    if (spaceBetween !== 0) {
        const key = swiper.isHorizontal() && rtl ? "marginLeft" : swiper.getDirectionLabel("marginRight");
        slides.filter((_, slideIndex)=>{
            if (!params.cssMode || params.loop) return true;
            if (slideIndex === slides.length - 1) return false;
            return true;
        }).forEach((slideEl)=>{
            slideEl.style[key] = `${spaceBetween}px`;
        });
    }
    if (params.centeredSlides && params.centeredSlidesBounds) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach((slideSizeValue)=>{
            allSlidesSize += slideSizeValue + (spaceBetween || 0);
        });
        allSlidesSize -= spaceBetween;
        const maxSnap = allSlidesSize - swiperSize;
        snapGrid = snapGrid.map((snap)=>{
            if (snap <= 0) return -offsetBefore;
            if (snap > maxSnap) return maxSnap + offsetAfter;
            return snap;
        });
    }
    if (params.centerInsufficientSlides) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach((slideSizeValue)=>{
            allSlidesSize += slideSizeValue + (spaceBetween || 0);
        });
        allSlidesSize -= spaceBetween;
        if (allSlidesSize < swiperSize) {
            const allSlidesOffset = (swiperSize - allSlidesSize) / 2;
            snapGrid.forEach((snap, snapIndex)=>{
                snapGrid[snapIndex] = snap - allSlidesOffset;
            });
            slidesGrid.forEach((snap, snapIndex)=>{
                slidesGrid[snapIndex] = snap + allSlidesOffset;
            });
        }
    }
    Object.assign(swiper, {
        slides: slides,
        snapGrid: snapGrid,
        slidesGrid: slidesGrid,
        slidesSizesGrid: slidesSizesGrid
    });
    if (params.centeredSlides && params.cssMode && !params.centeredSlidesBounds) {
        (0, $95ca904041552da4$export$2408f22a0fab9ae5)(wrapperEl, "--swiper-centered-offset-before", `${-snapGrid[0]}px`);
        (0, $95ca904041552da4$export$2408f22a0fab9ae5)(wrapperEl, "--swiper-centered-offset-after", `${swiper.size / 2 - slidesSizesGrid[slidesSizesGrid.length - 1] / 2}px`);
        const addToSnapGrid = -swiper.snapGrid[0];
        const addToSlidesGrid = -swiper.slidesGrid[0];
        swiper.snapGrid = swiper.snapGrid.map((v)=>v + addToSnapGrid);
        swiper.slidesGrid = swiper.slidesGrid.map((v)=>v + addToSlidesGrid);
    }
    if (slidesLength !== previousSlidesLength) swiper.emit("slidesLengthChange");
    if (snapGrid.length !== previousSnapGridLength) {
        if (swiper.params.watchOverflow) swiper.checkOverflow();
        swiper.emit("snapGridLengthChange");
    }
    if (slidesGrid.length !== previousSlidesGridLength) swiper.emit("slidesGridLengthChange");
    if (params.watchSlidesProgress) swiper.updateSlidesOffset();
    swiper.emit("slidesUpdated");
    if (!isVirtual && !params.cssMode && (params.effect === "slide" || params.effect === "fade")) {
        const backFaceHiddenClass = `${params.containerModifierClass}backface-hidden`;
        const hasClassBackfaceClassAdded = swiper.el.classList.contains(backFaceHiddenClass);
        if (slidesLength <= params.maxBackfaceHiddenSlides) {
            if (!hasClassBackfaceClassAdded) swiper.el.classList.add(backFaceHiddenClass);
        } else if (hasClassBackfaceClassAdded) swiper.el.classList.remove(backFaceHiddenClass);
    }
}
function $0d6016762a387e31$var$updateAutoHeight(speed) {
    const swiper = this;
    const activeSlides = [];
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    let newHeight = 0;
    let i;
    if (typeof speed === "number") swiper.setTransition(speed);
    else if (speed === true) swiper.setTransition(swiper.params.speed);
    const getSlideByIndex = (index)=>{
        if (isVirtual) return swiper.slides[swiper.getSlideIndexByData(index)];
        return swiper.slides[index];
    };
    // Find slides currently in view
    if (swiper.params.slidesPerView !== "auto" && swiper.params.slidesPerView > 1) {
        if (swiper.params.centeredSlides) (swiper.visibleSlides || []).forEach((slide)=>{
            activeSlides.push(slide);
        });
        else for(i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1){
            const index = swiper.activeIndex + i;
            if (index > swiper.slides.length && !isVirtual) break;
            activeSlides.push(getSlideByIndex(index));
        }
    } else activeSlides.push(getSlideByIndex(swiper.activeIndex));
    // Find new height from highest slide in view
    for(i = 0; i < activeSlides.length; i += 1)if (typeof activeSlides[i] !== "undefined") {
        const height = activeSlides[i].offsetHeight;
        newHeight = height > newHeight ? height : newHeight;
    }
    // Update Height
    if (newHeight || newHeight === 0) swiper.wrapperEl.style.height = `${newHeight}px`;
}
function $0d6016762a387e31$var$updateSlidesOffset() {
    const swiper = this;
    const slides = swiper.slides;
    // eslint-disable-next-line
    const minusOffset = swiper.isElement ? swiper.isHorizontal() ? swiper.wrapperEl.offsetLeft : swiper.wrapperEl.offsetTop : 0;
    for(let i = 0; i < slides.length; i += 1)slides[i].swiperSlideOffset = (swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop) - minusOffset - swiper.cssOverflowAdjustment();
}
function $0d6016762a387e31$var$updateSlidesProgress(translate) {
    if (translate === void 0) translate = this && this.translate || 0;
    const swiper = this;
    const params = swiper.params;
    const { slides: slides, rtlTranslate: rtl, snapGrid: snapGrid } = swiper;
    if (slides.length === 0) return;
    if (typeof slides[0].swiperSlideOffset === "undefined") swiper.updateSlidesOffset();
    let offsetCenter = -translate;
    if (rtl) offsetCenter = translate;
    // Visible Slides
    slides.forEach((slideEl)=>{
        slideEl.classList.remove(params.slideVisibleClass, params.slideFullyVisibleClass);
    });
    swiper.visibleSlidesIndexes = [];
    swiper.visibleSlides = [];
    let spaceBetween = params.spaceBetween;
    if (typeof spaceBetween === "string" && spaceBetween.indexOf("%") >= 0) spaceBetween = parseFloat(spaceBetween.replace("%", "")) / 100 * swiper.size;
    else if (typeof spaceBetween === "string") spaceBetween = parseFloat(spaceBetween);
    for(let i = 0; i < slides.length; i += 1){
        const slide = slides[i];
        let slideOffset = slide.swiperSlideOffset;
        if (params.cssMode && params.centeredSlides) slideOffset -= slides[0].swiperSlideOffset;
        const slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + spaceBetween);
        const originalSlideProgress = (offsetCenter - snapGrid[0] + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + spaceBetween);
        const slideBefore = -(offsetCenter - slideOffset);
        const slideAfter = slideBefore + swiper.slidesSizesGrid[i];
        const isFullyVisible = slideBefore >= 0 && slideBefore <= swiper.size - swiper.slidesSizesGrid[i];
        const isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;
        if (isVisible) {
            swiper.visibleSlides.push(slide);
            swiper.visibleSlidesIndexes.push(i);
            slides[i].classList.add(params.slideVisibleClass);
        }
        if (isFullyVisible) slides[i].classList.add(params.slideFullyVisibleClass);
        slide.progress = rtl ? -slideProgress : slideProgress;
        slide.originalProgress = rtl ? -originalSlideProgress : originalSlideProgress;
    }
}
function $0d6016762a387e31$var$updateProgress(translate) {
    const swiper = this;
    if (typeof translate === "undefined") {
        const multiplier = swiper.rtlTranslate ? -1 : 1;
        // eslint-disable-next-line
        translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
    }
    const params = swiper.params;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    let { progress: progress, isBeginning: isBeginning, isEnd: isEnd, progressLoop: progressLoop } = swiper;
    const wasBeginning = isBeginning;
    const wasEnd = isEnd;
    if (translatesDiff === 0) {
        progress = 0;
        isBeginning = true;
        isEnd = true;
    } else {
        progress = (translate - swiper.minTranslate()) / translatesDiff;
        const isBeginningRounded = Math.abs(translate - swiper.minTranslate()) < 1;
        const isEndRounded = Math.abs(translate - swiper.maxTranslate()) < 1;
        isBeginning = isBeginningRounded || progress <= 0;
        isEnd = isEndRounded || progress >= 1;
        if (isBeginningRounded) progress = 0;
        if (isEndRounded) progress = 1;
    }
    if (params.loop) {
        const firstSlideIndex = swiper.getSlideIndexByData(0);
        const lastSlideIndex = swiper.getSlideIndexByData(swiper.slides.length - 1);
        const firstSlideTranslate = swiper.slidesGrid[firstSlideIndex];
        const lastSlideTranslate = swiper.slidesGrid[lastSlideIndex];
        const translateMax = swiper.slidesGrid[swiper.slidesGrid.length - 1];
        const translateAbs = Math.abs(translate);
        if (translateAbs >= firstSlideTranslate) progressLoop = (translateAbs - firstSlideTranslate) / translateMax;
        else progressLoop = (translateAbs + translateMax - lastSlideTranslate) / translateMax;
        if (progressLoop > 1) progressLoop -= 1;
    }
    Object.assign(swiper, {
        progress: progress,
        progressLoop: progressLoop,
        isBeginning: isBeginning,
        isEnd: isEnd
    });
    if (params.watchSlidesProgress || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);
    if (isBeginning && !wasBeginning) swiper.emit("reachBeginning toEdge");
    if (isEnd && !wasEnd) swiper.emit("reachEnd toEdge");
    if (wasBeginning && !isBeginning || wasEnd && !isEnd) swiper.emit("fromEdge");
    swiper.emit("progress", progress);
}
function $0d6016762a387e31$var$updateSlidesClasses() {
    const swiper = this;
    const { slides: slides, params: params, slidesEl: slidesEl, activeIndex: activeIndex } = swiper;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    const getFilteredSlide = (selector)=>{
        return (0, $95ca904041552da4$export$f1e1789686576879)(slidesEl, `.${params.slideClass}${selector}, swiper-slide${selector}`)[0];
    };
    slides.forEach((slideEl)=>{
        slideEl.classList.remove(params.slideActiveClass, params.slideNextClass, params.slidePrevClass);
    });
    let activeSlide;
    let prevSlide;
    let nextSlide;
    if (isVirtual) {
        if (params.loop) {
            let slideIndex = activeIndex - swiper.virtual.slidesBefore;
            if (slideIndex < 0) slideIndex = swiper.virtual.slides.length + slideIndex;
            if (slideIndex >= swiper.virtual.slides.length) slideIndex -= swiper.virtual.slides.length;
            activeSlide = getFilteredSlide(`[data-swiper-slide-index="${slideIndex}"]`);
        } else activeSlide = getFilteredSlide(`[data-swiper-slide-index="${activeIndex}"]`);
    } else if (gridEnabled) {
        activeSlide = slides.filter((slideEl)=>slideEl.column === activeIndex)[0];
        nextSlide = slides.filter((slideEl)=>slideEl.column === activeIndex + 1)[0];
        prevSlide = slides.filter((slideEl)=>slideEl.column === activeIndex - 1)[0];
    } else activeSlide = slides[activeIndex];
    if (activeSlide) {
        // Active classes
        activeSlide.classList.add(params.slideActiveClass);
        if (gridEnabled) {
            if (nextSlide) nextSlide.classList.add(params.slideNextClass);
            if (prevSlide) prevSlide.classList.add(params.slidePrevClass);
        } else {
            // Next Slide
            nextSlide = (0, $95ca904041552da4$export$ffb5f4729a158638)(activeSlide, `.${params.slideClass}, swiper-slide`)[0];
            if (params.loop && !nextSlide) nextSlide = slides[0];
            if (nextSlide) nextSlide.classList.add(params.slideNextClass);
            // Prev Slide
            prevSlide = (0, $95ca904041552da4$export$9e5f44173e64f162)(activeSlide, `.${params.slideClass}, swiper-slide`)[0];
            params.loop;
            if (prevSlide) prevSlide.classList.add(params.slidePrevClass);
        }
    }
    swiper.emitSlidesClasses();
}
const $0d6016762a387e31$var$processLazyPreloader = (swiper, imageEl)=>{
    if (!swiper || swiper.destroyed || !swiper.params) return;
    const slideSelector = ()=>swiper.isElement ? `swiper-slide` : `.${swiper.params.slideClass}`;
    const slideEl = imageEl.closest(slideSelector());
    if (slideEl) {
        let lazyEl = slideEl.querySelector(`.${swiper.params.lazyPreloaderClass}`);
        if (!lazyEl && swiper.isElement) {
            if (slideEl.shadowRoot) lazyEl = slideEl.shadowRoot.querySelector(`.${swiper.params.lazyPreloaderClass}`);
            else // init later
            requestAnimationFrame(()=>{
                if (slideEl.shadowRoot) {
                    lazyEl = slideEl.shadowRoot.querySelector(`.${swiper.params.lazyPreloaderClass}`);
                    if (lazyEl) lazyEl.remove();
                }
            });
        }
        if (lazyEl) lazyEl.remove();
    }
};
const $0d6016762a387e31$var$unlazy = (swiper, index)=>{
    if (!swiper.slides[index]) return;
    const imageEl = swiper.slides[index].querySelector('[loading="lazy"]');
    if (imageEl) imageEl.removeAttribute("loading");
};
const $0d6016762a387e31$var$preload = (swiper)=>{
    if (!swiper || swiper.destroyed || !swiper.params) return;
    let amount = swiper.params.lazyPreloadPrevNext;
    const len = swiper.slides.length;
    if (!len || !amount || amount < 0) return;
    amount = Math.min(amount, len);
    const slidesPerView = swiper.params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : Math.ceil(swiper.params.slidesPerView);
    const activeIndex = swiper.activeIndex;
    if (swiper.params.grid && swiper.params.grid.rows > 1) {
        const activeColumn = activeIndex;
        const preloadColumns = [
            activeColumn - amount
        ];
        preloadColumns.push(...Array.from({
            length: amount
        }).map((_, i)=>{
            return activeColumn + slidesPerView + i;
        }));
        swiper.slides.forEach((slideEl, i)=>{
            if (preloadColumns.includes(slideEl.column)) $0d6016762a387e31$var$unlazy(swiper, i);
        });
        return;
    }
    const slideIndexLastInView = activeIndex + slidesPerView - 1;
    if (swiper.params.rewind || swiper.params.loop) for(let i = activeIndex - amount; i <= slideIndexLastInView + amount; i += 1){
        const realIndex = (i % len + len) % len;
        if (realIndex < activeIndex || realIndex > slideIndexLastInView) $0d6016762a387e31$var$unlazy(swiper, realIndex);
    }
    else {
        for(let i = Math.max(activeIndex - amount, 0); i <= Math.min(slideIndexLastInView + amount, len - 1); i += 1)if (i !== activeIndex && (i > slideIndexLastInView || i < activeIndex)) $0d6016762a387e31$var$unlazy(swiper, i);
    }
};
function $0d6016762a387e31$var$getActiveIndexByTranslate(swiper) {
    const { slidesGrid: slidesGrid, params: params } = swiper;
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    let activeIndex;
    for(let i = 0; i < slidesGrid.length; i += 1){
        if (typeof slidesGrid[i + 1] !== "undefined") {
            if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) activeIndex = i;
            else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) activeIndex = i + 1;
        } else if (translate >= slidesGrid[i]) activeIndex = i;
    }
    // Normalize slideIndex
    if (params.normalizeSlideIndex) {
        if (activeIndex < 0 || typeof activeIndex === "undefined") activeIndex = 0;
    }
    return activeIndex;
}
function $0d6016762a387e31$var$updateActiveIndex(newActiveIndex) {
    const swiper = this;
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    const { snapGrid: snapGrid, params: params, activeIndex: previousIndex, realIndex: previousRealIndex, snapIndex: previousSnapIndex } = swiper;
    let activeIndex = newActiveIndex;
    let snapIndex;
    const getVirtualRealIndex = (aIndex)=>{
        let realIndex = aIndex - swiper.virtual.slidesBefore;
        if (realIndex < 0) realIndex = swiper.virtual.slides.length + realIndex;
        if (realIndex >= swiper.virtual.slides.length) realIndex -= swiper.virtual.slides.length;
        return realIndex;
    };
    if (typeof activeIndex === "undefined") activeIndex = $0d6016762a387e31$var$getActiveIndexByTranslate(swiper);
    if (snapGrid.indexOf(translate) >= 0) snapIndex = snapGrid.indexOf(translate);
    else {
        const skip = Math.min(params.slidesPerGroupSkip, activeIndex);
        snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
    }
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    if (activeIndex === previousIndex && !swiper.params.loop) {
        if (snapIndex !== previousSnapIndex) {
            swiper.snapIndex = snapIndex;
            swiper.emit("snapIndexChange");
        }
        return;
    }
    if (activeIndex === previousIndex && swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) {
        swiper.realIndex = getVirtualRealIndex(activeIndex);
        return;
    }
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    // Get real index
    let realIndex;
    if (swiper.virtual && params.virtual.enabled && params.loop) realIndex = getVirtualRealIndex(activeIndex);
    else if (gridEnabled) {
        const firstSlideInColumn = swiper.slides.filter((slideEl)=>slideEl.column === activeIndex)[0];
        let activeSlideIndex = parseInt(firstSlideInColumn.getAttribute("data-swiper-slide-index"), 10);
        if (Number.isNaN(activeSlideIndex)) activeSlideIndex = Math.max(swiper.slides.indexOf(firstSlideInColumn), 0);
        realIndex = Math.floor(activeSlideIndex / params.grid.rows);
    } else if (swiper.slides[activeIndex]) {
        const slideIndex = swiper.slides[activeIndex].getAttribute("data-swiper-slide-index");
        if (slideIndex) realIndex = parseInt(slideIndex, 10);
        else realIndex = activeIndex;
    } else realIndex = activeIndex;
    Object.assign(swiper, {
        previousSnapIndex: previousSnapIndex,
        snapIndex: snapIndex,
        previousRealIndex: previousRealIndex,
        realIndex: realIndex,
        previousIndex: previousIndex,
        activeIndex: activeIndex
    });
    if (swiper.initialized) $0d6016762a387e31$var$preload(swiper);
    swiper.emit("activeIndexChange");
    swiper.emit("snapIndexChange");
    if (swiper.initialized || swiper.params.runCallbacksOnInit) {
        if (previousRealIndex !== realIndex) swiper.emit("realIndexChange");
        swiper.emit("slideChange");
    }
}
function $0d6016762a387e31$var$updateClickedSlide(el, path) {
    const swiper = this;
    const params = swiper.params;
    let slide = el.closest(`.${params.slideClass}, swiper-slide`);
    if (!slide && swiper.isElement && path && path.length > 1 && path.includes(el)) [
        ...path.slice(path.indexOf(el) + 1, path.length)
    ].forEach((pathEl)=>{
        if (!slide && pathEl.matches && pathEl.matches(`.${params.slideClass}, swiper-slide`)) slide = pathEl;
    });
    let slideFound = false;
    let slideIndex;
    if (slide) {
        for(let i = 0; i < swiper.slides.length; i += 1)if (swiper.slides[i] === slide) {
            slideFound = true;
            slideIndex = i;
            break;
        }
    }
    if (slide && slideFound) {
        swiper.clickedSlide = slide;
        if (swiper.virtual && swiper.params.virtual.enabled) swiper.clickedIndex = parseInt(slide.getAttribute("data-swiper-slide-index"), 10);
        else swiper.clickedIndex = slideIndex;
    } else {
        swiper.clickedSlide = undefined;
        swiper.clickedIndex = undefined;
        return;
    }
    if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) swiper.slideToClickedSlide();
}
var $0d6016762a387e31$var$update = {
    updateSize: $0d6016762a387e31$var$updateSize,
    updateSlides: $0d6016762a387e31$var$updateSlides,
    updateAutoHeight: $0d6016762a387e31$var$updateAutoHeight,
    updateSlidesOffset: $0d6016762a387e31$var$updateSlidesOffset,
    updateSlidesProgress: $0d6016762a387e31$var$updateSlidesProgress,
    updateProgress: $0d6016762a387e31$var$updateProgress,
    updateSlidesClasses: $0d6016762a387e31$var$updateSlidesClasses,
    updateActiveIndex: $0d6016762a387e31$var$updateActiveIndex,
    updateClickedSlide: $0d6016762a387e31$var$updateClickedSlide
};
function $0d6016762a387e31$var$getSwiperTranslate(axis) {
    if (axis === void 0) axis = this.isHorizontal() ? "x" : "y";
    const swiper = this;
    const { params: params, rtlTranslate: rtl, translate: translate, wrapperEl: wrapperEl } = swiper;
    if (params.virtualTranslate) return rtl ? -translate : translate;
    if (params.cssMode) return translate;
    let currentTranslate = (0, $95ca904041552da4$export$23f2a1d2818174ef)(wrapperEl, axis);
    currentTranslate += swiper.cssOverflowAdjustment();
    if (rtl) currentTranslate = -currentTranslate;
    return currentTranslate || 0;
}
function $0d6016762a387e31$var$setTranslate(translate, byController) {
    const swiper = this;
    const { rtlTranslate: rtl, params: params, wrapperEl: wrapperEl, progress: progress } = swiper;
    let x = 0;
    let y = 0;
    const z = 0;
    if (swiper.isHorizontal()) x = rtl ? -translate : translate;
    else y = translate;
    if (params.roundLengths) {
        x = Math.floor(x);
        y = Math.floor(y);
    }
    swiper.previousTranslate = swiper.translate;
    swiper.translate = swiper.isHorizontal() ? x : y;
    if (params.cssMode) wrapperEl[swiper.isHorizontal() ? "scrollLeft" : "scrollTop"] = swiper.isHorizontal() ? -x : -y;
    else if (!params.virtualTranslate) {
        if (swiper.isHorizontal()) x -= swiper.cssOverflowAdjustment();
        else y -= swiper.cssOverflowAdjustment();
        wrapperEl.style.transform = `translate3d(${x}px, ${y}px, ${z}px)`;
    }
    // Check if we need to update progress
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== progress) swiper.updateProgress(translate);
    swiper.emit("setTranslate", swiper.translate, byController);
}
function $0d6016762a387e31$var$minTranslate() {
    return -this.snapGrid[0];
}
function $0d6016762a387e31$var$maxTranslate() {
    return -this.snapGrid[this.snapGrid.length - 1];
}
function $0d6016762a387e31$var$translateTo(translate, speed, runCallbacks, translateBounds, internal) {
    if (translate === void 0) translate = 0;
    if (speed === void 0) speed = this.params.speed;
    if (runCallbacks === void 0) runCallbacks = true;
    if (translateBounds === void 0) translateBounds = true;
    const swiper = this;
    const { params: params, wrapperEl: wrapperEl } = swiper;
    if (swiper.animating && params.preventInteractionOnTransition) return false;
    const minTranslate = swiper.minTranslate();
    const maxTranslate = swiper.maxTranslate();
    let newTranslate;
    if (translateBounds && translate > minTranslate) newTranslate = minTranslate;
    else if (translateBounds && translate < maxTranslate) newTranslate = maxTranslate;
    else newTranslate = translate;
    // Update progress
    swiper.updateProgress(newTranslate);
    if (params.cssMode) {
        const isH = swiper.isHorizontal();
        if (speed === 0) wrapperEl[isH ? "scrollLeft" : "scrollTop"] = -newTranslate;
        else {
            if (!swiper.support.smoothScroll) {
                (0, $95ca904041552da4$export$43caf9889c228507)({
                    swiper: swiper,
                    targetPosition: -newTranslate,
                    side: isH ? "left" : "top"
                });
                return true;
            }
            wrapperEl.scrollTo({
                [isH ? "left" : "top"]: -newTranslate,
                behavior: "smooth"
            });
        }
        return true;
    }
    if (speed === 0) {
        swiper.setTransition(0);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit("beforeTransitionStart", speed, internal);
            swiper.emit("transitionEnd");
        }
    } else {
        swiper.setTransition(speed);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit("beforeTransitionStart", speed, internal);
            swiper.emit("transitionStart");
        }
        if (!swiper.animating) {
            swiper.animating = true;
            if (!swiper.onTranslateToWrapperTransitionEnd) swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
                if (!swiper || swiper.destroyed) return;
                if (e.target !== this) return;
                swiper.wrapperEl.removeEventListener("transitionend", swiper.onTranslateToWrapperTransitionEnd);
                swiper.onTranslateToWrapperTransitionEnd = null;
                delete swiper.onTranslateToWrapperTransitionEnd;
                if (runCallbacks) swiper.emit("transitionEnd");
            };
            swiper.wrapperEl.addEventListener("transitionend", swiper.onTranslateToWrapperTransitionEnd);
        }
    }
    return true;
}
var $0d6016762a387e31$var$translate = {
    getTranslate: $0d6016762a387e31$var$getSwiperTranslate,
    setTranslate: $0d6016762a387e31$var$setTranslate,
    minTranslate: $0d6016762a387e31$var$minTranslate,
    maxTranslate: $0d6016762a387e31$var$maxTranslate,
    translateTo: $0d6016762a387e31$var$translateTo
};
function $0d6016762a387e31$var$setTransition(duration, byController) {
    const swiper = this;
    if (!swiper.params.cssMode) {
        swiper.wrapperEl.style.transitionDuration = `${duration}ms`;
        swiper.wrapperEl.style.transitionDelay = duration === 0 ? `0ms` : "";
    }
    swiper.emit("setTransition", duration, byController);
}
function $0d6016762a387e31$var$transitionEmit(_ref) {
    let { swiper: swiper, runCallbacks: runCallbacks, direction: direction, step: step } = _ref;
    const { activeIndex: activeIndex, previousIndex: previousIndex } = swiper;
    let dir = direction;
    if (!dir) {
        if (activeIndex > previousIndex) dir = "next";
        else if (activeIndex < previousIndex) dir = "prev";
        else dir = "reset";
    }
    swiper.emit(`transition${step}`);
    if (runCallbacks && activeIndex !== previousIndex) {
        if (dir === "reset") {
            swiper.emit(`slideResetTransition${step}`);
            return;
        }
        swiper.emit(`slideChangeTransition${step}`);
        if (dir === "next") swiper.emit(`slideNextTransition${step}`);
        else swiper.emit(`slidePrevTransition${step}`);
    }
}
function $0d6016762a387e31$var$transitionStart(runCallbacks, direction) {
    if (runCallbacks === void 0) runCallbacks = true;
    const swiper = this;
    const { params: params } = swiper;
    if (params.cssMode) return;
    if (params.autoHeight) swiper.updateAutoHeight();
    $0d6016762a387e31$var$transitionEmit({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: "Start"
    });
}
function $0d6016762a387e31$var$transitionEnd(runCallbacks, direction) {
    if (runCallbacks === void 0) runCallbacks = true;
    const swiper = this;
    const { params: params } = swiper;
    swiper.animating = false;
    if (params.cssMode) return;
    swiper.setTransition(0);
    $0d6016762a387e31$var$transitionEmit({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: "End"
    });
}
var $0d6016762a387e31$var$transition = {
    setTransition: $0d6016762a387e31$var$setTransition,
    transitionStart: $0d6016762a387e31$var$transitionStart,
    transitionEnd: $0d6016762a387e31$var$transitionEnd
};
function $0d6016762a387e31$var$slideTo(index, speed, runCallbacks, internal, initial) {
    if (index === void 0) index = 0;
    if (speed === void 0) speed = this.params.speed;
    if (runCallbacks === void 0) runCallbacks = true;
    if (typeof index === "string") index = parseInt(index, 10);
    const swiper = this;
    let slideIndex = index;
    if (slideIndex < 0) slideIndex = 0;
    const { params: params, snapGrid: snapGrid, slidesGrid: slidesGrid, previousIndex: previousIndex, activeIndex: activeIndex, rtlTranslate: rtl, wrapperEl: wrapperEl, enabled: enabled } = swiper;
    if (swiper.animating && params.preventInteractionOnTransition || !enabled && !internal && !initial || swiper.destroyed) return false;
    const skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
    let snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    const translate = -snapGrid[snapIndex];
    // Normalize slideIndex
    if (params.normalizeSlideIndex) for(let i = 0; i < slidesGrid.length; i += 1){
        const normalizedTranslate = -Math.floor(translate * 100);
        const normalizedGrid = Math.floor(slidesGrid[i] * 100);
        const normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);
        if (typeof slidesGrid[i + 1] !== "undefined") {
            if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGrid) / 2) slideIndex = i;
            else if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext) slideIndex = i + 1;
        } else if (normalizedTranslate >= normalizedGrid) slideIndex = i;
    }
    // Directions locks
    if (swiper.initialized && slideIndex !== activeIndex) {
        if (!swiper.allowSlideNext && (rtl ? translate > swiper.translate && translate > swiper.minTranslate() : translate < swiper.translate && translate < swiper.minTranslate())) return false;
        if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
            if ((activeIndex || 0) !== slideIndex) return false;
        }
    }
    if (slideIndex !== (previousIndex || 0) && runCallbacks) swiper.emit("beforeSlideChangeStart");
    // Update progress
    swiper.updateProgress(translate);
    let direction;
    if (slideIndex > activeIndex) direction = "next";
    else if (slideIndex < activeIndex) direction = "prev";
    else direction = "reset";
    // Update Index
    if (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate) {
        swiper.updateActiveIndex(slideIndex);
        // Update Height
        if (params.autoHeight) swiper.updateAutoHeight();
        swiper.updateSlidesClasses();
        if (params.effect !== "slide") swiper.setTranslate(translate);
        if (direction !== "reset") {
            swiper.transitionStart(runCallbacks, direction);
            swiper.transitionEnd(runCallbacks, direction);
        }
        return false;
    }
    if (params.cssMode) {
        const isH = swiper.isHorizontal();
        const t = rtl ? translate : -translate;
        if (speed === 0) {
            const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
            if (isVirtual) {
                swiper.wrapperEl.style.scrollSnapType = "none";
                swiper._immediateVirtual = true;
            }
            if (isVirtual && !swiper._cssModeVirtualInitialSet && swiper.params.initialSlide > 0) {
                swiper._cssModeVirtualInitialSet = true;
                requestAnimationFrame(()=>{
                    wrapperEl[isH ? "scrollLeft" : "scrollTop"] = t;
                });
            } else wrapperEl[isH ? "scrollLeft" : "scrollTop"] = t;
            if (isVirtual) requestAnimationFrame(()=>{
                swiper.wrapperEl.style.scrollSnapType = "";
                swiper._immediateVirtual = false;
            });
        } else {
            if (!swiper.support.smoothScroll) {
                (0, $95ca904041552da4$export$43caf9889c228507)({
                    swiper: swiper,
                    targetPosition: t,
                    side: isH ? "left" : "top"
                });
                return true;
            }
            wrapperEl.scrollTo({
                [isH ? "left" : "top"]: t,
                behavior: "smooth"
            });
        }
        return true;
    }
    swiper.setTransition(speed);
    swiper.setTranslate(translate);
    swiper.updateActiveIndex(slideIndex);
    swiper.updateSlidesClasses();
    swiper.emit("beforeTransitionStart", speed, internal);
    swiper.transitionStart(runCallbacks, direction);
    if (speed === 0) swiper.transitionEnd(runCallbacks, direction);
    else if (!swiper.animating) {
        swiper.animating = true;
        if (!swiper.onSlideToWrapperTransitionEnd) swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
            if (!swiper || swiper.destroyed) return;
            if (e.target !== this) return;
            swiper.wrapperEl.removeEventListener("transitionend", swiper.onSlideToWrapperTransitionEnd);
            swiper.onSlideToWrapperTransitionEnd = null;
            delete swiper.onSlideToWrapperTransitionEnd;
            swiper.transitionEnd(runCallbacks, direction);
        };
        swiper.wrapperEl.addEventListener("transitionend", swiper.onSlideToWrapperTransitionEnd);
    }
    return true;
}
function $0d6016762a387e31$var$slideToLoop(index, speed, runCallbacks, internal) {
    if (index === void 0) index = 0;
    if (speed === void 0) speed = this.params.speed;
    if (runCallbacks === void 0) runCallbacks = true;
    if (typeof index === "string") {
        const indexAsNumber = parseInt(index, 10);
        index = indexAsNumber;
    }
    const swiper = this;
    if (swiper.destroyed) return;
    const gridEnabled = swiper.grid && swiper.params.grid && swiper.params.grid.rows > 1;
    let newIndex = index;
    if (swiper.params.loop) {
        if (swiper.virtual && swiper.params.virtual.enabled) // eslint-disable-next-line
        newIndex = newIndex + swiper.virtual.slidesBefore;
        else {
            let targetSlideIndex;
            if (gridEnabled) {
                const slideIndex = newIndex * swiper.params.grid.rows;
                targetSlideIndex = swiper.slides.filter((slideEl)=>slideEl.getAttribute("data-swiper-slide-index") * 1 === slideIndex)[0].column;
            } else targetSlideIndex = swiper.getSlideIndexByData(newIndex);
            const cols = gridEnabled ? Math.ceil(swiper.slides.length / swiper.params.grid.rows) : swiper.slides.length;
            const { centeredSlides: centeredSlides } = swiper.params;
            let slidesPerView = swiper.params.slidesPerView;
            if (slidesPerView === "auto") slidesPerView = swiper.slidesPerViewDynamic();
            else {
                slidesPerView = Math.ceil(parseFloat(swiper.params.slidesPerView, 10));
                if (centeredSlides && slidesPerView % 2 === 0) slidesPerView = slidesPerView + 1;
            }
            let needLoopFix = cols - targetSlideIndex < slidesPerView;
            if (centeredSlides) needLoopFix = needLoopFix || targetSlideIndex < Math.ceil(slidesPerView / 2);
            if (needLoopFix) {
                const direction = centeredSlides ? targetSlideIndex < swiper.activeIndex ? "prev" : "next" : targetSlideIndex - swiper.activeIndex - 1 < swiper.params.slidesPerView ? "next" : "prev";
                swiper.loopFix({
                    direction: direction,
                    slideTo: true,
                    activeSlideIndex: direction === "next" ? targetSlideIndex + 1 : targetSlideIndex - cols + 1,
                    slideRealIndex: direction === "next" ? swiper.realIndex : undefined
                });
            }
            if (gridEnabled) {
                const slideIndex = newIndex * swiper.params.grid.rows;
                newIndex = swiper.slides.filter((slideEl)=>slideEl.getAttribute("data-swiper-slide-index") * 1 === slideIndex)[0].column;
            } else newIndex = swiper.getSlideIndexByData(newIndex);
        }
    }
    requestAnimationFrame(()=>{
        swiper.slideTo(newIndex, speed, runCallbacks, internal);
    });
    return swiper;
}
/* eslint no-unused-vars: "off" */ function $0d6016762a387e31$var$slideNext(speed, runCallbacks, internal) {
    if (speed === void 0) speed = this.params.speed;
    if (runCallbacks === void 0) runCallbacks = true;
    const swiper = this;
    const { enabled: enabled, params: params, animating: animating } = swiper;
    if (!enabled || swiper.destroyed) return swiper;
    let perGroup = params.slidesPerGroup;
    if (params.slidesPerView === "auto" && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) perGroup = Math.max(swiper.slidesPerViewDynamic("current", true), 1);
    const increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : perGroup;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    if (params.loop) {
        if (animating && !isVirtual && params.loopPreventsSliding) return false;
        swiper.loopFix({
            direction: "next"
        });
        // eslint-disable-next-line
        swiper._clientLeft = swiper.wrapperEl.clientLeft;
        if (swiper.activeIndex === swiper.slides.length - 1 && params.cssMode) {
            requestAnimationFrame(()=>{
                swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
            });
            return true;
        }
    }
    if (params.rewind && swiper.isEnd) return swiper.slideTo(0, speed, runCallbacks, internal);
    return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function $0d6016762a387e31$var$slidePrev(speed, runCallbacks, internal) {
    if (speed === void 0) speed = this.params.speed;
    if (runCallbacks === void 0) runCallbacks = true;
    const swiper = this;
    const { params: params, snapGrid: snapGrid, slidesGrid: slidesGrid, rtlTranslate: rtlTranslate, enabled: enabled, animating: animating } = swiper;
    if (!enabled || swiper.destroyed) return swiper;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    if (params.loop) {
        if (animating && !isVirtual && params.loopPreventsSliding) return false;
        swiper.loopFix({
            direction: "prev"
        });
        // eslint-disable-next-line
        swiper._clientLeft = swiper.wrapperEl.clientLeft;
    }
    const translate = rtlTranslate ? swiper.translate : -swiper.translate;
    function normalize(val) {
        if (val < 0) return -Math.floor(Math.abs(val));
        return Math.floor(val);
    }
    const normalizedTranslate = normalize(translate);
    const normalizedSnapGrid = snapGrid.map((val)=>normalize(val));
    let prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
    if (typeof prevSnap === "undefined" && params.cssMode) {
        let prevSnapIndex;
        snapGrid.forEach((snap, snapIndex)=>{
            if (normalizedTranslate >= snap) // prevSnap = snap;
            prevSnapIndex = snapIndex;
        });
        if (typeof prevSnapIndex !== "undefined") prevSnap = snapGrid[prevSnapIndex > 0 ? prevSnapIndex - 1 : prevSnapIndex];
    }
    let prevIndex = 0;
    if (typeof prevSnap !== "undefined") {
        prevIndex = slidesGrid.indexOf(prevSnap);
        if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
        if (params.slidesPerView === "auto" && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
            prevIndex = prevIndex - swiper.slidesPerViewDynamic("previous", true) + 1;
            prevIndex = Math.max(prevIndex, 0);
        }
    }
    if (params.rewind && swiper.isBeginning) {
        const lastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        return swiper.slideTo(lastIndex, speed, runCallbacks, internal);
    } else if (params.loop && swiper.activeIndex === 0 && params.cssMode) {
        requestAnimationFrame(()=>{
            swiper.slideTo(prevIndex, speed, runCallbacks, internal);
        });
        return true;
    }
    return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function $0d6016762a387e31$var$slideReset(speed, runCallbacks, internal) {
    if (speed === void 0) speed = this.params.speed;
    if (runCallbacks === void 0) runCallbacks = true;
    const swiper = this;
    if (swiper.destroyed) return;
    return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function $0d6016762a387e31$var$slideToClosest(speed, runCallbacks, internal, threshold) {
    if (speed === void 0) speed = this.params.speed;
    if (runCallbacks === void 0) runCallbacks = true;
    if (threshold === void 0) threshold = 0.5;
    const swiper = this;
    if (swiper.destroyed) return;
    let index = swiper.activeIndex;
    const skip = Math.min(swiper.params.slidesPerGroupSkip, index);
    const snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    if (translate >= swiper.snapGrid[snapIndex]) {
        // The current translate is on or after the current snap index, so the choice
        // is between the current index and the one after it.
        const currentSnap = swiper.snapGrid[snapIndex];
        const nextSnap = swiper.snapGrid[snapIndex + 1];
        if (translate - currentSnap > (nextSnap - currentSnap) * threshold) index += swiper.params.slidesPerGroup;
    } else {
        // The current translate is before the current snap index, so the choice
        // is between the current index and the one before it.
        const prevSnap = swiper.snapGrid[snapIndex - 1];
        const currentSnap = swiper.snapGrid[snapIndex];
        if (translate - prevSnap <= (currentSnap - prevSnap) * threshold) index -= swiper.params.slidesPerGroup;
    }
    index = Math.max(index, 0);
    index = Math.min(index, swiper.slidesGrid.length - 1);
    return swiper.slideTo(index, speed, runCallbacks, internal);
}
function $0d6016762a387e31$var$slideToClickedSlide() {
    const swiper = this;
    if (swiper.destroyed) return;
    const { params: params, slidesEl: slidesEl } = swiper;
    const slidesPerView = params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : params.slidesPerView;
    let slideToIndex = swiper.clickedIndex;
    let realIndex;
    const slideSelector = swiper.isElement ? `swiper-slide` : `.${params.slideClass}`;
    if (params.loop) {
        if (swiper.animating) return;
        realIndex = parseInt(swiper.clickedSlide.getAttribute("data-swiper-slide-index"), 10);
        if (params.centeredSlides) {
            if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
                swiper.loopFix();
                slideToIndex = swiper.getSlideIndex((0, $95ca904041552da4$export$f1e1789686576879)(slidesEl, `${slideSelector}[data-swiper-slide-index="${realIndex}"]`)[0]);
                (0, $95ca904041552da4$export$7ccc53e8f1e7dfc5)(()=>{
                    swiper.slideTo(slideToIndex);
                });
            } else swiper.slideTo(slideToIndex);
        } else if (slideToIndex > swiper.slides.length - slidesPerView) {
            swiper.loopFix();
            slideToIndex = swiper.getSlideIndex((0, $95ca904041552da4$export$f1e1789686576879)(slidesEl, `${slideSelector}[data-swiper-slide-index="${realIndex}"]`)[0]);
            (0, $95ca904041552da4$export$7ccc53e8f1e7dfc5)(()=>{
                swiper.slideTo(slideToIndex);
            });
        } else swiper.slideTo(slideToIndex);
    } else swiper.slideTo(slideToIndex);
}
var $0d6016762a387e31$var$slide = {
    slideTo: $0d6016762a387e31$var$slideTo,
    slideToLoop: $0d6016762a387e31$var$slideToLoop,
    slideNext: $0d6016762a387e31$var$slideNext,
    slidePrev: $0d6016762a387e31$var$slidePrev,
    slideReset: $0d6016762a387e31$var$slideReset,
    slideToClosest: $0d6016762a387e31$var$slideToClosest,
    slideToClickedSlide: $0d6016762a387e31$var$slideToClickedSlide
};
function $0d6016762a387e31$var$loopCreate(slideRealIndex) {
    const swiper = this;
    const { params: params, slidesEl: slidesEl } = swiper;
    if (!params.loop || swiper.virtual && swiper.params.virtual.enabled) return;
    const initSlides = ()=>{
        const slides = (0, $95ca904041552da4$export$f1e1789686576879)(slidesEl, `.${params.slideClass}, swiper-slide`);
        slides.forEach((el, index)=>{
            el.setAttribute("data-swiper-slide-index", index);
        });
    };
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    const slidesPerGroup = params.slidesPerGroup * (gridEnabled ? params.grid.rows : 1);
    const shouldFillGroup = swiper.slides.length % slidesPerGroup !== 0;
    const shouldFillGrid = gridEnabled && swiper.slides.length % params.grid.rows !== 0;
    const addBlankSlides = (amountOfSlides)=>{
        for(let i = 0; i < amountOfSlides; i += 1){
            const slideEl = swiper.isElement ? (0, $95ca904041552da4$export$db3b6bfb95261072)("swiper-slide", [
                params.slideBlankClass
            ]) : (0, $95ca904041552da4$export$db3b6bfb95261072)("div", [
                params.slideClass,
                params.slideBlankClass
            ]);
            swiper.slidesEl.append(slideEl);
        }
    };
    if (shouldFillGroup) {
        if (params.loopAddBlankSlides) {
            const slidesToAdd = slidesPerGroup - swiper.slides.length % slidesPerGroup;
            addBlankSlides(slidesToAdd);
            swiper.recalcSlides();
            swiper.updateSlides();
        } else (0, $95ca904041552da4$export$625550452a3fa3ec)("Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
        initSlides();
    } else if (shouldFillGrid) {
        if (params.loopAddBlankSlides) {
            const slidesToAdd = params.grid.rows - swiper.slides.length % params.grid.rows;
            addBlankSlides(slidesToAdd);
            swiper.recalcSlides();
            swiper.updateSlides();
        } else (0, $95ca904041552da4$export$625550452a3fa3ec)("Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
        initSlides();
    } else initSlides();
    swiper.loopFix({
        slideRealIndex: slideRealIndex,
        direction: params.centeredSlides ? undefined : "next"
    });
}
function $0d6016762a387e31$var$loopFix(_temp) {
    let { slideRealIndex: slideRealIndex, slideTo: slideTo = true, direction: direction, setTranslate: setTranslate, activeSlideIndex: activeSlideIndex, byController: byController, byMousewheel: byMousewheel } = _temp === void 0 ? {} : _temp;
    const swiper = this;
    if (!swiper.params.loop) return;
    swiper.emit("beforeLoopFix");
    const { slides: slides, allowSlidePrev: allowSlidePrev, allowSlideNext: allowSlideNext, slidesEl: slidesEl, params: params } = swiper;
    const { centeredSlides: centeredSlides } = params;
    swiper.allowSlidePrev = true;
    swiper.allowSlideNext = true;
    if (swiper.virtual && params.virtual.enabled) {
        if (slideTo) {
            if (!params.centeredSlides && swiper.snapIndex === 0) swiper.slideTo(swiper.virtual.slides.length, 0, false, true);
            else if (params.centeredSlides && swiper.snapIndex < params.slidesPerView) swiper.slideTo(swiper.virtual.slides.length + swiper.snapIndex, 0, false, true);
            else if (swiper.snapIndex === swiper.snapGrid.length - 1) swiper.slideTo(swiper.virtual.slidesBefore, 0, false, true);
        }
        swiper.allowSlidePrev = allowSlidePrev;
        swiper.allowSlideNext = allowSlideNext;
        swiper.emit("loopFix");
        return;
    }
    let slidesPerView = params.slidesPerView;
    if (slidesPerView === "auto") slidesPerView = swiper.slidesPerViewDynamic();
    else {
        slidesPerView = Math.ceil(parseFloat(params.slidesPerView, 10));
        if (centeredSlides && slidesPerView % 2 === 0) slidesPerView = slidesPerView + 1;
    }
    const slidesPerGroup = params.slidesPerGroupAuto ? slidesPerView : params.slidesPerGroup;
    let loopedSlides = slidesPerGroup;
    if (loopedSlides % slidesPerGroup !== 0) loopedSlides += slidesPerGroup - loopedSlides % slidesPerGroup;
    loopedSlides += params.loopAdditionalSlides;
    swiper.loopedSlides = loopedSlides;
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    if (slides.length < slidesPerView + loopedSlides) (0, $95ca904041552da4$export$625550452a3fa3ec)("Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled and not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters");
    else if (gridEnabled && params.grid.fill === "row") (0, $95ca904041552da4$export$625550452a3fa3ec)("Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`");
    const prependSlidesIndexes = [];
    const appendSlidesIndexes = [];
    let activeIndex = swiper.activeIndex;
    if (typeof activeSlideIndex === "undefined") activeSlideIndex = swiper.getSlideIndex(slides.filter((el)=>el.classList.contains(params.slideActiveClass))[0]);
    else activeIndex = activeSlideIndex;
    const isNext = direction === "next" || !direction;
    const isPrev = direction === "prev" || !direction;
    let slidesPrepended = 0;
    let slidesAppended = 0;
    const cols = gridEnabled ? Math.ceil(slides.length / params.grid.rows) : slides.length;
    const activeColIndex = gridEnabled ? slides[activeSlideIndex].column : activeSlideIndex;
    const activeColIndexWithShift = activeColIndex + (centeredSlides && typeof setTranslate === "undefined" ? -slidesPerView / 2 + 0.5 : 0);
    // prepend last slides before start
    if (activeColIndexWithShift < loopedSlides) {
        slidesPrepended = Math.max(loopedSlides - activeColIndexWithShift, slidesPerGroup);
        for(let i = 0; i < loopedSlides - activeColIndexWithShift; i += 1){
            const index = i - Math.floor(i / cols) * cols;
            if (gridEnabled) {
                const colIndexToPrepend = cols - index - 1;
                for(let i = slides.length - 1; i >= 0; i -= 1)if (slides[i].column === colIndexToPrepend) prependSlidesIndexes.push(i);
            // slides.forEach((slide, slideIndex) => {
            //   if (slide.column === colIndexToPrepend) prependSlidesIndexes.push(slideIndex);
            // });
            } else prependSlidesIndexes.push(cols - index - 1);
        }
    } else if (activeColIndexWithShift + slidesPerView > cols - loopedSlides) {
        slidesAppended = Math.max(activeColIndexWithShift - (cols - loopedSlides * 2), slidesPerGroup);
        for(let i = 0; i < slidesAppended; i += 1){
            const index = i - Math.floor(i / cols) * cols;
            if (gridEnabled) slides.forEach((slide, slideIndex)=>{
                if (slide.column === index) appendSlidesIndexes.push(slideIndex);
            });
            else appendSlidesIndexes.push(index);
        }
    }
    swiper.__preventObserver__ = true;
    requestAnimationFrame(()=>{
        swiper.__preventObserver__ = false;
    });
    if (isPrev) prependSlidesIndexes.forEach((index)=>{
        slides[index].swiperLoopMoveDOM = true;
        slidesEl.prepend(slides[index]);
        slides[index].swiperLoopMoveDOM = false;
    });
    if (isNext) appendSlidesIndexes.forEach((index)=>{
        slides[index].swiperLoopMoveDOM = true;
        slidesEl.append(slides[index]);
        slides[index].swiperLoopMoveDOM = false;
    });
    swiper.recalcSlides();
    if (params.slidesPerView === "auto") swiper.updateSlides();
    else if (gridEnabled && (prependSlidesIndexes.length > 0 && isPrev || appendSlidesIndexes.length > 0 && isNext)) swiper.slides.forEach((slide, slideIndex)=>{
        swiper.grid.updateSlide(slideIndex, slide, swiper.slides);
    });
    if (params.watchSlidesProgress) swiper.updateSlidesOffset();
    if (slideTo) {
        if (prependSlidesIndexes.length > 0 && isPrev) {
            if (typeof slideRealIndex === "undefined") {
                const currentSlideTranslate = swiper.slidesGrid[activeIndex];
                const newSlideTranslate = swiper.slidesGrid[activeIndex + slidesPrepended];
                const diff = newSlideTranslate - currentSlideTranslate;
                if (byMousewheel) swiper.setTranslate(swiper.translate - diff);
                else {
                    swiper.slideTo(activeIndex + slidesPrepended, 0, false, true);
                    if (setTranslate) {
                        swiper.touchEventsData.startTranslate = swiper.touchEventsData.startTranslate - diff;
                        swiper.touchEventsData.currentTranslate = swiper.touchEventsData.currentTranslate - diff;
                    }
                }
            } else if (setTranslate) {
                const shift = gridEnabled ? prependSlidesIndexes.length / params.grid.rows : prependSlidesIndexes.length;
                swiper.slideTo(swiper.activeIndex + shift, 0, false, true);
                swiper.touchEventsData.currentTranslate = swiper.translate;
            }
        } else if (appendSlidesIndexes.length > 0 && isNext) {
            if (typeof slideRealIndex === "undefined") {
                const currentSlideTranslate = swiper.slidesGrid[activeIndex];
                const newSlideTranslate = swiper.slidesGrid[activeIndex - slidesAppended];
                const diff = newSlideTranslate - currentSlideTranslate;
                if (byMousewheel) swiper.setTranslate(swiper.translate - diff);
                else {
                    swiper.slideTo(activeIndex - slidesAppended, 0, false, true);
                    if (setTranslate) {
                        swiper.touchEventsData.startTranslate = swiper.touchEventsData.startTranslate - diff;
                        swiper.touchEventsData.currentTranslate = swiper.touchEventsData.currentTranslate - diff;
                    }
                }
            } else {
                const shift = gridEnabled ? appendSlidesIndexes.length / params.grid.rows : appendSlidesIndexes.length;
                swiper.slideTo(swiper.activeIndex - shift, 0, false, true);
            }
        }
    }
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.controller && swiper.controller.control && !byController) {
        const loopParams = {
            slideRealIndex: slideRealIndex,
            direction: direction,
            setTranslate: setTranslate,
            activeSlideIndex: activeSlideIndex,
            byController: true
        };
        if (Array.isArray(swiper.controller.control)) swiper.controller.control.forEach((c)=>{
            if (!c.destroyed && c.params.loop) c.loopFix({
                ...loopParams,
                slideTo: c.params.slidesPerView === params.slidesPerView ? slideTo : false
            });
        });
        else if (swiper.controller.control instanceof swiper.constructor && swiper.controller.control.params.loop) swiper.controller.control.loopFix({
            ...loopParams,
            slideTo: swiper.controller.control.params.slidesPerView === params.slidesPerView ? slideTo : false
        });
    }
    swiper.emit("loopFix");
}
function $0d6016762a387e31$var$loopDestroy() {
    const swiper = this;
    const { params: params, slidesEl: slidesEl } = swiper;
    if (!params.loop || swiper.virtual && swiper.params.virtual.enabled) return;
    swiper.recalcSlides();
    const newSlidesOrder = [];
    swiper.slides.forEach((slideEl)=>{
        const index = typeof slideEl.swiperSlideIndex === "undefined" ? slideEl.getAttribute("data-swiper-slide-index") * 1 : slideEl.swiperSlideIndex;
        newSlidesOrder[index] = slideEl;
    });
    swiper.slides.forEach((slideEl)=>{
        slideEl.removeAttribute("data-swiper-slide-index");
    });
    newSlidesOrder.forEach((slideEl)=>{
        slidesEl.append(slideEl);
    });
    swiper.recalcSlides();
    swiper.slideTo(swiper.realIndex, 0);
}
var $0d6016762a387e31$var$loop = {
    loopCreate: $0d6016762a387e31$var$loopCreate,
    loopFix: $0d6016762a387e31$var$loopFix,
    loopDestroy: $0d6016762a387e31$var$loopDestroy
};
function $0d6016762a387e31$var$setGrabCursor(moving) {
    const swiper = this;
    if (!swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    const el = swiper.params.touchEventsTarget === "container" ? swiper.el : swiper.wrapperEl;
    if (swiper.isElement) swiper.__preventObserver__ = true;
    el.style.cursor = "move";
    el.style.cursor = moving ? "grabbing" : "grab";
    if (swiper.isElement) requestAnimationFrame(()=>{
        swiper.__preventObserver__ = false;
    });
}
function $0d6016762a387e31$var$unsetGrabCursor() {
    const swiper = this;
    if (swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    if (swiper.isElement) swiper.__preventObserver__ = true;
    swiper[swiper.params.touchEventsTarget === "container" ? "el" : "wrapperEl"].style.cursor = "";
    if (swiper.isElement) requestAnimationFrame(()=>{
        swiper.__preventObserver__ = false;
    });
}
var $0d6016762a387e31$var$grabCursor = {
    setGrabCursor: $0d6016762a387e31$var$setGrabCursor,
    unsetGrabCursor: $0d6016762a387e31$var$unsetGrabCursor
};
// Modified from https://stackoverflow.com/questions/54520554/custom-element-getrootnode-closest-function-crossing-multiple-parent-shadowd
function $0d6016762a387e31$var$closestElement(selector, base) {
    if (base === void 0) base = this;
    function __closestFrom(el) {
        if (!el || el === (0, $73cf9966c142bfa0$export$39b482c5e57630a8)() || el === (0, $73cf9966c142bfa0$export$407448d2b89b1813)()) return null;
        if (el.assignedSlot) el = el.assignedSlot;
        const found = el.closest(selector);
        if (!found && !el.getRootNode) return null;
        return found || __closestFrom(el.getRootNode().host);
    }
    return __closestFrom(base);
}
function $0d6016762a387e31$var$preventEdgeSwipe(swiper, event, startX) {
    const window1 = (0, $73cf9966c142bfa0$export$407448d2b89b1813)();
    const { params: params } = swiper;
    const edgeSwipeDetection = params.edgeSwipeDetection;
    const edgeSwipeThreshold = params.edgeSwipeThreshold;
    if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window1.innerWidth - edgeSwipeThreshold)) {
        if (edgeSwipeDetection === "prevent") {
            event.preventDefault();
            return true;
        }
        return false;
    }
    return true;
}
function $0d6016762a387e31$var$onTouchStart(event) {
    const swiper = this;
    const document1 = (0, $73cf9966c142bfa0$export$39b482c5e57630a8)();
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    const data = swiper.touchEventsData;
    if (e.type === "pointerdown") {
        if (data.pointerId !== null && data.pointerId !== e.pointerId) return;
        data.pointerId = e.pointerId;
    } else if (e.type === "touchstart" && e.targetTouches.length === 1) data.touchId = e.targetTouches[0].identifier;
    if (e.type === "touchstart") {
        // don't proceed touch event
        $0d6016762a387e31$var$preventEdgeSwipe(swiper, e, e.targetTouches[0].pageX);
        return;
    }
    const { params: params, touches: touches, enabled: enabled } = swiper;
    if (!enabled) return;
    if (!params.simulateTouch && e.pointerType === "mouse") return;
    if (swiper.animating && params.preventInteractionOnTransition) return;
    if (!swiper.animating && params.cssMode && params.loop) swiper.loopFix();
    let targetEl = e.target;
    if (params.touchEventsTarget === "wrapper") {
        if (!swiper.wrapperEl.contains(targetEl)) return;
    }
    if ("which" in e && e.which === 3) return;
    if ("button" in e && e.button > 0) return;
    if (data.isTouched && data.isMoved) return;
    // change target el for shadow root component
    const swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== "";
    // eslint-disable-next-line
    const eventPath = e.composedPath ? e.composedPath() : e.path;
    if (swipingClassHasValue && e.target && e.target.shadowRoot && eventPath) targetEl = eventPath[0];
    const noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : `.${params.noSwipingClass}`;
    const isTargetShadow = !!(e.target && e.target.shadowRoot);
    // use closestElement for shadow root element to get the actual closest for nested shadow root element
    if (params.noSwiping && (isTargetShadow ? $0d6016762a387e31$var$closestElement(noSwipingSelector, targetEl) : targetEl.closest(noSwipingSelector))) {
        swiper.allowClick = true;
        return;
    }
    if (params.swipeHandler) {
        if (!targetEl.closest(params.swipeHandler)) return;
    }
    touches.currentX = e.pageX;
    touches.currentY = e.pageY;
    const startX = touches.currentX;
    const startY = touches.currentY;
    // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore
    if (!$0d6016762a387e31$var$preventEdgeSwipe(swiper, e, startX)) return;
    Object.assign(data, {
        isTouched: true,
        isMoved: false,
        allowTouchCallbacks: true,
        isScrolling: undefined,
        startMoving: undefined
    });
    touches.startX = startX;
    touches.startY = startY;
    data.touchStartTime = (0, $95ca904041552da4$export$4368d992c4eafac0)();
    swiper.allowClick = true;
    swiper.updateSize();
    swiper.swipeDirection = undefined;
    if (params.threshold > 0) data.allowThresholdMove = false;
    let preventDefault = true;
    if (targetEl.matches(data.focusableElements)) {
        preventDefault = false;
        if (targetEl.nodeName === "SELECT") data.isTouched = false;
    }
    if (document1.activeElement && document1.activeElement.matches(data.focusableElements) && document1.activeElement !== targetEl) document1.activeElement.blur();
    const shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
    if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !targetEl.isContentEditable) e.preventDefault();
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode && swiper.animating && !params.cssMode) swiper.freeMode.onTouchStart();
    swiper.emit("touchStart", e);
}
function $0d6016762a387e31$var$onTouchMove(event) {
    const document1 = (0, $73cf9966c142bfa0$export$39b482c5e57630a8)();
    const swiper = this;
    const data = swiper.touchEventsData;
    const { params: params, touches: touches, rtlTranslate: rtl, enabled: enabled } = swiper;
    if (!enabled) return;
    if (!params.simulateTouch && event.pointerType === "mouse") return;
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    if (e.type === "pointermove") {
        if (data.touchId !== null) return; // return from pointer if we use touch
        const id = e.pointerId;
        if (id !== data.pointerId) return;
    }
    let targetTouch;
    if (e.type === "touchmove") {
        targetTouch = [
            ...e.changedTouches
        ].filter((t)=>t.identifier === data.touchId)[0];
        if (!targetTouch || targetTouch.identifier !== data.touchId) return;
    } else targetTouch = e;
    if (!data.isTouched) {
        if (data.startMoving && data.isScrolling) swiper.emit("touchMoveOpposite", e);
        return;
    }
    const pageX = targetTouch.pageX;
    const pageY = targetTouch.pageY;
    if (e.preventedByNestedSwiper) {
        touches.startX = pageX;
        touches.startY = pageY;
        return;
    }
    if (!swiper.allowTouchMove) {
        if (!e.target.matches(data.focusableElements)) swiper.allowClick = false;
        if (data.isTouched) {
            Object.assign(touches, {
                startX: pageX,
                startY: pageY,
                currentX: pageX,
                currentY: pageY
            });
            data.touchStartTime = (0, $95ca904041552da4$export$4368d992c4eafac0)();
        }
        return;
    }
    if (params.touchReleaseOnEdges && !params.loop) {
        if (swiper.isVertical()) // Vertical
        {
            if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
                data.isTouched = false;
                data.isMoved = false;
                return;
            }
        } else if (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate()) return;
    }
    if (document1.activeElement) {
        if (e.target === document1.activeElement && e.target.matches(data.focusableElements)) {
            data.isMoved = true;
            swiper.allowClick = false;
            return;
        }
    }
    if (data.allowTouchCallbacks) swiper.emit("touchMove", e);
    touches.previousX = touches.currentX;
    touches.previousY = touches.currentY;
    touches.currentX = pageX;
    touches.currentY = pageY;
    const diffX = touches.currentX - touches.startX;
    const diffY = touches.currentY - touches.startY;
    if (swiper.params.threshold && Math.sqrt(diffX ** 2 + diffY ** 2) < swiper.params.threshold) return;
    if (typeof data.isScrolling === "undefined") {
        let touchAngle;
        if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) data.isScrolling = false;
        else // eslint-disable-next-line
        if (diffX * diffX + diffY * diffY >= 25) {
            touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
            data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
        }
    }
    if (data.isScrolling) swiper.emit("touchMoveOpposite", e);
    if (typeof data.startMoving === "undefined") {
        if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) data.startMoving = true;
    }
    if (data.isScrolling) {
        data.isTouched = false;
        return;
    }
    if (!data.startMoving) return;
    swiper.allowClick = false;
    if (!params.cssMode && e.cancelable) e.preventDefault();
    if (params.touchMoveStopPropagation && !params.nested) e.stopPropagation();
    let diff = swiper.isHorizontal() ? diffX : diffY;
    let touchesDiff = swiper.isHorizontal() ? touches.currentX - touches.previousX : touches.currentY - touches.previousY;
    if (params.oneWayMovement) {
        diff = Math.abs(diff) * (rtl ? 1 : -1);
        touchesDiff = Math.abs(touchesDiff) * (rtl ? 1 : -1);
    }
    touches.diff = diff;
    diff *= params.touchRatio;
    if (rtl) {
        diff = -diff;
        touchesDiff = -touchesDiff;
    }
    const prevTouchesDirection = swiper.touchesDirection;
    swiper.swipeDirection = diff > 0 ? "prev" : "next";
    swiper.touchesDirection = touchesDiff > 0 ? "prev" : "next";
    const isLoop = swiper.params.loop && !params.cssMode;
    const allowLoopFix = swiper.touchesDirection === "next" && swiper.allowSlideNext || swiper.touchesDirection === "prev" && swiper.allowSlidePrev;
    if (!data.isMoved) {
        if (isLoop && allowLoopFix) swiper.loopFix({
            direction: swiper.swipeDirection
        });
        data.startTranslate = swiper.getTranslate();
        swiper.setTransition(0);
        if (swiper.animating) {
            const evt = new window.CustomEvent("transitionend", {
                bubbles: true,
                cancelable: true
            });
            swiper.wrapperEl.dispatchEvent(evt);
        }
        data.allowMomentumBounce = false;
        // Grab Cursor
        if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(true);
        swiper.emit("sliderFirstMove", e);
    }
    let loopFixed;
    new Date().getTime();
    if (data.isMoved && data.allowThresholdMove && prevTouchesDirection !== swiper.touchesDirection && isLoop && allowLoopFix && Math.abs(diff) >= 1) {
        Object.assign(touches, {
            startX: pageX,
            startY: pageY,
            currentX: pageX,
            currentY: pageY,
            startTranslate: data.currentTranslate
        });
        data.loopSwapReset = true;
        data.startTranslate = data.currentTranslate;
        return;
    }
    swiper.emit("sliderMove", e);
    data.isMoved = true;
    data.currentTranslate = diff + data.startTranslate;
    let disableParentSwiper = true;
    let resistanceRatio = params.resistanceRatio;
    if (params.touchReleaseOnEdges) resistanceRatio = 0;
    if (diff > 0) {
        if (isLoop && allowLoopFix && !loopFixed && data.allowThresholdMove && data.currentTranslate > (params.centeredSlides ? swiper.minTranslate() - swiper.slidesSizesGrid[swiper.activeIndex + 1] : swiper.minTranslate())) swiper.loopFix({
            direction: "prev",
            setTranslate: true,
            activeSlideIndex: 0
        });
        if (data.currentTranslate > swiper.minTranslate()) {
            disableParentSwiper = false;
            if (params.resistance) data.currentTranslate = swiper.minTranslate() - 1 + (-swiper.minTranslate() + data.startTranslate + diff) ** resistanceRatio;
        }
    } else if (diff < 0) {
        if (isLoop && allowLoopFix && !loopFixed && data.allowThresholdMove && data.currentTranslate < (params.centeredSlides ? swiper.maxTranslate() + swiper.slidesSizesGrid[swiper.slidesSizesGrid.length - 1] : swiper.maxTranslate())) swiper.loopFix({
            direction: "next",
            setTranslate: true,
            activeSlideIndex: swiper.slides.length - (params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : Math.ceil(parseFloat(params.slidesPerView, 10)))
        });
        if (data.currentTranslate < swiper.maxTranslate()) {
            disableParentSwiper = false;
            if (params.resistance) data.currentTranslate = swiper.maxTranslate() + 1 - (swiper.maxTranslate() - data.startTranslate - diff) ** resistanceRatio;
        }
    }
    if (disableParentSwiper) e.preventedByNestedSwiper = true;
    // Directions locks
    if (!swiper.allowSlideNext && swiper.swipeDirection === "next" && data.currentTranslate < data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && swiper.swipeDirection === "prev" && data.currentTranslate > data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && !swiper.allowSlideNext) data.currentTranslate = data.startTranslate;
    // Threshold
    if (params.threshold > 0) {
        if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
            if (!data.allowThresholdMove) {
                data.allowThresholdMove = true;
                touches.startX = touches.currentX;
                touches.startY = touches.currentY;
                data.currentTranslate = data.startTranslate;
                touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
                return;
            }
        } else {
            data.currentTranslate = data.startTranslate;
            return;
        }
    }
    if (!params.followFinger || params.cssMode) return;
    // Update active index in free mode
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode || params.watchSlidesProgress) {
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode) swiper.freeMode.onTouchMove();
    // Update progress
    swiper.updateProgress(data.currentTranslate);
    // Update translate
    swiper.setTranslate(data.currentTranslate);
}
function $0d6016762a387e31$var$onTouchEnd(event) {
    const swiper = this;
    const data = swiper.touchEventsData;
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    let targetTouch;
    const isTouchEvent = e.type === "touchend" || e.type === "touchcancel";
    if (!isTouchEvent) {
        if (data.touchId !== null) return; // return from pointer if we use touch
        if (e.pointerId !== data.pointerId) return;
        targetTouch = e;
    } else {
        targetTouch = [
            ...e.changedTouches
        ].filter((t)=>t.identifier === data.touchId)[0];
        if (!targetTouch || targetTouch.identifier !== data.touchId) return;
    }
    if ([
        "pointercancel",
        "pointerout",
        "pointerleave",
        "contextmenu"
    ].includes(e.type)) {
        const proceed = [
            "pointercancel",
            "contextmenu"
        ].includes(e.type) && (swiper.browser.isSafari || swiper.browser.isWebView);
        if (!proceed) return;
    }
    data.pointerId = null;
    data.touchId = null;
    const { params: params, touches: touches, rtlTranslate: rtl, slidesGrid: slidesGrid, enabled: enabled } = swiper;
    if (!enabled) return;
    if (!params.simulateTouch && e.pointerType === "mouse") return;
    if (data.allowTouchCallbacks) swiper.emit("touchEnd", e);
    data.allowTouchCallbacks = false;
    if (!data.isTouched) {
        if (data.isMoved && params.grabCursor) swiper.setGrabCursor(false);
        data.isMoved = false;
        data.startMoving = false;
        return;
    }
    // Return Grab Cursor
    if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(false);
    // Time diff
    const touchEndTime = (0, $95ca904041552da4$export$4368d992c4eafac0)();
    const timeDiff = touchEndTime - data.touchStartTime;
    // Tap, doubleTap, Click
    if (swiper.allowClick) {
        const pathTree = e.path || e.composedPath && e.composedPath();
        swiper.updateClickedSlide(pathTree && pathTree[0] || e.target, pathTree);
        swiper.emit("tap click", e);
        if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) swiper.emit("doubleTap doubleClick", e);
    }
    data.lastClickTime = (0, $95ca904041552da4$export$4368d992c4eafac0)();
    (0, $95ca904041552da4$export$7ccc53e8f1e7dfc5)(()=>{
        if (!swiper.destroyed) swiper.allowClick = true;
    });
    if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 && !data.loopSwapReset || data.currentTranslate === data.startTranslate && !data.loopSwapReset) {
        data.isTouched = false;
        data.isMoved = false;
        data.startMoving = false;
        return;
    }
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    let currentPos;
    if (params.followFinger) currentPos = rtl ? swiper.translate : -swiper.translate;
    else currentPos = -data.currentTranslate;
    if (params.cssMode) return;
    if (params.freeMode && params.freeMode.enabled) {
        swiper.freeMode.onTouchEnd({
            currentPos: currentPos
        });
        return;
    }
    // Find current slide
    const swipeToLast = currentPos >= -swiper.maxTranslate() && !swiper.params.loop;
    let stopIndex = 0;
    let groupSize = swiper.slidesSizesGrid[0];
    for(let i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup){
        const increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
        if (typeof slidesGrid[i + increment] !== "undefined") {
            if (swipeToLast || currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + increment]) {
                stopIndex = i;
                groupSize = slidesGrid[i + increment] - slidesGrid[i];
            }
        } else if (swipeToLast || currentPos >= slidesGrid[i]) {
            stopIndex = i;
            groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
        }
    }
    let rewindFirstIndex = null;
    let rewindLastIndex = null;
    if (params.rewind) {
        if (swiper.isBeginning) rewindLastIndex = params.virtual && params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        else if (swiper.isEnd) rewindFirstIndex = 0;
    }
    // Find current slide size
    const ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
    const increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
    if (timeDiff > params.longSwipesMs) {
        // Long touches
        if (!params.longSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (swiper.swipeDirection === "next") {
            if (ratio >= params.longSwipesRatio) swiper.slideTo(params.rewind && swiper.isEnd ? rewindFirstIndex : stopIndex + increment);
            else swiper.slideTo(stopIndex);
        }
        if (swiper.swipeDirection === "prev") {
            if (ratio > 1 - params.longSwipesRatio) swiper.slideTo(stopIndex + increment);
            else if (rewindLastIndex !== null && ratio < 0 && Math.abs(ratio) > params.longSwipesRatio) swiper.slideTo(rewindLastIndex);
            else swiper.slideTo(stopIndex);
        }
    } else {
        // Short swipes
        if (!params.shortSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        const isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);
        if (!isNavButtonTarget) {
            if (swiper.swipeDirection === "next") swiper.slideTo(rewindFirstIndex !== null ? rewindFirstIndex : stopIndex + increment);
            if (swiper.swipeDirection === "prev") swiper.slideTo(rewindLastIndex !== null ? rewindLastIndex : stopIndex);
        } else if (e.target === swiper.navigation.nextEl) swiper.slideTo(stopIndex + increment);
        else swiper.slideTo(stopIndex);
    }
}
function $0d6016762a387e31$var$onResize() {
    const swiper = this;
    const { params: params, el: el } = swiper;
    if (el && el.offsetWidth === 0) return;
    // Breakpoints
    if (params.breakpoints) swiper.setBreakpoint();
    // Save locks
    const { allowSlideNext: allowSlideNext, allowSlidePrev: allowSlidePrev, snapGrid: snapGrid } = swiper;
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    // Disable locks on resize
    swiper.allowSlideNext = true;
    swiper.allowSlidePrev = true;
    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateSlidesClasses();
    const isVirtualLoop = isVirtual && params.loop;
    if ((params.slidesPerView === "auto" || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides && !isVirtualLoop) swiper.slideTo(swiper.slides.length - 1, 0, false, true);
    else if (swiper.params.loop && !isVirtual) swiper.slideToLoop(swiper.realIndex, 0, false, true);
    else swiper.slideTo(swiper.activeIndex, 0, false, true);
    if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
        clearTimeout(swiper.autoplay.resizeTimeout);
        swiper.autoplay.resizeTimeout = setTimeout(()=>{
            if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) swiper.autoplay.resume();
        }, 500);
    }
    // Return locks after resize
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
}
function $0d6016762a387e31$var$onClick(e) {
    const swiper = this;
    if (!swiper.enabled) return;
    if (!swiper.allowClick) {
        if (swiper.params.preventClicks) e.preventDefault();
        if (swiper.params.preventClicksPropagation && swiper.animating) {
            e.stopPropagation();
            e.stopImmediatePropagation();
        }
    }
}
function $0d6016762a387e31$var$onScroll() {
    const swiper = this;
    const { wrapperEl: wrapperEl, rtlTranslate: rtlTranslate, enabled: enabled } = swiper;
    if (!enabled) return;
    swiper.previousTranslate = swiper.translate;
    if (swiper.isHorizontal()) swiper.translate = -wrapperEl.scrollLeft;
    else swiper.translate = -wrapperEl.scrollTop;
    // eslint-disable-next-line
    if (swiper.translate === 0) swiper.translate = 0;
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== swiper.progress) swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
    swiper.emit("setTranslate", swiper.translate, false);
}
function $0d6016762a387e31$var$onLoad(e) {
    const swiper = this;
    $0d6016762a387e31$var$processLazyPreloader(swiper, e.target);
    if (swiper.params.cssMode || swiper.params.slidesPerView !== "auto" && !swiper.params.autoHeight) return;
    swiper.update();
}
function $0d6016762a387e31$var$onDocumentTouchStart() {
    const swiper = this;
    if (swiper.documentTouchHandlerProceeded) return;
    swiper.documentTouchHandlerProceeded = true;
    if (swiper.params.touchReleaseOnEdges) swiper.el.style.touchAction = "auto";
}
const $0d6016762a387e31$var$events = (swiper, method)=>{
    const document1 = (0, $73cf9966c142bfa0$export$39b482c5e57630a8)();
    const { params: params, el: el, wrapperEl: wrapperEl, device: device } = swiper;
    const capture = !!params.nested;
    const domMethod = method === "on" ? "addEventListener" : "removeEventListener";
    const swiperMethod = method;
    // Touch Events
    document1[domMethod]("touchstart", swiper.onDocumentTouchStart, {
        passive: false,
        capture: capture
    });
    el[domMethod]("touchstart", swiper.onTouchStart, {
        passive: false
    });
    el[domMethod]("pointerdown", swiper.onTouchStart, {
        passive: false
    });
    document1[domMethod]("touchmove", swiper.onTouchMove, {
        passive: false,
        capture: capture
    });
    document1[domMethod]("pointermove", swiper.onTouchMove, {
        passive: false,
        capture: capture
    });
    document1[domMethod]("touchend", swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]("pointerup", swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]("pointercancel", swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]("touchcancel", swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]("pointerout", swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]("pointerleave", swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]("contextmenu", swiper.onTouchEnd, {
        passive: true
    });
    // Prevent Links Clicks
    if (params.preventClicks || params.preventClicksPropagation) el[domMethod]("click", swiper.onClick, true);
    if (params.cssMode) wrapperEl[domMethod]("scroll", swiper.onScroll);
    // Resize handler
    if (params.updateOnWindowResize) swiper[swiperMethod](device.ios || device.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", $0d6016762a387e31$var$onResize, true);
    else swiper[swiperMethod]("observerUpdate", $0d6016762a387e31$var$onResize, true);
    // Images loader
    el[domMethod]("load", swiper.onLoad, {
        capture: true
    });
};
function $0d6016762a387e31$var$attachEvents() {
    const swiper = this;
    const { params: params } = swiper;
    swiper.onTouchStart = $0d6016762a387e31$var$onTouchStart.bind(swiper);
    swiper.onTouchMove = $0d6016762a387e31$var$onTouchMove.bind(swiper);
    swiper.onTouchEnd = $0d6016762a387e31$var$onTouchEnd.bind(swiper);
    swiper.onDocumentTouchStart = $0d6016762a387e31$var$onDocumentTouchStart.bind(swiper);
    if (params.cssMode) swiper.onScroll = $0d6016762a387e31$var$onScroll.bind(swiper);
    swiper.onClick = $0d6016762a387e31$var$onClick.bind(swiper);
    swiper.onLoad = $0d6016762a387e31$var$onLoad.bind(swiper);
    $0d6016762a387e31$var$events(swiper, "on");
}
function $0d6016762a387e31$var$detachEvents() {
    const swiper = this;
    $0d6016762a387e31$var$events(swiper, "off");
}
var $0d6016762a387e31$var$events$1 = {
    attachEvents: $0d6016762a387e31$var$attachEvents,
    detachEvents: $0d6016762a387e31$var$detachEvents
};
const $0d6016762a387e31$var$isGridEnabled = (swiper, params)=>{
    return swiper.grid && params.grid && params.grid.rows > 1;
};
function $0d6016762a387e31$var$setBreakpoint() {
    const swiper = this;
    const { realIndex: realIndex, initialized: initialized, params: params, el: el } = swiper;
    const breakpoints = params.breakpoints;
    if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return;
    // Get breakpoint for window width and update parameters
    const breakpoint = swiper.getBreakpoint(breakpoints, swiper.params.breakpointsBase, swiper.el);
    if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
    const breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
    const breakpointParams = breakpointOnlyParams || swiper.originalParams;
    const wasMultiRow = $0d6016762a387e31$var$isGridEnabled(swiper, params);
    const isMultiRow = $0d6016762a387e31$var$isGridEnabled(swiper, breakpointParams);
    const wasEnabled = params.enabled;
    if (wasMultiRow && !isMultiRow) {
        el.classList.remove(`${params.containerModifierClass}grid`, `${params.containerModifierClass}grid-column`);
        swiper.emitContainerClasses();
    } else if (!wasMultiRow && isMultiRow) {
        el.classList.add(`${params.containerModifierClass}grid`);
        if (breakpointParams.grid.fill && breakpointParams.grid.fill === "column" || !breakpointParams.grid.fill && params.grid.fill === "column") el.classList.add(`${params.containerModifierClass}grid-column`);
        swiper.emitContainerClasses();
    }
    // Toggle navigation, pagination, scrollbar
    [
        "navigation",
        "pagination",
        "scrollbar"
    ].forEach((prop)=>{
        if (typeof breakpointParams[prop] === "undefined") return;
        const wasModuleEnabled = params[prop] && params[prop].enabled;
        const isModuleEnabled = breakpointParams[prop] && breakpointParams[prop].enabled;
        if (wasModuleEnabled && !isModuleEnabled) swiper[prop].disable();
        if (!wasModuleEnabled && isModuleEnabled) swiper[prop].enable();
    });
    const directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
    const needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);
    const wasLoop = params.loop;
    if (directionChanged && initialized) swiper.changeDirection();
    (0, $95ca904041552da4$export$3b14a55fb2447963)(swiper.params, breakpointParams);
    const isEnabled = swiper.params.enabled;
    const hasLoop = swiper.params.loop;
    Object.assign(swiper, {
        allowTouchMove: swiper.params.allowTouchMove,
        allowSlideNext: swiper.params.allowSlideNext,
        allowSlidePrev: swiper.params.allowSlidePrev
    });
    if (wasEnabled && !isEnabled) swiper.disable();
    else if (!wasEnabled && isEnabled) swiper.enable();
    swiper.currentBreakpoint = breakpoint;
    swiper.emit("_beforeBreakpoint", breakpointParams);
    if (initialized) {
        if (needsReLoop) {
            swiper.loopDestroy();
            swiper.loopCreate(realIndex);
            swiper.updateSlides();
        } else if (!wasLoop && hasLoop) {
            swiper.loopCreate(realIndex);
            swiper.updateSlides();
        } else if (wasLoop && !hasLoop) swiper.loopDestroy();
    }
    swiper.emit("breakpoint", breakpointParams);
}
function $0d6016762a387e31$var$getBreakpoint(breakpoints, base, containerEl) {
    if (base === void 0) base = "window";
    if (!breakpoints || base === "container" && !containerEl) return undefined;
    let breakpoint = false;
    const window1 = (0, $73cf9966c142bfa0$export$407448d2b89b1813)();
    const currentHeight = base === "window" ? window1.innerHeight : containerEl.clientHeight;
    const points = Object.keys(breakpoints).map((point)=>{
        if (typeof point === "string" && point.indexOf("@") === 0) {
            const minRatio = parseFloat(point.substr(1));
            const value = currentHeight * minRatio;
            return {
                value: value,
                point: point
            };
        }
        return {
            value: point,
            point: point
        };
    });
    points.sort((a, b)=>parseInt(a.value, 10) - parseInt(b.value, 10));
    for(let i = 0; i < points.length; i += 1){
        const { point: point, value: value } = points[i];
        if (base === "window") {
            if (window1.matchMedia(`(min-width: ${value}px)`).matches) breakpoint = point;
        } else if (value <= containerEl.clientWidth) breakpoint = point;
    }
    return breakpoint || "max";
}
var $0d6016762a387e31$var$breakpoints = {
    setBreakpoint: $0d6016762a387e31$var$setBreakpoint,
    getBreakpoint: $0d6016762a387e31$var$getBreakpoint
};
function $0d6016762a387e31$var$prepareClasses(entries, prefix) {
    const resultClasses = [];
    entries.forEach((item)=>{
        if (typeof item === "object") Object.keys(item).forEach((classNames)=>{
            if (item[classNames]) resultClasses.push(prefix + classNames);
        });
        else if (typeof item === "string") resultClasses.push(prefix + item);
    });
    return resultClasses;
}
function $0d6016762a387e31$var$addClasses() {
    const swiper = this;
    const { classNames: classNames, params: params, rtl: rtl, el: el, device: device } = swiper;
    // prettier-ignore
    const suffixes = $0d6016762a387e31$var$prepareClasses([
        "initialized",
        params.direction,
        {
            "free-mode": swiper.params.freeMode && params.freeMode.enabled
        },
        {
            "autoheight": params.autoHeight
        },
        {
            "rtl": rtl
        },
        {
            "grid": params.grid && params.grid.rows > 1
        },
        {
            "grid-column": params.grid && params.grid.rows > 1 && params.grid.fill === "column"
        },
        {
            "android": device.android
        },
        {
            "ios": device.ios
        },
        {
            "css-mode": params.cssMode
        },
        {
            "centered": params.cssMode && params.centeredSlides
        },
        {
            "watch-progress": params.watchSlidesProgress
        }
    ], params.containerModifierClass);
    classNames.push(...suffixes);
    el.classList.add(...classNames);
    swiper.emitContainerClasses();
}
function $0d6016762a387e31$var$removeClasses() {
    const swiper = this;
    const { el: el, classNames: classNames } = swiper;
    el.classList.remove(...classNames);
    swiper.emitContainerClasses();
}
var $0d6016762a387e31$var$classes = {
    addClasses: $0d6016762a387e31$var$addClasses,
    removeClasses: $0d6016762a387e31$var$removeClasses
};
function $0d6016762a387e31$var$checkOverflow() {
    const swiper = this;
    const { isLocked: wasLocked, params: params } = swiper;
    const { slidesOffsetBefore: slidesOffsetBefore } = params;
    if (slidesOffsetBefore) {
        const lastSlideIndex = swiper.slides.length - 1;
        const lastSlideRightEdge = swiper.slidesGrid[lastSlideIndex] + swiper.slidesSizesGrid[lastSlideIndex] + slidesOffsetBefore * 2;
        swiper.isLocked = swiper.size > lastSlideRightEdge;
    } else swiper.isLocked = swiper.snapGrid.length === 1;
    if (params.allowSlideNext === true) swiper.allowSlideNext = !swiper.isLocked;
    if (params.allowSlidePrev === true) swiper.allowSlidePrev = !swiper.isLocked;
    if (wasLocked && wasLocked !== swiper.isLocked) swiper.isEnd = false;
    if (wasLocked !== swiper.isLocked) swiper.emit(swiper.isLocked ? "lock" : "unlock");
}
var $0d6016762a387e31$var$checkOverflow$1 = {
    checkOverflow: $0d6016762a387e31$var$checkOverflow
};
var $0d6016762a387e31$export$4368d992c4eafac0 = {
    init: true,
    direction: "horizontal",
    oneWayMovement: false,
    swiperElementNodeName: "SWIPER-CONTAINER",
    touchEventsTarget: "wrapper",
    initialSlide: 0,
    speed: 300,
    cssMode: false,
    updateOnWindowResize: true,
    resizeObserver: true,
    nested: false,
    createElements: false,
    eventsPrefix: "swiper",
    enabled: true,
    focusableElements: "input, select, option, textarea, button, video, label",
    // Overrides
    width: null,
    height: null,
    //
    preventInteractionOnTransition: false,
    // ssr
    userAgent: null,
    url: null,
    // To support iOS's swipe-to-go-back gesture (when being used in-app).
    edgeSwipeDetection: false,
    edgeSwipeThreshold: 20,
    // Autoheight
    autoHeight: false,
    // Set wrapper width
    setWrapperSize: false,
    // Virtual Translate
    virtualTranslate: false,
    // Effects
    effect: "slide",
    // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
    // Breakpoints
    breakpoints: undefined,
    breakpointsBase: "window",
    // Slides grid
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerGroup: 1,
    slidesPerGroupSkip: 0,
    slidesPerGroupAuto: false,
    centeredSlides: false,
    centeredSlidesBounds: false,
    slidesOffsetBefore: 0,
    // in px
    slidesOffsetAfter: 0,
    // in px
    normalizeSlideIndex: true,
    centerInsufficientSlides: false,
    // Disable swiper and hide navigation when container not overflow
    watchOverflow: true,
    // Round length
    roundLengths: false,
    // Touches
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: true,
    shortSwipes: true,
    longSwipes: true,
    longSwipesRatio: 0.5,
    longSwipesMs: 300,
    followFinger: true,
    allowTouchMove: true,
    threshold: 5,
    touchMoveStopPropagation: false,
    touchStartPreventDefault: true,
    touchStartForcePreventDefault: false,
    touchReleaseOnEdges: false,
    // Unique Navigation Elements
    uniqueNavElements: true,
    // Resistance
    resistance: true,
    resistanceRatio: 0.85,
    // Progress
    watchSlidesProgress: false,
    // Cursor
    grabCursor: false,
    // Clicks
    preventClicks: true,
    preventClicksPropagation: true,
    slideToClickedSlide: false,
    // loop
    loop: false,
    loopAddBlankSlides: true,
    loopAdditionalSlides: 0,
    loopPreventsSliding: true,
    // rewind
    rewind: false,
    // Swiping/no swiping
    allowSlidePrev: true,
    allowSlideNext: true,
    swipeHandler: null,
    // '.swipe-handler',
    noSwiping: true,
    noSwipingClass: "swiper-no-swiping",
    noSwipingSelector: null,
    // Passive Listeners
    passiveListeners: true,
    maxBackfaceHiddenSlides: 10,
    // NS
    containerModifierClass: "swiper-",
    // NEW
    slideClass: "swiper-slide",
    slideBlankClass: "swiper-slide-blank",
    slideActiveClass: "swiper-slide-active",
    slideVisibleClass: "swiper-slide-visible",
    slideFullyVisibleClass: "swiper-slide-fully-visible",
    slideNextClass: "swiper-slide-next",
    slidePrevClass: "swiper-slide-prev",
    wrapperClass: "swiper-wrapper",
    lazyPreloaderClass: "swiper-lazy-preloader",
    lazyPreloadPrevNext: 0,
    // Callbacks
    runCallbacksOnInit: true,
    // Internals
    _emitClasses: false
};
function $0d6016762a387e31$var$moduleExtendParams(params, allModulesParams) {
    return function extendParams(obj) {
        if (obj === void 0) obj = {};
        const moduleParamName = Object.keys(obj)[0];
        const moduleParams = obj[moduleParamName];
        if (typeof moduleParams !== "object" || moduleParams === null) {
            (0, $95ca904041552da4$export$3b14a55fb2447963)(allModulesParams, obj);
            return;
        }
        if (params[moduleParamName] === true) params[moduleParamName] = {
            enabled: true
        };
        if (moduleParamName === "navigation" && params[moduleParamName] && params[moduleParamName].enabled && !params[moduleParamName].prevEl && !params[moduleParamName].nextEl) params[moduleParamName].auto = true;
        if ([
            "pagination",
            "scrollbar"
        ].indexOf(moduleParamName) >= 0 && params[moduleParamName] && params[moduleParamName].enabled && !params[moduleParamName].el) params[moduleParamName].auto = true;
        if (!(moduleParamName in params && "enabled" in moduleParams)) {
            (0, $95ca904041552da4$export$3b14a55fb2447963)(allModulesParams, obj);
            return;
        }
        if (typeof params[moduleParamName] === "object" && !("enabled" in params[moduleParamName])) params[moduleParamName].enabled = true;
        if (!params[moduleParamName]) params[moduleParamName] = {
            enabled: false
        };
        (0, $95ca904041552da4$export$3b14a55fb2447963)(allModulesParams, obj);
    };
}
/* eslint no-param-reassign: "off" */ const $0d6016762a387e31$var$prototypes = {
    eventsEmitter: $0d6016762a387e31$var$eventsEmitter,
    update: $0d6016762a387e31$var$update,
    translate: $0d6016762a387e31$var$translate,
    transition: $0d6016762a387e31$var$transition,
    slide: $0d6016762a387e31$var$slide,
    loop: $0d6016762a387e31$var$loop,
    grabCursor: $0d6016762a387e31$var$grabCursor,
    events: $0d6016762a387e31$var$events$1,
    breakpoints: $0d6016762a387e31$var$breakpoints,
    checkOverflow: $0d6016762a387e31$var$checkOverflow$1,
    classes: $0d6016762a387e31$var$classes
};
const $0d6016762a387e31$var$extendedDefaults = {};
class $0d6016762a387e31$export$25ce5a424b770e84 {
    constructor(){
        let el;
        let params;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === "Object") params = args[0];
        else [el, params] = args;
        if (!params) params = {};
        params = (0, $95ca904041552da4$export$3b14a55fb2447963)({}, params);
        if (el && !params.el) params.el = el;
        const document1 = (0, $73cf9966c142bfa0$export$39b482c5e57630a8)();
        if (params.el && typeof params.el === "string" && document1.querySelectorAll(params.el).length > 1) {
            const swipers = [];
            document1.querySelectorAll(params.el).forEach((containerEl)=>{
                const newParams = (0, $95ca904041552da4$export$3b14a55fb2447963)({}, params, {
                    el: containerEl
                });
                swipers.push(new $0d6016762a387e31$export$25ce5a424b770e84(newParams));
            });
            // eslint-disable-next-line no-constructor-return
            return swipers;
        }
        // Swiper Instance
        const swiper = this;
        swiper.__swiper__ = true;
        swiper.support = $0d6016762a387e31$var$getSupport();
        swiper.device = $0d6016762a387e31$var$getDevice({
            userAgent: params.userAgent
        });
        swiper.browser = $0d6016762a387e31$var$getBrowser();
        swiper.eventsListeners = {};
        swiper.eventsAnyListeners = [];
        swiper.modules = [
            ...swiper.__modules__
        ];
        if (params.modules && Array.isArray(params.modules)) swiper.modules.push(...params.modules);
        const allModulesParams = {};
        swiper.modules.forEach((mod)=>{
            mod({
                params: params,
                swiper: swiper,
                extendParams: $0d6016762a387e31$var$moduleExtendParams(params, allModulesParams),
                on: swiper.on.bind(swiper),
                once: swiper.once.bind(swiper),
                off: swiper.off.bind(swiper),
                emit: swiper.emit.bind(swiper)
            });
        });
        // Extend defaults with modules params
        const swiperParams = (0, $95ca904041552da4$export$3b14a55fb2447963)({}, $0d6016762a387e31$export$4368d992c4eafac0, allModulesParams);
        // Extend defaults with passed params
        swiper.params = (0, $95ca904041552da4$export$3b14a55fb2447963)({}, swiperParams, $0d6016762a387e31$var$extendedDefaults, params);
        swiper.originalParams = (0, $95ca904041552da4$export$3b14a55fb2447963)({}, swiper.params);
        swiper.passedParams = (0, $95ca904041552da4$export$3b14a55fb2447963)({}, params);
        // add event listeners
        if (swiper.params && swiper.params.on) Object.keys(swiper.params.on).forEach((eventName)=>{
            swiper.on(eventName, swiper.params.on[eventName]);
        });
        if (swiper.params && swiper.params.onAny) swiper.onAny(swiper.params.onAny);
        // Extend Swiper
        Object.assign(swiper, {
            enabled: swiper.params.enabled,
            el: el,
            // Classes
            classNames: [],
            // Slides
            slides: [],
            slidesGrid: [],
            snapGrid: [],
            slidesSizesGrid: [],
            // isDirection
            isHorizontal () {
                return swiper.params.direction === "horizontal";
            },
            isVertical () {
                return swiper.params.direction === "vertical";
            },
            // Indexes
            activeIndex: 0,
            realIndex: 0,
            //
            isBeginning: true,
            isEnd: false,
            // Props
            translate: 0,
            previousTranslate: 0,
            progress: 0,
            velocity: 0,
            animating: false,
            cssOverflowAdjustment () {
                // Returns 0 unless `translate` is > 2**23
                // Should be subtracted from css values to prevent overflow
                return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
            },
            // Locks
            allowSlideNext: swiper.params.allowSlideNext,
            allowSlidePrev: swiper.params.allowSlidePrev,
            // Touch Events
            touchEventsData: {
                isTouched: undefined,
                isMoved: undefined,
                allowTouchCallbacks: undefined,
                touchStartTime: undefined,
                isScrolling: undefined,
                currentTranslate: undefined,
                startTranslate: undefined,
                allowThresholdMove: undefined,
                // Form elements to match
                focusableElements: swiper.params.focusableElements,
                // Last click time
                lastClickTime: 0,
                clickTimeout: undefined,
                // Velocities
                velocities: [],
                allowMomentumBounce: undefined,
                startMoving: undefined,
                pointerId: null,
                touchId: null
            },
            // Clicks
            allowClick: true,
            // Touches
            allowTouchMove: swiper.params.allowTouchMove,
            touches: {
                startX: 0,
                startY: 0,
                currentX: 0,
                currentY: 0,
                diff: 0
            },
            // Images
            imagesToLoad: [],
            imagesLoaded: 0
        });
        swiper.emit("_swiper");
        // Init
        if (swiper.params.init) swiper.init();
        // Return app instance
        // eslint-disable-next-line no-constructor-return
        return swiper;
    }
    getDirectionLabel(property) {
        if (this.isHorizontal()) return property;
        // prettier-ignore
        return ({
            "width": "height",
            "margin-top": "margin-left",
            "margin-bottom ": "margin-right",
            "margin-left": "margin-top",
            "margin-right": "margin-bottom",
            "padding-left": "padding-top",
            "padding-right": "padding-bottom",
            "marginRight": "marginBottom"
        })[property];
    }
    getSlideIndex(slideEl) {
        const { slidesEl: slidesEl, params: params } = this;
        const slides = (0, $95ca904041552da4$export$f1e1789686576879)(slidesEl, `.${params.slideClass}, swiper-slide`);
        const firstSlideIndex = (0, $95ca904041552da4$export$39b482c5e57630a8)(slides[0]);
        return (0, $95ca904041552da4$export$39b482c5e57630a8)(slideEl) - firstSlideIndex;
    }
    getSlideIndexByData(index) {
        return this.getSlideIndex(this.slides.filter((slideEl)=>slideEl.getAttribute("data-swiper-slide-index") * 1 === index)[0]);
    }
    recalcSlides() {
        const swiper = this;
        const { slidesEl: slidesEl, params: params } = swiper;
        swiper.slides = (0, $95ca904041552da4$export$f1e1789686576879)(slidesEl, `.${params.slideClass}, swiper-slide`);
    }
    enable() {
        const swiper = this;
        if (swiper.enabled) return;
        swiper.enabled = true;
        if (swiper.params.grabCursor) swiper.setGrabCursor();
        swiper.emit("enable");
    }
    disable() {
        const swiper = this;
        if (!swiper.enabled) return;
        swiper.enabled = false;
        if (swiper.params.grabCursor) swiper.unsetGrabCursor();
        swiper.emit("disable");
    }
    setProgress(progress, speed) {
        const swiper = this;
        progress = Math.min(Math.max(progress, 0), 1);
        const min = swiper.minTranslate();
        const max = swiper.maxTranslate();
        const current = (max - min) * progress + min;
        swiper.translateTo(current, typeof speed === "undefined" ? 0 : speed);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    emitContainerClasses() {
        const swiper = this;
        if (!swiper.params._emitClasses || !swiper.el) return;
        const cls = swiper.el.className.split(" ").filter((className)=>{
            return className.indexOf("swiper") === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
        });
        swiper.emit("_containerClasses", cls.join(" "));
    }
    getSlideClasses(slideEl) {
        const swiper = this;
        if (swiper.destroyed) return "";
        return slideEl.className.split(" ").filter((className)=>{
            return className.indexOf("swiper-slide") === 0 || className.indexOf(swiper.params.slideClass) === 0;
        }).join(" ");
    }
    emitSlidesClasses() {
        const swiper = this;
        if (!swiper.params._emitClasses || !swiper.el) return;
        const updates = [];
        swiper.slides.forEach((slideEl)=>{
            const classNames = swiper.getSlideClasses(slideEl);
            updates.push({
                slideEl: slideEl,
                classNames: classNames
            });
            swiper.emit("_slideClass", slideEl, classNames);
        });
        swiper.emit("_slideClasses", updates);
    }
    slidesPerViewDynamic(view, exact) {
        if (view === void 0) view = "current";
        if (exact === void 0) exact = false;
        const swiper = this;
        const { params: params, slides: slides, slidesGrid: slidesGrid, slidesSizesGrid: slidesSizesGrid, size: swiperSize, activeIndex: activeIndex } = swiper;
        let spv = 1;
        if (typeof params.slidesPerView === "number") return params.slidesPerView;
        if (params.centeredSlides) {
            let slideSize = slides[activeIndex] ? Math.ceil(slides[activeIndex].swiperSlideSize) : 0;
            let breakLoop;
            for(let i = activeIndex + 1; i < slides.length; i += 1)if (slides[i] && !breakLoop) {
                slideSize += Math.ceil(slides[i].swiperSlideSize);
                spv += 1;
                if (slideSize > swiperSize) breakLoop = true;
            }
            for(let i = activeIndex - 1; i >= 0; i -= 1)if (slides[i] && !breakLoop) {
                slideSize += slides[i].swiperSlideSize;
                spv += 1;
                if (slideSize > swiperSize) breakLoop = true;
            }
        } else {
            // eslint-disable-next-line
            if (view === "current") for(let i = activeIndex + 1; i < slides.length; i += 1){
                const slideInView = exact ? slidesGrid[i] + slidesSizesGrid[i] - slidesGrid[activeIndex] < swiperSize : slidesGrid[i] - slidesGrid[activeIndex] < swiperSize;
                if (slideInView) spv += 1;
            }
            else // previous
            for(let i = activeIndex - 1; i >= 0; i -= 1){
                const slideInView = slidesGrid[activeIndex] - slidesGrid[i] < swiperSize;
                if (slideInView) spv += 1;
            }
        }
        return spv;
    }
    update() {
        const swiper = this;
        if (!swiper || swiper.destroyed) return;
        const { snapGrid: snapGrid, params: params } = swiper;
        // Breakpoints
        if (params.breakpoints) swiper.setBreakpoint();
        [
            ...swiper.el.querySelectorAll('[loading="lazy"]')
        ].forEach((imageEl)=>{
            if (imageEl.complete) $0d6016762a387e31$var$processLazyPreloader(swiper, imageEl);
        });
        swiper.updateSize();
        swiper.updateSlides();
        swiper.updateProgress();
        swiper.updateSlidesClasses();
        function setTranslate() {
            const translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
            const newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
            swiper.setTranslate(newTranslate);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
        let translated;
        if (params.freeMode && params.freeMode.enabled && !params.cssMode) {
            setTranslate();
            if (params.autoHeight) swiper.updateAutoHeight();
        } else {
            if ((params.slidesPerView === "auto" || params.slidesPerView > 1) && swiper.isEnd && !params.centeredSlides) {
                const slides = swiper.virtual && params.virtual.enabled ? swiper.virtual.slides : swiper.slides;
                translated = swiper.slideTo(slides.length - 1, 0, false, true);
            } else translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
            if (!translated) setTranslate();
        }
        if (params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
        swiper.emit("update");
    }
    changeDirection(newDirection, needUpdate) {
        if (needUpdate === void 0) needUpdate = true;
        const swiper = this;
        const currentDirection = swiper.params.direction;
        if (!newDirection) // eslint-disable-next-line
        newDirection = currentDirection === "horizontal" ? "vertical" : "horizontal";
        if (newDirection === currentDirection || newDirection !== "horizontal" && newDirection !== "vertical") return swiper;
        swiper.el.classList.remove(`${swiper.params.containerModifierClass}${currentDirection}`);
        swiper.el.classList.add(`${swiper.params.containerModifierClass}${newDirection}`);
        swiper.emitContainerClasses();
        swiper.params.direction = newDirection;
        swiper.slides.forEach((slideEl)=>{
            if (newDirection === "vertical") slideEl.style.width = "";
            else slideEl.style.height = "";
        });
        swiper.emit("changeDirection");
        if (needUpdate) swiper.update();
        return swiper;
    }
    changeLanguageDirection(direction) {
        const swiper = this;
        if (swiper.rtl && direction === "rtl" || !swiper.rtl && direction === "ltr") return;
        swiper.rtl = direction === "rtl";
        swiper.rtlTranslate = swiper.params.direction === "horizontal" && swiper.rtl;
        if (swiper.rtl) {
            swiper.el.classList.add(`${swiper.params.containerModifierClass}rtl`);
            swiper.el.dir = "rtl";
        } else {
            swiper.el.classList.remove(`${swiper.params.containerModifierClass}rtl`);
            swiper.el.dir = "ltr";
        }
        swiper.update();
    }
    mount(element) {
        const swiper = this;
        if (swiper.mounted) return true;
        // Find el
        let el = element || swiper.params.el;
        if (typeof el === "string") el = document.querySelector(el);
        if (!el) return false;
        el.swiper = swiper;
        if (el.parentNode && el.parentNode.host && el.parentNode.host.nodeName === swiper.params.swiperElementNodeName.toUpperCase()) swiper.isElement = true;
        const getWrapperSelector = ()=>{
            return `.${(swiper.params.wrapperClass || "").trim().split(" ").join(".")}`;
        };
        const getWrapper = ()=>{
            if (el && el.shadowRoot && el.shadowRoot.querySelector) {
                const res = el.shadowRoot.querySelector(getWrapperSelector());
                // Children needs to return slot items
                return res;
            }
            return (0, $95ca904041552da4$export$f1e1789686576879)(el, getWrapperSelector())[0];
        };
        // Find Wrapper
        let wrapperEl = getWrapper();
        if (!wrapperEl && swiper.params.createElements) {
            wrapperEl = (0, $95ca904041552da4$export$db3b6bfb95261072)("div", swiper.params.wrapperClass);
            el.append(wrapperEl);
            (0, $95ca904041552da4$export$f1e1789686576879)(el, `.${swiper.params.slideClass}`).forEach((slideEl)=>{
                wrapperEl.append(slideEl);
            });
        }
        Object.assign(swiper, {
            el: el,
            wrapperEl: wrapperEl,
            slidesEl: swiper.isElement && !el.parentNode.host.slideSlots ? el.parentNode.host : wrapperEl,
            hostEl: swiper.isElement ? el.parentNode.host : el,
            mounted: true,
            // RTL
            rtl: el.dir.toLowerCase() === "rtl" || (0, $95ca904041552da4$export$ae1af26003f05816)(el, "direction") === "rtl",
            rtlTranslate: swiper.params.direction === "horizontal" && (el.dir.toLowerCase() === "rtl" || (0, $95ca904041552da4$export$ae1af26003f05816)(el, "direction") === "rtl"),
            wrongRTL: (0, $95ca904041552da4$export$ae1af26003f05816)(wrapperEl, "display") === "-webkit-box"
        });
        return true;
    }
    init(el) {
        const swiper = this;
        if (swiper.initialized) return swiper;
        const mounted = swiper.mount(el);
        if (mounted === false) return swiper;
        swiper.emit("beforeInit");
        // Set breakpoint
        if (swiper.params.breakpoints) swiper.setBreakpoint();
        // Add Classes
        swiper.addClasses();
        // Update size
        swiper.updateSize();
        // Update slides
        swiper.updateSlides();
        if (swiper.params.watchOverflow) swiper.checkOverflow();
        // Set Grab Cursor
        if (swiper.params.grabCursor && swiper.enabled) swiper.setGrabCursor();
        // Slide To Initial Slide
        if (swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) swiper.slideTo(swiper.params.initialSlide + swiper.virtual.slidesBefore, 0, swiper.params.runCallbacksOnInit, false, true);
        else swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
        // Create loop
        if (swiper.params.loop) swiper.loopCreate();
        // Attach events
        swiper.attachEvents();
        const lazyElements = [
            ...swiper.el.querySelectorAll('[loading="lazy"]')
        ];
        if (swiper.isElement) lazyElements.push(...swiper.hostEl.querySelectorAll('[loading="lazy"]'));
        lazyElements.forEach((imageEl)=>{
            if (imageEl.complete) $0d6016762a387e31$var$processLazyPreloader(swiper, imageEl);
            else imageEl.addEventListener("load", (e)=>{
                $0d6016762a387e31$var$processLazyPreloader(swiper, e.target);
            });
        });
        $0d6016762a387e31$var$preload(swiper);
        // Init Flag
        swiper.initialized = true;
        $0d6016762a387e31$var$preload(swiper);
        // Emit
        swiper.emit("init");
        swiper.emit("afterInit");
        return swiper;
    }
    destroy(deleteInstance, cleanStyles) {
        if (deleteInstance === void 0) deleteInstance = true;
        if (cleanStyles === void 0) cleanStyles = true;
        const swiper = this;
        const { params: params, el: el, wrapperEl: wrapperEl, slides: slides } = swiper;
        if (typeof swiper.params === "undefined" || swiper.destroyed) return null;
        swiper.emit("beforeDestroy");
        // Init Flag
        swiper.initialized = false;
        // Detach events
        swiper.detachEvents();
        // Destroy loop
        if (params.loop) swiper.loopDestroy();
        // Cleanup styles
        if (cleanStyles) {
            swiper.removeClasses();
            el.removeAttribute("style");
            wrapperEl.removeAttribute("style");
            if (slides && slides.length) slides.forEach((slideEl)=>{
                slideEl.classList.remove(params.slideVisibleClass, params.slideFullyVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass);
                slideEl.removeAttribute("style");
                slideEl.removeAttribute("data-swiper-slide-index");
            });
        }
        swiper.emit("destroy");
        // Detach emitter events
        Object.keys(swiper.eventsListeners).forEach((eventName)=>{
            swiper.off(eventName);
        });
        if (deleteInstance !== false) {
            swiper.el.swiper = null;
            (0, $95ca904041552da4$export$90a7f3efeed30595)(swiper);
        }
        swiper.destroyed = true;
        return null;
    }
    static extendDefaults(newDefaults) {
        (0, $95ca904041552da4$export$3b14a55fb2447963)($0d6016762a387e31$var$extendedDefaults, newDefaults);
    }
    static get extendedDefaults() {
        return $0d6016762a387e31$var$extendedDefaults;
    }
    static get defaults() {
        return $0d6016762a387e31$export$4368d992c4eafac0;
    }
    static installModule(mod) {
        if (!$0d6016762a387e31$export$25ce5a424b770e84.prototype.__modules__) $0d6016762a387e31$export$25ce5a424b770e84.prototype.__modules__ = [];
        const modules = $0d6016762a387e31$export$25ce5a424b770e84.prototype.__modules__;
        if (typeof mod === "function" && modules.indexOf(mod) < 0) modules.push(mod);
    }
    static use(module) {
        if (Array.isArray(module)) {
            module.forEach((m)=>$0d6016762a387e31$export$25ce5a424b770e84.installModule(m));
            return $0d6016762a387e31$export$25ce5a424b770e84;
        }
        $0d6016762a387e31$export$25ce5a424b770e84.installModule(module);
        return $0d6016762a387e31$export$25ce5a424b770e84;
    }
}
Object.keys($0d6016762a387e31$var$prototypes).forEach((prototypeGroup)=>{
    Object.keys($0d6016762a387e31$var$prototypes[prototypeGroup]).forEach((protoMethod)=>{
        $0d6016762a387e31$export$25ce5a424b770e84.prototype[protoMethod] = $0d6016762a387e31$var$prototypes[prototypeGroup][protoMethod];
    });
});
$0d6016762a387e31$export$25ce5a424b770e84.use([
    $0d6016762a387e31$var$Resize,
    $0d6016762a387e31$var$Observer
]);




(0, $a7539de1d140ddd7$export$2e2bcd8739ae039)(()=>{
    (0, $3c3eaba7ed460a04$export$b61d4be8ddba9539)();
    (0, $844a571b0bb01553$export$d8cf031a7c97f17b)();
    (0, $f111f945f972b324$export$2e2bcd8739ae039).start();
});
document.addEventListener("DOMContentLoaded", function() {
    // insert typescript code here
    const submenus = document.querySelectorAll(".menu-item.parent.menu-item-has-children");
    submenus.forEach((el)=>{
        let submenuEl = el.lastElementChild;
        console.log(submenuEl);
        (0, $55c7f2385d3e922b$export$8f7491d57c8f97a9)(el, submenuEl, {
            placement: "bottom-start"
        });
    });
    const downloadBox = document.querySelectorAll(".c-img-downloadbox");
    downloadBox.forEach((element)=>{
        element.addEventListener("click", (event)=>{
            console.log(event);
            if (event.target instanceof HTMLElement) {
                event.target.classList.toggle("open");
                let set = event.target.dataset;
                if (set.state == "open") set.state = "closed";
                else set.state = "open";
            }
        });
    });
    var slider = new (0, $0d6016762a387e31$export$25ce5a424b770e84)(".js-slider", {
        loop: true,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
        },
        pagination: {
            el: ".swiper-pagination"
        }
    });
});

})();
//# sourceMappingURL=index.js.map
